// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { accountsApiDiscoveryGetAuthenticationMethods, accountsApiLegacyGoogleLogin, accountsApiLegacyLogout, accountsApiOtpRequest, accountsApiOtpVerify, accountsApiProfileGetCurrentUser, accountsApiSessionsRefresh, accountsApiSessionsSessionLogout, accountsApiSsoExchange, categoriesApiCategoryStats, categoriesApiCreateCategory, categoriesApiDeleteCategory, categoriesApiGetCategory, categoriesApiListCategories, categoriesApiUpdateCategory, complianceApiBulkCompleteProductActions, complianceApiCompleteProductAction, complianceApiGetActionItems, complianceApiGetPogCategoryRate, complianceApiGetProductActionsPostResetPhotoState, complianceApiListPogCategoryRates, complianceApiListPogStoreRates, complianceApiListProductActions, complianceApiUpdateProductAction, coreHealthcheckApiHealthCheck, employeesApiCreateEmployee, employeesApiDeleteEmployee, employeesApiEmployeeStats, employeesApiGetEmployee, employeesApiListEmployeeRoles, employeesApiListEmployees, employeesApiListEmploymentTypes, employeesApiUpdateEmployee, ingestionApiConnectionsConnectionStats, ingestionApiConnectionsCreateConnection, ingestionApiConnectionsDeleteConnection, ingestionApiConnectionsGetConnection, ingestionApiConnectionsListConnections, ingestionApiConnectionsSyncConnection, ingestionApiConnectionsTestConnection, ingestionApiConnectionsUpdateConnection, ingestionApiImportsApproveImport, ingestionApiImportsCreateImport, ingestionApiImportsDownloadImportErrorsCsv, ingestionApiImportsGetImport, ingestionApiImportsListImportErrors, ingestionApiImportsListImports, mappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignment, mappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStats, mappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignment, mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignments, mappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignment, mappingsApiStoreCategoriesCreateStoreCategory, mappingsApiStoreCategoriesDeleteStoreCategory, mappingsApiStoreCategoriesGetStoreCategory, mappingsApiStoreCategoriesListStoreCategories, mappingsApiStoreCategoriesStoreCategoryStats, mappingsApiStoreCategoriesUpdateStoreCategory, mappingsApiStorePlanogramsCreateStorePlanogram, mappingsApiStorePlanogramsDeleteStorePlanogram, mappingsApiStorePlanogramsGetStorePlanogram, mappingsApiStorePlanogramsListStorePlanogramGroups, mappingsApiStorePlanogramsListStorePlanograms, mappingsApiStorePlanogramsStorePlanogramGroupStats, mappingsApiStorePlanogramsStorePlanogramStats, mappingsApiStorePlanogramsUpdateStorePlanogram, mappingsApiStoreProductsCreateStoreProduct, mappingsApiStoreProductsDeleteStoreProduct, mappingsApiStoreProductsGetStoreProduct, mappingsApiStoreProductsListStoreProducts, mappingsApiStoreProductsStoreProductStats, mappingsApiStoreProductsUpdateStoreProduct, mappingsApiWorkingGroupsCreateWorkingGroup, mappingsApiWorkingGroupsGetWorkingGroup, mappingsApiWorkingGroupsListWorkingGroups, mappingsApiWorkingGroupsUpdateWorkingGroup, mappingsApiWorkingGroupsWorkingGroupStats, mobileApiCompleteWorkItemTask, mobileApiGetCompletionSummary, mobileApiListWorkItemBays, mobileApiStartWorkItemTask, mobileApiStartWorkOrderNiciTask, mobileApiStartWorkOrderVisit, mobileApiStopWorkOrderNiciTask, mobileApiSubmitWorkOrderNiciScan, mobileApiValidateWorkOrderLocation, type Options, planningApiNiciCreateNici, planningApiNiciDeleteNici, planningApiNiciGetNici, planningApiNiciListNici, planningApiNiciNiciStats, planningApiNiciUpdateNici, planningApiResetCalendarCreateResetCycle, planningApiResetCalendarDeleteResetCycle, planningApiResetCalendarGetResetCycle, planningApiResetCalendarListResetCycles, planningApiResetCalendarResetCycleStats, planningApiResetCalendarUpdateResetCycle, planogramsApiPlanogramsCreatePlanogram, planogramsApiPlanogramsDeletePlanogram, planogramsApiPlanogramsGetPlanogram, planogramsApiPlanogramsGetPlanogramDetails, planogramsApiPlanogramsListPlanograms, planogramsApiPlanogramsPlanogramStats, planogramsApiPlanogramsUpdatePlanogram, planogramsApiPositionsListPlanogramPositions, planogramsApiVersionsGetVersion, planogramsApiVersionsListVersions, planogramsApiVersionsPublish, planogramsApiVersionsStoreReach, planogramsApiVisualizationGetVisualization, productsProductsApiCreateProduct, productsProductsApiDeleteProduct, productsProductsApiDeleteProductImage, productsProductsApiGetProduct, productsProductsApiListBrands, productsProductsApiListProducts, productsProductsApiProductStats, productsProductsApiSetPrimaryProductImage, productsProductsApiUpdateProduct, productsProductsApiUploadProductImage, projectsApiEditEditAnalyze, projectsApiEditEditAssignTeams, projectsApiEditEditCancel, projectsApiEditEditCommit, projectsApiEditEditCostEstimate, projectsApiEditEditInit, projectsApiEditEditResume, projectsApiEditEditSaveDraft, projectsApiEditEditSchedule, projectsApiFieldworkGetVisitAssignment, projectsApiFieldworkListAssignedStores, projectsApiFieldworkListVisitAssignments, projectsApiFieldworkListWorkItems, projectsApiFieldworkUpdateVisit, projectsApiFieldworkUpdateVisitAssignment, projectsApiMissionControlDashboardSummary, projectsApiMissionControlListAlerts, projectsApiMissionControlListEscalations, projectsApiMissionControlListWorkOrders, projectsApiMissionControlResolveEscalation, projectsApiNiciResolutionsCreateNiciResolution, projectsApiNiciScansListNiciScans, projectsApiNiciTrackingListNiciItems, projectsApiNiciTrackingListNiciStores, projectsApiNiciTrackingNiciItemRollout, projectsApiNiciTrackingNiciProjectSummary, projectsApiProjectsApplyBackroomNewItemCollectionAction, projectsApiProjectsCreateExceptionEvent, projectsApiProjectsCreateFieldPhoto, projectsApiProjectsCreateProject, projectsApiProjectsDeleteProject, projectsApiProjectsGetBackroomNewItemRequirements, projectsApiProjectsGetProject, projectsApiProjectsListCycles, projectsApiProjectsListExceptionEventTypes, projectsApiProjectsListFieldPhotos, projectsApiProjectsListProjects, projectsApiProjectsListWorkOrderWorkItems, projectsApiProjectsTransitionProject, projectsApiProjectsUpdateProject, projectsApiProjectsUpdateWorkItem, projectsApiTimeEntriesListTimeEntries, projectsApiTimesheetsGetBreakForm, projectsApiTimesheetsGetTimesheet, projectsApiTimesheetsListTimesheets, projectsApiTimesheetsUpdateTimesheet, projectsApiWizardWizardAnalyze, projectsApiWizardWizardAnalyzeV2, projectsApiWizardWizardApprove, projectsApiWizardWizardAssignTeamsV2, projectsApiWizardWizardCostEstimate, projectsApiWizardWizardCreate, projectsApiWizardWizardInit, projectsApiWizardWizardOptions, projectsApiWizardWizardParseDescription, projectsApiWizardWizardParseVoice, projectsApiWizardWizardProjectTypes, projectsApiWizardWizardRefresh, projectsApiWizardWizardResume, projectsApiWizardWizardSaveDraft, projectsApiWizardWizardScheduleApply, projectsApiWizardWizardScheduleV2, projectsApiWizardWizardTranscribe, rulesApiCreateRule, rulesApiDeleteRule, rulesApiGetRule, rulesApiListRules, rulesApiRuleStats, rulesApiUpdateRule, storageApiLocalFsUpload, storageApiRequestUpload, storesApiCreateStore, storesApiDeleteStore, storesApiGetStore, storesApiListBanners, storesApiListRegions, storesApiListSegments, storesApiListStates, storesApiListStoreFormats, storesApiListStoreGroups, storesApiListStores, storesApiListStoreTypes, storesApiStoreStats, storesApiUpdateStore, supervisorApiCreateChat, supervisorApiListChats, supervisorApiListMessages, supervisorApiSendMessage, suppliersApiListSuppliers } from '../sdk.gen';
import type { AccountsApiDiscoveryGetAuthenticationMethodsData, AccountsApiDiscoveryGetAuthenticationMethodsError, AccountsApiDiscoveryGetAuthenticationMethodsResponse, AccountsApiLegacyGoogleLoginData, AccountsApiLegacyGoogleLoginError, AccountsApiLegacyGoogleLoginResponse, AccountsApiLegacyLogoutData, AccountsApiLegacyLogoutResponse, AccountsApiOtpRequestData, AccountsApiOtpRequestError, AccountsApiOtpRequestResponse, AccountsApiOtpVerifyData, AccountsApiOtpVerifyError, AccountsApiOtpVerifyResponse, AccountsApiProfileGetCurrentUserData, AccountsApiProfileGetCurrentUserError, AccountsApiProfileGetCurrentUserResponse, AccountsApiSessionsRefreshData, AccountsApiSessionsRefreshError, AccountsApiSessionsRefreshResponse, AccountsApiSessionsSessionLogoutData, AccountsApiSessionsSessionLogoutError, AccountsApiSessionsSessionLogoutResponse, AccountsApiSsoExchangeData, AccountsApiSsoExchangeError, AccountsApiSsoExchangeResponse, CategoriesApiCategoryStatsData, CategoriesApiCategoryStatsResponse, CategoriesApiCreateCategoryData, CategoriesApiCreateCategoryError, CategoriesApiCreateCategoryResponse, CategoriesApiDeleteCategoryData, CategoriesApiDeleteCategoryError, CategoriesApiDeleteCategoryResponse, CategoriesApiGetCategoryData, CategoriesApiGetCategoryResponse, CategoriesApiListCategoriesData, CategoriesApiListCategoriesResponse, CategoriesApiUpdateCategoryData, CategoriesApiUpdateCategoryError, CategoriesApiUpdateCategoryResponse, ComplianceApiBulkCompleteProductActionsData, ComplianceApiBulkCompleteProductActionsError, ComplianceApiBulkCompleteProductActionsResponse, ComplianceApiCompleteProductActionData, ComplianceApiCompleteProductActionError, ComplianceApiCompleteProductActionResponse, ComplianceApiGetActionItemsData, ComplianceApiGetActionItemsResponse, ComplianceApiGetPogCategoryRateData, ComplianceApiGetPogCategoryRateResponse, ComplianceApiGetProductActionsPostResetPhotoStateData, ComplianceApiGetProductActionsPostResetPhotoStateError, ComplianceApiGetProductActionsPostResetPhotoStateResponse, ComplianceApiListPogCategoryRatesData, ComplianceApiListPogCategoryRatesResponse, ComplianceApiListPogStoreRatesData, ComplianceApiListPogStoreRatesResponse, ComplianceApiListProductActionsData, ComplianceApiListProductActionsError, ComplianceApiListProductActionsResponse, ComplianceApiUpdateProductActionData, ComplianceApiUpdateProductActionError, ComplianceApiUpdateProductActionResponse, CoreHealthcheckApiHealthCheckData, EmployeesApiCreateEmployeeData, EmployeesApiCreateEmployeeError, EmployeesApiCreateEmployeeResponse, EmployeesApiDeleteEmployeeData, EmployeesApiDeleteEmployeeError, EmployeesApiDeleteEmployeeResponse, EmployeesApiEmployeeStatsData, EmployeesApiEmployeeStatsResponse, EmployeesApiGetEmployeeData, EmployeesApiGetEmployeeResponse, EmployeesApiListEmployeeRolesData, EmployeesApiListEmployeeRolesResponse, EmployeesApiListEmployeesData, EmployeesApiListEmployeesResponse, EmployeesApiListEmploymentTypesData, EmployeesApiListEmploymentTypesResponse, EmployeesApiUpdateEmployeeData, EmployeesApiUpdateEmployeeError, EmployeesApiUpdateEmployeeResponse, IngestionApiConnectionsConnectionStatsData, IngestionApiConnectionsConnectionStatsResponse, IngestionApiConnectionsCreateConnectionData, IngestionApiConnectionsCreateConnectionError, IngestionApiConnectionsCreateConnectionResponse, IngestionApiConnectionsDeleteConnectionData, IngestionApiConnectionsDeleteConnectionResponse, IngestionApiConnectionsGetConnectionData, IngestionApiConnectionsGetConnectionResponse, IngestionApiConnectionsListConnectionsData, IngestionApiConnectionsListConnectionsResponse, IngestionApiConnectionsSyncConnectionData, IngestionApiConnectionsSyncConnectionError, IngestionApiConnectionsSyncConnectionResponse, IngestionApiConnectionsTestConnectionData, IngestionApiConnectionsTestConnectionError, IngestionApiConnectionsTestConnectionResponse, IngestionApiConnectionsUpdateConnectionData, IngestionApiConnectionsUpdateConnectionError, IngestionApiConnectionsUpdateConnectionResponse, IngestionApiImportsApproveImportData, IngestionApiImportsApproveImportError, IngestionApiImportsApproveImportResponse, IngestionApiImportsCreateImportData, IngestionApiImportsCreateImportResponse, IngestionApiImportsDownloadImportErrorsCsvData, IngestionApiImportsGetImportData, IngestionApiImportsGetImportResponse, IngestionApiImportsListImportErrorsData, IngestionApiImportsListImportErrorsResponse, IngestionApiImportsListImportsData, IngestionApiImportsListImportsResponse, MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentData, MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentError, MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentResponse, MappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsData, MappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsResponse, MappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentData, MappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentResponse, MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData, MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsResponse, MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentData, MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentError, MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentResponse, MappingsApiStoreCategoriesCreateStoreCategoryData, MappingsApiStoreCategoriesCreateStoreCategoryError, MappingsApiStoreCategoriesCreateStoreCategoryResponse, MappingsApiStoreCategoriesDeleteStoreCategoryData, MappingsApiStoreCategoriesDeleteStoreCategoryResponse, MappingsApiStoreCategoriesGetStoreCategoryData, MappingsApiStoreCategoriesGetStoreCategoryResponse, MappingsApiStoreCategoriesListStoreCategoriesData, MappingsApiStoreCategoriesListStoreCategoriesResponse, MappingsApiStoreCategoriesStoreCategoryStatsData, MappingsApiStoreCategoriesStoreCategoryStatsResponse, MappingsApiStoreCategoriesUpdateStoreCategoryData, MappingsApiStoreCategoriesUpdateStoreCategoryError, MappingsApiStoreCategoriesUpdateStoreCategoryResponse, MappingsApiStorePlanogramsCreateStorePlanogramData, MappingsApiStorePlanogramsCreateStorePlanogramError, MappingsApiStorePlanogramsCreateStorePlanogramResponse, MappingsApiStorePlanogramsDeleteStorePlanogramData, MappingsApiStorePlanogramsDeleteStorePlanogramError, MappingsApiStorePlanogramsDeleteStorePlanogramResponse, MappingsApiStorePlanogramsGetStorePlanogramData, MappingsApiStorePlanogramsGetStorePlanogramResponse, MappingsApiStorePlanogramsListStorePlanogramGroupsData, MappingsApiStorePlanogramsListStorePlanogramGroupsResponse, MappingsApiStorePlanogramsListStorePlanogramsData, MappingsApiStorePlanogramsListStorePlanogramsResponse, MappingsApiStorePlanogramsStorePlanogramGroupStatsData, MappingsApiStorePlanogramsStorePlanogramGroupStatsResponse, MappingsApiStorePlanogramsStorePlanogramStatsData, MappingsApiStorePlanogramsStorePlanogramStatsResponse, MappingsApiStorePlanogramsUpdateStorePlanogramData, MappingsApiStorePlanogramsUpdateStorePlanogramError, MappingsApiStorePlanogramsUpdateStorePlanogramResponse, MappingsApiStoreProductsCreateStoreProductData, MappingsApiStoreProductsCreateStoreProductError, MappingsApiStoreProductsCreateStoreProductResponse, MappingsApiStoreProductsDeleteStoreProductData, MappingsApiStoreProductsDeleteStoreProductResponse, MappingsApiStoreProductsGetStoreProductData, MappingsApiStoreProductsGetStoreProductResponse, MappingsApiStoreProductsListStoreProductsData, MappingsApiStoreProductsListStoreProductsResponse, MappingsApiStoreProductsStoreProductStatsData, MappingsApiStoreProductsStoreProductStatsResponse, MappingsApiStoreProductsUpdateStoreProductData, MappingsApiStoreProductsUpdateStoreProductError, MappingsApiStoreProductsUpdateStoreProductResponse, MappingsApiWorkingGroupsCreateWorkingGroupData, MappingsApiWorkingGroupsCreateWorkingGroupError, MappingsApiWorkingGroupsCreateWorkingGroupResponse, MappingsApiWorkingGroupsGetWorkingGroupData, MappingsApiWorkingGroupsGetWorkingGroupResponse, MappingsApiWorkingGroupsListWorkingGroupsData, MappingsApiWorkingGroupsListWorkingGroupsResponse, MappingsApiWorkingGroupsUpdateWorkingGroupData, MappingsApiWorkingGroupsUpdateWorkingGroupError, MappingsApiWorkingGroupsUpdateWorkingGroupResponse, MappingsApiWorkingGroupsWorkingGroupStatsData, MappingsApiWorkingGroupsWorkingGroupStatsResponse, MobileApiCompleteWorkItemTaskData, MobileApiCompleteWorkItemTaskResponse, MobileApiGetCompletionSummaryData, MobileApiGetCompletionSummaryError, MobileApiGetCompletionSummaryResponse, MobileApiListWorkItemBaysData, MobileApiListWorkItemBaysError, MobileApiListWorkItemBaysResponse, MobileApiStartWorkItemTaskData, MobileApiStartWorkItemTaskResponse, MobileApiStartWorkOrderNiciTaskData, MobileApiStartWorkOrderNiciTaskError, MobileApiStartWorkOrderNiciTaskResponse, MobileApiStartWorkOrderVisitData, MobileApiStartWorkOrderVisitError, MobileApiStartWorkOrderVisitResponse, MobileApiStopWorkOrderNiciTaskData, MobileApiStopWorkOrderNiciTaskError, MobileApiStopWorkOrderNiciTaskResponse, MobileApiSubmitWorkOrderNiciScanData, MobileApiSubmitWorkOrderNiciScanError, MobileApiSubmitWorkOrderNiciScanResponse, MobileApiValidateWorkOrderLocationData, MobileApiValidateWorkOrderLocationError, MobileApiValidateWorkOrderLocationResponse, PlanningApiNiciCreateNiciData, PlanningApiNiciCreateNiciError, PlanningApiNiciCreateNiciResponse, PlanningApiNiciDeleteNiciData, PlanningApiNiciDeleteNiciResponse, PlanningApiNiciGetNiciData, PlanningApiNiciGetNiciResponse, PlanningApiNiciListNiciData, PlanningApiNiciListNiciError, PlanningApiNiciListNiciResponse, PlanningApiNiciNiciStatsData, PlanningApiNiciNiciStatsResponse, PlanningApiNiciUpdateNiciData, PlanningApiNiciUpdateNiciError, PlanningApiNiciUpdateNiciResponse, PlanningApiResetCalendarCreateResetCycleData, PlanningApiResetCalendarCreateResetCycleError, PlanningApiResetCalendarCreateResetCycleResponse, PlanningApiResetCalendarDeleteResetCycleData, PlanningApiResetCalendarDeleteResetCycleResponse, PlanningApiResetCalendarGetResetCycleData, PlanningApiResetCalendarGetResetCycleResponse, PlanningApiResetCalendarListResetCyclesData, PlanningApiResetCalendarListResetCyclesResponse, PlanningApiResetCalendarResetCycleStatsData, PlanningApiResetCalendarResetCycleStatsResponse, PlanningApiResetCalendarUpdateResetCycleData, PlanningApiResetCalendarUpdateResetCycleError, PlanningApiResetCalendarUpdateResetCycleResponse, PlanogramsApiPlanogramsCreatePlanogramData, PlanogramsApiPlanogramsCreatePlanogramError, PlanogramsApiPlanogramsCreatePlanogramResponse, PlanogramsApiPlanogramsDeletePlanogramData, PlanogramsApiPlanogramsDeletePlanogramError, PlanogramsApiPlanogramsDeletePlanogramResponse, PlanogramsApiPlanogramsGetPlanogramData, PlanogramsApiPlanogramsGetPlanogramDetailsData, PlanogramsApiPlanogramsGetPlanogramDetailsResponse, PlanogramsApiPlanogramsGetPlanogramResponse, PlanogramsApiPlanogramsListPlanogramsData, PlanogramsApiPlanogramsListPlanogramsResponse, PlanogramsApiPlanogramsPlanogramStatsData, PlanogramsApiPlanogramsPlanogramStatsResponse, PlanogramsApiPlanogramsUpdatePlanogramData, PlanogramsApiPlanogramsUpdatePlanogramError, PlanogramsApiPlanogramsUpdatePlanogramResponse, PlanogramsApiPositionsListPlanogramPositionsData, PlanogramsApiPositionsListPlanogramPositionsResponse, PlanogramsApiVersionsGetVersionData, PlanogramsApiVersionsGetVersionResponse, PlanogramsApiVersionsListVersionsData, PlanogramsApiVersionsListVersionsResponse, PlanogramsApiVersionsPublishData, PlanogramsApiVersionsPublishError, PlanogramsApiVersionsPublishResponse, PlanogramsApiVersionsStoreReachData, PlanogramsApiVersionsStoreReachResponse, PlanogramsApiVisualizationGetVisualizationData, PlanogramsApiVisualizationGetVisualizationError, PlanogramsApiVisualizationGetVisualizationResponse, ProductsProductsApiCreateProductData, ProductsProductsApiCreateProductError, ProductsProductsApiCreateProductResponse, ProductsProductsApiDeleteProductData, ProductsProductsApiDeleteProductImageData, ProductsProductsApiDeleteProductImageResponse, ProductsProductsApiDeleteProductResponse, ProductsProductsApiGetProductData, ProductsProductsApiGetProductResponse, ProductsProductsApiListBrandsData, ProductsProductsApiListBrandsResponse, ProductsProductsApiListProductsData, ProductsProductsApiListProductsResponse, ProductsProductsApiProductStatsData, ProductsProductsApiProductStatsResponse, ProductsProductsApiSetPrimaryProductImageData, ProductsProductsApiSetPrimaryProductImageError, ProductsProductsApiSetPrimaryProductImageResponse, ProductsProductsApiUpdateProductData, ProductsProductsApiUpdateProductError, ProductsProductsApiUpdateProductResponse, ProductsProductsApiUploadProductImageData, ProductsProductsApiUploadProductImageError, ProductsProductsApiUploadProductImageResponse, ProjectsApiEditEditAnalyzeData, ProjectsApiEditEditAnalyzeError, ProjectsApiEditEditAnalyzeResponse, ProjectsApiEditEditAssignTeamsData, ProjectsApiEditEditAssignTeamsError, ProjectsApiEditEditAssignTeamsResponse, ProjectsApiEditEditCancelData, ProjectsApiEditEditCancelError, ProjectsApiEditEditCancelResponse, ProjectsApiEditEditCommitData, ProjectsApiEditEditCommitError, ProjectsApiEditEditCommitResponse, ProjectsApiEditEditCostEstimateData, ProjectsApiEditEditCostEstimateError, ProjectsApiEditEditCostEstimateResponse, ProjectsApiEditEditInitData, ProjectsApiEditEditInitError, ProjectsApiEditEditInitResponse, ProjectsApiEditEditResumeData, ProjectsApiEditEditResumeError, ProjectsApiEditEditResumeResponse, ProjectsApiEditEditSaveDraftData, ProjectsApiEditEditSaveDraftError, ProjectsApiEditEditSaveDraftResponse, ProjectsApiEditEditScheduleData, ProjectsApiEditEditScheduleError, ProjectsApiEditEditScheduleResponse, ProjectsApiFieldworkGetVisitAssignmentData, ProjectsApiFieldworkGetVisitAssignmentError, ProjectsApiFieldworkGetVisitAssignmentResponse, ProjectsApiFieldworkListAssignedStoresData, ProjectsApiFieldworkListAssignedStoresError, ProjectsApiFieldworkListAssignedStoresResponse, ProjectsApiFieldworkListVisitAssignmentsData, ProjectsApiFieldworkListVisitAssignmentsError, ProjectsApiFieldworkListVisitAssignmentsResponse, ProjectsApiFieldworkListWorkItemsData, ProjectsApiFieldworkListWorkItemsError, ProjectsApiFieldworkListWorkItemsResponse, ProjectsApiFieldworkUpdateVisitAssignmentData, ProjectsApiFieldworkUpdateVisitAssignmentError, ProjectsApiFieldworkUpdateVisitAssignmentResponse, ProjectsApiFieldworkUpdateVisitData, ProjectsApiFieldworkUpdateVisitError, ProjectsApiFieldworkUpdateVisitResponse, ProjectsApiMissionControlDashboardSummaryData, ProjectsApiMissionControlDashboardSummaryResponse, ProjectsApiMissionControlListAlertsData, ProjectsApiMissionControlListAlertsResponse, ProjectsApiMissionControlListEscalationsData, ProjectsApiMissionControlListEscalationsResponse, ProjectsApiMissionControlListWorkOrdersData, ProjectsApiMissionControlListWorkOrdersError, ProjectsApiMissionControlListWorkOrdersResponse, ProjectsApiMissionControlResolveEscalationData, ProjectsApiMissionControlResolveEscalationError, ProjectsApiMissionControlResolveEscalationResponse, ProjectsApiNiciResolutionsCreateNiciResolutionData, ProjectsApiNiciResolutionsCreateNiciResolutionError, ProjectsApiNiciResolutionsCreateNiciResolutionResponse, ProjectsApiNiciScansListNiciScansData, ProjectsApiNiciScansListNiciScansError, ProjectsApiNiciScansListNiciScansResponse, ProjectsApiNiciTrackingListNiciItemsData, ProjectsApiNiciTrackingListNiciItemsError, ProjectsApiNiciTrackingListNiciItemsResponse, ProjectsApiNiciTrackingListNiciStoresData, ProjectsApiNiciTrackingListNiciStoresError, ProjectsApiNiciTrackingListNiciStoresResponse, ProjectsApiNiciTrackingNiciItemRolloutData, ProjectsApiNiciTrackingNiciItemRolloutError, ProjectsApiNiciTrackingNiciItemRolloutResponse, ProjectsApiNiciTrackingNiciProjectSummaryData, ProjectsApiNiciTrackingNiciProjectSummaryResponse, ProjectsApiProjectsApplyBackroomNewItemCollectionActionData, ProjectsApiProjectsApplyBackroomNewItemCollectionActionError, ProjectsApiProjectsApplyBackroomNewItemCollectionActionResponse, ProjectsApiProjectsCreateExceptionEventData, ProjectsApiProjectsCreateExceptionEventError, ProjectsApiProjectsCreateExceptionEventResponse, ProjectsApiProjectsCreateFieldPhotoData, ProjectsApiProjectsCreateFieldPhotoError, ProjectsApiProjectsCreateFieldPhotoResponse, ProjectsApiProjectsCreateProjectData, ProjectsApiProjectsCreateProjectError, ProjectsApiProjectsCreateProjectResponse, ProjectsApiProjectsDeleteProjectData, ProjectsApiProjectsDeleteProjectError, ProjectsApiProjectsDeleteProjectResponse, ProjectsApiProjectsGetBackroomNewItemRequirementsData, ProjectsApiProjectsGetBackroomNewItemRequirementsResponse, ProjectsApiProjectsGetProjectData, ProjectsApiProjectsGetProjectResponse, ProjectsApiProjectsListCyclesData, ProjectsApiProjectsListCyclesResponse, ProjectsApiProjectsListExceptionEventTypesData, ProjectsApiProjectsListExceptionEventTypesResponse, ProjectsApiProjectsListFieldPhotosData, ProjectsApiProjectsListFieldPhotosResponse, ProjectsApiProjectsListProjectsData, ProjectsApiProjectsListProjectsResponse, ProjectsApiProjectsListWorkOrderWorkItemsData, ProjectsApiProjectsListWorkOrderWorkItemsError, ProjectsApiProjectsListWorkOrderWorkItemsResponse, ProjectsApiProjectsTransitionProjectData, ProjectsApiProjectsTransitionProjectError, ProjectsApiProjectsTransitionProjectResponse, ProjectsApiProjectsUpdateProjectData, ProjectsApiProjectsUpdateProjectError, ProjectsApiProjectsUpdateProjectResponse, ProjectsApiProjectsUpdateWorkItemData, ProjectsApiProjectsUpdateWorkItemError, ProjectsApiProjectsUpdateWorkItemResponse, ProjectsApiTimeEntriesListTimeEntriesData, ProjectsApiTimeEntriesListTimeEntriesError, ProjectsApiTimeEntriesListTimeEntriesResponse, ProjectsApiTimesheetsGetBreakFormData, ProjectsApiTimesheetsGetBreakFormError, ProjectsApiTimesheetsGetBreakFormResponse, ProjectsApiTimesheetsGetTimesheetData, ProjectsApiTimesheetsGetTimesheetError, ProjectsApiTimesheetsGetTimesheetResponse, ProjectsApiTimesheetsListTimesheetsData, ProjectsApiTimesheetsListTimesheetsError, ProjectsApiTimesheetsListTimesheetsResponse, ProjectsApiTimesheetsUpdateTimesheetData, ProjectsApiTimesheetsUpdateTimesheetError, ProjectsApiTimesheetsUpdateTimesheetResponse, ProjectsApiWizardWizardAnalyzeData, ProjectsApiWizardWizardAnalyzeError, ProjectsApiWizardWizardAnalyzeResponse, ProjectsApiWizardWizardAnalyzeV2Data, ProjectsApiWizardWizardAnalyzeV2Error, ProjectsApiWizardWizardAnalyzeV2Response, ProjectsApiWizardWizardApproveData, ProjectsApiWizardWizardApproveError, ProjectsApiWizardWizardApproveResponse, ProjectsApiWizardWizardAssignTeamsV2Data, ProjectsApiWizardWizardAssignTeamsV2Error, ProjectsApiWizardWizardAssignTeamsV2Response, ProjectsApiWizardWizardCostEstimateData, ProjectsApiWizardWizardCostEstimateError, ProjectsApiWizardWizardCostEstimateResponse, ProjectsApiWizardWizardCreateData, ProjectsApiWizardWizardCreateError, ProjectsApiWizardWizardCreateResponse, ProjectsApiWizardWizardInitData, ProjectsApiWizardWizardInitError, ProjectsApiWizardWizardInitResponse, ProjectsApiWizardWizardOptionsData, ProjectsApiWizardWizardOptionsResponse, ProjectsApiWizardWizardParseDescriptionData, ProjectsApiWizardWizardParseDescriptionError, ProjectsApiWizardWizardParseDescriptionResponse, ProjectsApiWizardWizardParseVoiceData, ProjectsApiWizardWizardParseVoiceError, ProjectsApiWizardWizardParseVoiceResponse, ProjectsApiWizardWizardProjectTypesData, ProjectsApiWizardWizardProjectTypesResponse, ProjectsApiWizardWizardRefreshData, ProjectsApiWizardWizardRefreshError, ProjectsApiWizardWizardRefreshResponse, ProjectsApiWizardWizardResumeData, ProjectsApiWizardWizardResumeError, ProjectsApiWizardWizardResumeResponse, ProjectsApiWizardWizardSaveDraftData, ProjectsApiWizardWizardSaveDraftError, ProjectsApiWizardWizardSaveDraftResponse, ProjectsApiWizardWizardScheduleApplyData, ProjectsApiWizardWizardScheduleApplyError, ProjectsApiWizardWizardScheduleApplyResponse, ProjectsApiWizardWizardScheduleV2Data, ProjectsApiWizardWizardScheduleV2Error, ProjectsApiWizardWizardScheduleV2Response, ProjectsApiWizardWizardTranscribeData, ProjectsApiWizardWizardTranscribeError, ProjectsApiWizardWizardTranscribeResponse, RulesApiCreateRuleData, RulesApiCreateRuleError, RulesApiCreateRuleResponse, RulesApiDeleteRuleData, RulesApiDeleteRuleResponse, RulesApiGetRuleData, RulesApiGetRuleResponse, RulesApiListRulesData, RulesApiListRulesResponse, RulesApiRuleStatsData, RulesApiRuleStatsResponse, RulesApiUpdateRuleData, RulesApiUpdateRuleError, RulesApiUpdateRuleResponse, StorageApiLocalFsUploadData, StorageApiLocalFsUploadError, StorageApiLocalFsUploadResponse, StorageApiRequestUploadData, StorageApiRequestUploadResponse, StoresApiCreateStoreData, StoresApiCreateStoreError, StoresApiCreateStoreResponse, StoresApiDeleteStoreData, StoresApiDeleteStoreResponse, StoresApiGetStoreData, StoresApiGetStoreResponse, StoresApiListBannersData, StoresApiListBannersResponse, StoresApiListRegionsData, StoresApiListRegionsResponse, StoresApiListSegmentsData, StoresApiListSegmentsResponse, StoresApiListStatesData, StoresApiListStatesResponse, StoresApiListStoreFormatsData, StoresApiListStoreFormatsResponse, StoresApiListStoreGroupsData, StoresApiListStoreGroupsResponse, StoresApiListStoresData, StoresApiListStoresResponse, StoresApiListStoreTypesData, StoresApiListStoreTypesResponse, StoresApiStoreStatsData, StoresApiStoreStatsResponse, StoresApiUpdateStoreData, StoresApiUpdateStoreError, StoresApiUpdateStoreResponse, SupervisorApiCreateChatData, SupervisorApiCreateChatError, SupervisorApiCreateChatResponse, SupervisorApiListChatsData, SupervisorApiListChatsResponse, SupervisorApiListMessagesData, SupervisorApiListMessagesError, SupervisorApiListMessagesResponse, SupervisorApiSendMessageData, SupervisorApiSendMessageError, SuppliersApiListSuppliersData, SuppliersApiListSuppliersResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const coreHealthcheckApiHealthCheckQueryKey = (options?: Options<CoreHealthcheckApiHealthCheckData>) => createQueryKey('coreHealthcheckApiHealthCheck', options);

/**
 * Health Check
 *
 * Comprehensive healthcheck that verifies backing services.
 *
 * Checks performed:
 * 1. Required environment variables are present.
 * 2. PostgreSQL connection is working.
 * 3. Redis connection is working.
 *
 * Returns:
 * ``JsonResponse`` with HTTP 200 if all checks pass, or
 * HTTP 503 if any check fails. The body contains per-check
 * status details under ``checks``.
 */
export const coreHealthcheckApiHealthCheckOptions = (options?: Options<CoreHealthcheckApiHealthCheckData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof coreHealthcheckApiHealthCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreHealthcheckApiHealthCheck({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreHealthcheckApiHealthCheckQueryKey(options)
});

export const accountsApiDiscoveryGetAuthenticationMethodsQueryKey = (options?: Options<AccountsApiDiscoveryGetAuthenticationMethodsData>) => createQueryKey('accountsApiDiscoveryGetAuthenticationMethods', options);

/**
 * Get Authentication Methods
 *
 * Return the available authentication methods for a client surface.
 */
export const accountsApiDiscoveryGetAuthenticationMethodsOptions = (options?: Options<AccountsApiDiscoveryGetAuthenticationMethodsData>) => queryOptions<AccountsApiDiscoveryGetAuthenticationMethodsResponse, AccountsApiDiscoveryGetAuthenticationMethodsError, AccountsApiDiscoveryGetAuthenticationMethodsResponse, ReturnType<typeof accountsApiDiscoveryGetAuthenticationMethodsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await accountsApiDiscoveryGetAuthenticationMethods({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: accountsApiDiscoveryGetAuthenticationMethodsQueryKey(options)
});

/**
 * Google Login
 *
 * Exchange a Google token for a JWT access token.
 */
export const accountsApiLegacyGoogleLoginMutation = (options?: Partial<Options<AccountsApiLegacyGoogleLoginData>>): UseMutationOptions<AccountsApiLegacyGoogleLoginResponse, AccountsApiLegacyGoogleLoginError, Options<AccountsApiLegacyGoogleLoginData>> => {
    const mutationOptions: UseMutationOptions<AccountsApiLegacyGoogleLoginResponse, AccountsApiLegacyGoogleLoginError, Options<AccountsApiLegacyGoogleLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountsApiLegacyGoogleLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Logout
 *
 * Clear the auth cookie and Django session.
 *
 * Note: the JWT itself is not revoked — it remains valid
 * until its ``exp`` timestamp. This is inherent to
 * stateless JWTs; logout == "clear the browser's copy".
 * If stricter revocation becomes a requirement, add a
 * ``jti`` denylist in Redis and check it in
 * ``JWTAuthMiddleware``.
 *
 * Requires CSRF (see ``CookieCsrfMiddleware``): the
 * endpoint is intentionally *not* listed in
 * ``PUBLIC_PREFIXES``, so a valid auth cookie +
 * ``X-CSRFToken`` header are both required.
 */
export const accountsApiLegacyLogoutMutation = (options?: Partial<Options<AccountsApiLegacyLogoutData>>): UseMutationOptions<AccountsApiLegacyLogoutResponse, DefaultError, Options<AccountsApiLegacyLogoutData>> => {
    const mutationOptions: UseMutationOptions<AccountsApiLegacyLogoutResponse, DefaultError, Options<AccountsApiLegacyLogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountsApiLegacyLogout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountsApiProfileGetCurrentUserQueryKey = (options?: Options<AccountsApiProfileGetCurrentUserData>) => createQueryKey('accountsApiProfileGetCurrentUser', options);

/**
 * Get Current User
 *
 * Return the current authenticated user's profile.
 *
 * Pure read — does *not* re-issue the JWT or refresh the
 * cookie. If a sliding session is needed in the future,
 * add a dedicated ``/refresh/`` endpoint rather than
 * silently extending the session on every poll.
 */
export const accountsApiProfileGetCurrentUserOptions = (options?: Options<AccountsApiProfileGetCurrentUserData>) => queryOptions<AccountsApiProfileGetCurrentUserResponse, AccountsApiProfileGetCurrentUserError, AccountsApiProfileGetCurrentUserResponse, ReturnType<typeof accountsApiProfileGetCurrentUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await accountsApiProfileGetCurrentUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: accountsApiProfileGetCurrentUserQueryKey(options)
});

/**
 * Request
 *
 * Request an opaque OTP challenge without exposing account eligibility.
 */
export const accountsApiOtpRequestMutation = (options?: Partial<Options<AccountsApiOtpRequestData>>): UseMutationOptions<AccountsApiOtpRequestResponse, AccountsApiOtpRequestError, Options<AccountsApiOtpRequestData>> => {
    const mutationOptions: UseMutationOptions<AccountsApiOtpRequestResponse, AccountsApiOtpRequestError, Options<AccountsApiOtpRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountsApiOtpRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify
 *
 * Verify a challenge and establish an application session on success.
 */
export const accountsApiOtpVerifyMutation = (options?: Partial<Options<AccountsApiOtpVerifyData>>): UseMutationOptions<AccountsApiOtpVerifyResponse, AccountsApiOtpVerifyError, Options<AccountsApiOtpVerifyData>> => {
    const mutationOptions: UseMutationOptions<AccountsApiOtpVerifyResponse, AccountsApiOtpVerifyError, Options<AccountsApiOtpVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountsApiOtpVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh
 *
 * Rotate a cookie-held application refresh credential.
 */
export const accountsApiSessionsRefreshMutation = (options?: Partial<Options<AccountsApiSessionsRefreshData>>): UseMutationOptions<AccountsApiSessionsRefreshResponse, AccountsApiSessionsRefreshError, Options<AccountsApiSessionsRefreshData>> => {
    const mutationOptions: UseMutationOptions<AccountsApiSessionsRefreshResponse, AccountsApiSessionsRefreshError, Options<AccountsApiSessionsRefreshData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountsApiSessionsRefresh({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Session Logout
 *
 * Revoke a cookie-held application session and clear browser credentials.
 *
 * The endpoint never clears browser state before a valid request.
 */
export const accountsApiSessionsSessionLogoutMutation = (options?: Partial<Options<AccountsApiSessionsSessionLogoutData>>): UseMutationOptions<AccountsApiSessionsSessionLogoutResponse, AccountsApiSessionsSessionLogoutError, Options<AccountsApiSessionsSessionLogoutData>> => {
    const mutationOptions: UseMutationOptions<AccountsApiSessionsSessionLogoutResponse, AccountsApiSessionsSessionLogoutError, Options<AccountsApiSessionsSessionLogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountsApiSessionsSessionLogout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Exchange
 *
 * Exchange one PKCE-bound SSO login code for application credentials.
 */
export const accountsApiSsoExchangeMutation = (options?: Partial<Options<AccountsApiSsoExchangeData>>): UseMutationOptions<AccountsApiSsoExchangeResponse, AccountsApiSsoExchangeError, Options<AccountsApiSsoExchangeData>> => {
    const mutationOptions: UseMutationOptions<AccountsApiSsoExchangeResponse, AccountsApiSsoExchangeError, Options<AccountsApiSsoExchangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountsApiSsoExchange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiProjectsListCyclesQueryKey = (options?: Options<ProjectsApiProjectsListCyclesData>) => createQueryKey('projectsApiProjectsListCycles', options);

/**
 * List Cycles
 */
export const projectsApiProjectsListCyclesOptions = (options?: Options<ProjectsApiProjectsListCyclesData>) => queryOptions<ProjectsApiProjectsListCyclesResponse, DefaultError, ProjectsApiProjectsListCyclesResponse, ReturnType<typeof projectsApiProjectsListCyclesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiProjectsListCycles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiProjectsListCyclesQueryKey(options)
});

export const projectsApiProjectsListProjectsQueryKey = (options?: Options<ProjectsApiProjectsListProjectsData>) => createQueryKey('projectsApiProjectsListProjects', options);

/**
 * List Projects
 */
export const projectsApiProjectsListProjectsOptions = (options?: Options<ProjectsApiProjectsListProjectsData>) => queryOptions<ProjectsApiProjectsListProjectsResponse, DefaultError, ProjectsApiProjectsListProjectsResponse, ReturnType<typeof projectsApiProjectsListProjectsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiProjectsListProjects({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiProjectsListProjectsQueryKey(options)
});

/**
 * Create Project
 */
export const projectsApiProjectsCreateProjectMutation = (options?: Partial<Options<ProjectsApiProjectsCreateProjectData>>): UseMutationOptions<ProjectsApiProjectsCreateProjectResponse, ProjectsApiProjectsCreateProjectError, Options<ProjectsApiProjectsCreateProjectData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiProjectsCreateProjectResponse, ProjectsApiProjectsCreateProjectError, Options<ProjectsApiProjectsCreateProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiProjectsCreateProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiProjectsListWorkOrderWorkItemsQueryKey = (options: Options<ProjectsApiProjectsListWorkOrderWorkItemsData>) => createQueryKey('projectsApiProjectsListWorkOrderWorkItems', options);

/**
 * List Work Order Work Items
 */
export const projectsApiProjectsListWorkOrderWorkItemsOptions = (options: Options<ProjectsApiProjectsListWorkOrderWorkItemsData>) => queryOptions<ProjectsApiProjectsListWorkOrderWorkItemsResponse, ProjectsApiProjectsListWorkOrderWorkItemsError, ProjectsApiProjectsListWorkOrderWorkItemsResponse, ReturnType<typeof projectsApiProjectsListWorkOrderWorkItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiProjectsListWorkOrderWorkItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiProjectsListWorkOrderWorkItemsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const projectsApiProjectsListWorkOrderWorkItemsInfiniteQueryKey = (options: Options<ProjectsApiProjectsListWorkOrderWorkItemsData>): QueryKey<Options<ProjectsApiProjectsListWorkOrderWorkItemsData>> => createQueryKey('projectsApiProjectsListWorkOrderWorkItems', options, true);

/**
 * List Work Order Work Items
 */
export const projectsApiProjectsListWorkOrderWorkItemsInfiniteOptions = (options: Options<ProjectsApiProjectsListWorkOrderWorkItemsData>) => infiniteQueryOptions<ProjectsApiProjectsListWorkOrderWorkItemsResponse, ProjectsApiProjectsListWorkOrderWorkItemsError, InfiniteData<ProjectsApiProjectsListWorkOrderWorkItemsResponse>, QueryKey<Options<ProjectsApiProjectsListWorkOrderWorkItemsData>>, number | Pick<QueryKey<Options<ProjectsApiProjectsListWorkOrderWorkItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiProjectsListWorkOrderWorkItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiProjectsListWorkOrderWorkItems({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiProjectsListWorkOrderWorkItemsInfiniteQueryKey(options)
});

/**
 * Update Work Item
 */
export const projectsApiProjectsUpdateWorkItemMutation = (options?: Partial<Options<ProjectsApiProjectsUpdateWorkItemData>>): UseMutationOptions<ProjectsApiProjectsUpdateWorkItemResponse, ProjectsApiProjectsUpdateWorkItemError, Options<ProjectsApiProjectsUpdateWorkItemData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiProjectsUpdateWorkItemResponse, ProjectsApiProjectsUpdateWorkItemError, Options<ProjectsApiProjectsUpdateWorkItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiProjectsUpdateWorkItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiProjectsGetBackroomNewItemRequirementsQueryKey = (options: Options<ProjectsApiProjectsGetBackroomNewItemRequirementsData>) => createQueryKey('projectsApiProjectsGetBackroomNewItemRequirements', options);

/**
 * Get Backroom New Item Requirements
 */
export const projectsApiProjectsGetBackroomNewItemRequirementsOptions = (options: Options<ProjectsApiProjectsGetBackroomNewItemRequirementsData>) => queryOptions<ProjectsApiProjectsGetBackroomNewItemRequirementsResponse, DefaultError, ProjectsApiProjectsGetBackroomNewItemRequirementsResponse, ReturnType<typeof projectsApiProjectsGetBackroomNewItemRequirementsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiProjectsGetBackroomNewItemRequirements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiProjectsGetBackroomNewItemRequirementsQueryKey(options)
});

/**
 * Apply Backroom New Item Collection Action
 */
export const projectsApiProjectsApplyBackroomNewItemCollectionActionMutation = (options?: Partial<Options<ProjectsApiProjectsApplyBackroomNewItemCollectionActionData>>): UseMutationOptions<ProjectsApiProjectsApplyBackroomNewItemCollectionActionResponse, ProjectsApiProjectsApplyBackroomNewItemCollectionActionError, Options<ProjectsApiProjectsApplyBackroomNewItemCollectionActionData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiProjectsApplyBackroomNewItemCollectionActionResponse, ProjectsApiProjectsApplyBackroomNewItemCollectionActionError, Options<ProjectsApiProjectsApplyBackroomNewItemCollectionActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiProjectsApplyBackroomNewItemCollectionAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Exception Event
 */
export const projectsApiProjectsCreateExceptionEventMutation = (options?: Partial<Options<ProjectsApiProjectsCreateExceptionEventData>>): UseMutationOptions<ProjectsApiProjectsCreateExceptionEventResponse, ProjectsApiProjectsCreateExceptionEventError, Options<ProjectsApiProjectsCreateExceptionEventData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiProjectsCreateExceptionEventResponse, ProjectsApiProjectsCreateExceptionEventError, Options<ProjectsApiProjectsCreateExceptionEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiProjectsCreateExceptionEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiProjectsListExceptionEventTypesQueryKey = (options?: Options<ProjectsApiProjectsListExceptionEventTypesData>) => createQueryKey('projectsApiProjectsListExceptionEventTypes', options);

/**
 * List Exception Event Types
 */
export const projectsApiProjectsListExceptionEventTypesOptions = (options?: Options<ProjectsApiProjectsListExceptionEventTypesData>) => queryOptions<ProjectsApiProjectsListExceptionEventTypesResponse, DefaultError, ProjectsApiProjectsListExceptionEventTypesResponse, ReturnType<typeof projectsApiProjectsListExceptionEventTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiProjectsListExceptionEventTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiProjectsListExceptionEventTypesQueryKey(options)
});

export const projectsApiProjectsListExceptionEventTypesInfiniteQueryKey = (options?: Options<ProjectsApiProjectsListExceptionEventTypesData>): QueryKey<Options<ProjectsApiProjectsListExceptionEventTypesData>> => createQueryKey('projectsApiProjectsListExceptionEventTypes', options, true);

/**
 * List Exception Event Types
 */
export const projectsApiProjectsListExceptionEventTypesInfiniteOptions = (options?: Options<ProjectsApiProjectsListExceptionEventTypesData>) => infiniteQueryOptions<ProjectsApiProjectsListExceptionEventTypesResponse, DefaultError, InfiniteData<ProjectsApiProjectsListExceptionEventTypesResponse>, QueryKey<Options<ProjectsApiProjectsListExceptionEventTypesData>>, number | Pick<QueryKey<Options<ProjectsApiProjectsListExceptionEventTypesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiProjectsListExceptionEventTypesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiProjectsListExceptionEventTypes({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiProjectsListExceptionEventTypesInfiniteQueryKey(options)
});

export const projectsApiProjectsListFieldPhotosQueryKey = (options?: Options<ProjectsApiProjectsListFieldPhotosData>) => createQueryKey('projectsApiProjectsListFieldPhotos', options);

/**
 * List Field Photos
 */
export const projectsApiProjectsListFieldPhotosOptions = (options?: Options<ProjectsApiProjectsListFieldPhotosData>) => queryOptions<ProjectsApiProjectsListFieldPhotosResponse, DefaultError, ProjectsApiProjectsListFieldPhotosResponse, ReturnType<typeof projectsApiProjectsListFieldPhotosQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiProjectsListFieldPhotos({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiProjectsListFieldPhotosQueryKey(options)
});

export const projectsApiProjectsListFieldPhotosInfiniteQueryKey = (options?: Options<ProjectsApiProjectsListFieldPhotosData>): QueryKey<Options<ProjectsApiProjectsListFieldPhotosData>> => createQueryKey('projectsApiProjectsListFieldPhotos', options, true);

/**
 * List Field Photos
 */
export const projectsApiProjectsListFieldPhotosInfiniteOptions = (options?: Options<ProjectsApiProjectsListFieldPhotosData>) => infiniteQueryOptions<ProjectsApiProjectsListFieldPhotosResponse, DefaultError, InfiniteData<ProjectsApiProjectsListFieldPhotosResponse>, QueryKey<Options<ProjectsApiProjectsListFieldPhotosData>>, number | Pick<QueryKey<Options<ProjectsApiProjectsListFieldPhotosData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiProjectsListFieldPhotosData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiProjectsListFieldPhotos({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiProjectsListFieldPhotosInfiniteQueryKey(options)
});

/**
 * Create Field Photo
 */
export const projectsApiProjectsCreateFieldPhotoMutation = (options?: Partial<Options<ProjectsApiProjectsCreateFieldPhotoData>>): UseMutationOptions<ProjectsApiProjectsCreateFieldPhotoResponse, ProjectsApiProjectsCreateFieldPhotoError, Options<ProjectsApiProjectsCreateFieldPhotoData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiProjectsCreateFieldPhotoResponse, ProjectsApiProjectsCreateFieldPhotoError, Options<ProjectsApiProjectsCreateFieldPhotoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiProjectsCreateFieldPhoto({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Project
 */
export const projectsApiProjectsDeleteProjectMutation = (options?: Partial<Options<ProjectsApiProjectsDeleteProjectData>>): UseMutationOptions<ProjectsApiProjectsDeleteProjectResponse, ProjectsApiProjectsDeleteProjectError, Options<ProjectsApiProjectsDeleteProjectData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiProjectsDeleteProjectResponse, ProjectsApiProjectsDeleteProjectError, Options<ProjectsApiProjectsDeleteProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiProjectsDeleteProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiProjectsGetProjectQueryKey = (options: Options<ProjectsApiProjectsGetProjectData>) => createQueryKey('projectsApiProjectsGetProject', options);

/**
 * Get Project
 */
export const projectsApiProjectsGetProjectOptions = (options: Options<ProjectsApiProjectsGetProjectData>) => queryOptions<ProjectsApiProjectsGetProjectResponse, DefaultError, ProjectsApiProjectsGetProjectResponse, ReturnType<typeof projectsApiProjectsGetProjectQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiProjectsGetProject({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiProjectsGetProjectQueryKey(options)
});

/**
 * Update Project
 */
export const projectsApiProjectsUpdateProjectMutation = (options?: Partial<Options<ProjectsApiProjectsUpdateProjectData>>): UseMutationOptions<ProjectsApiProjectsUpdateProjectResponse, ProjectsApiProjectsUpdateProjectError, Options<ProjectsApiProjectsUpdateProjectData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiProjectsUpdateProjectResponse, ProjectsApiProjectsUpdateProjectError, Options<ProjectsApiProjectsUpdateProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiProjectsUpdateProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Transition Project
 */
export const projectsApiProjectsTransitionProjectMutation = (options?: Partial<Options<ProjectsApiProjectsTransitionProjectData>>): UseMutationOptions<ProjectsApiProjectsTransitionProjectResponse, ProjectsApiProjectsTransitionProjectError, Options<ProjectsApiProjectsTransitionProjectData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiProjectsTransitionProjectResponse, ProjectsApiProjectsTransitionProjectError, Options<ProjectsApiProjectsTransitionProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiProjectsTransitionProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Initialize a new project with scope analysis
 *
 * Create a DRAFT project and return scope analysis summary.
 */
export const projectsApiWizardWizardInitMutation = (options?: Partial<Options<ProjectsApiWizardWizardInitData>>): UseMutationOptions<ProjectsApiWizardWizardInitResponse, ProjectsApiWizardWizardInitError, Options<ProjectsApiWizardWizardInitData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardInitResponse, ProjectsApiWizardWizardInitError, Options<ProjectsApiWizardWizardInitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardInit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Persist wizard draft: project basics and overrides
 *
 * Unified user-initiated draft editor.
 *
 * Full-replacement semantics for both Project basics and wizard
 * overrides. The client sends the complete draft snapshot; the
 * server replaces both blocks atomically. Uses ``If-Match`` for
 * optimistic concurrency, checked inside a row lock to prevent
 * lost updates between concurrent sessions.
 */
export const projectsApiWizardWizardSaveDraftMutation = (options?: Partial<Options<ProjectsApiWizardWizardSaveDraftData>>): UseMutationOptions<ProjectsApiWizardWizardSaveDraftResponse, ProjectsApiWizardWizardSaveDraftError, Options<ProjectsApiWizardWizardSaveDraftData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardSaveDraftResponse, ProjectsApiWizardWizardSaveDraftError, Options<ProjectsApiWizardWizardSaveDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardSaveDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiWizardWizardResumeQueryKey = (options: Options<ProjectsApiWizardWizardResumeData>) => createQueryKey('projectsApiWizardWizardResume', options);

/**
 * Resume a draft project wizard
 *
 * Return the current draft state for the wizard UI.
 *
 * Reads are tolerant: if a stored slot fails schema validation
 * (schema drift across deployments), it is dropped from the
 * returned view and the derived wizard_step reflects the walk
 * stopping at the first invalid slot. Stale slots are returned
 * as-is with ``stale.<slot> = True``.
 */
export const projectsApiWizardWizardResumeOptions = (options: Options<ProjectsApiWizardWizardResumeData>) => queryOptions<ProjectsApiWizardWizardResumeResponse, ProjectsApiWizardWizardResumeError, ProjectsApiWizardWizardResumeResponse, ReturnType<typeof projectsApiWizardWizardResumeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiWizardWizardResume({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiWizardWizardResumeQueryKey(options)
});

export const projectsApiWizardWizardOptionsQueryKey = (options?: Options<ProjectsApiWizardWizardOptionsData>) => createQueryKey('projectsApiWizardWizardOptions', options);

/**
 * Wizard Options
 */
export const projectsApiWizardWizardOptionsOptions = (options?: Options<ProjectsApiWizardWizardOptionsData>) => queryOptions<ProjectsApiWizardWizardOptionsResponse, DefaultError, ProjectsApiWizardWizardOptionsResponse, ReturnType<typeof projectsApiWizardWizardOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiWizardWizardOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiWizardWizardOptionsQueryKey(options)
});

export const projectsApiWizardWizardProjectTypesQueryKey = (options?: Options<ProjectsApiWizardWizardProjectTypesData>) => createQueryKey('projectsApiWizardWizardProjectTypes', options);

/**
 * Wizard Project Types
 *
 * Return only the task-type choices and transcription flag.
 *
 * A lightweight companion to ``/options`` that skips the categories
 * and cycles queries so the create-project form can render its Task
 * Type cards without waiting on data it does not need.
 */
export const projectsApiWizardWizardProjectTypesOptions = (options?: Options<ProjectsApiWizardWizardProjectTypesData>) => queryOptions<ProjectsApiWizardWizardProjectTypesResponse, DefaultError, ProjectsApiWizardWizardProjectTypesResponse, ReturnType<typeof projectsApiWizardWizardProjectTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiWizardWizardProjectTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiWizardWizardProjectTypesQueryKey(options)
});

/**
 * Wizard Parse Description
 */
export const projectsApiWizardWizardParseDescriptionMutation = (options?: Partial<Options<ProjectsApiWizardWizardParseDescriptionData>>): UseMutationOptions<ProjectsApiWizardWizardParseDescriptionResponse, ProjectsApiWizardWizardParseDescriptionError, Options<ProjectsApiWizardWizardParseDescriptionData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardParseDescriptionResponse, ProjectsApiWizardWizardParseDescriptionError, Options<ProjectsApiWizardWizardParseDescriptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardParseDescription({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Wizard Transcribe
 *
 * Transcribe an audio clip via OpenAI Whisper.
 */
export const projectsApiWizardWizardTranscribeMutation = (options?: Partial<Options<ProjectsApiWizardWizardTranscribeData>>): UseMutationOptions<ProjectsApiWizardWizardTranscribeResponse, ProjectsApiWizardWizardTranscribeError, Options<ProjectsApiWizardWizardTranscribeData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardTranscribeResponse, ProjectsApiWizardWizardTranscribeError, Options<ProjectsApiWizardWizardTranscribeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardTranscribe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Wizard Parse Voice
 *
 * Transcribe audio and parse project description in one call.
 */
export const projectsApiWizardWizardParseVoiceMutation = (options?: Partial<Options<ProjectsApiWizardWizardParseVoiceData>>): UseMutationOptions<ProjectsApiWizardWizardParseVoiceResponse, ProjectsApiWizardWizardParseVoiceError, Options<ProjectsApiWizardWizardParseVoiceData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardParseVoiceResponse, ProjectsApiWizardWizardParseVoiceError, Options<ProjectsApiWizardWizardParseVoiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardParseVoice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Run scope validation and AI analysis for a draft project
 *
 * Validate project scope and persist the analysis result.
 *
 * Loads the DRAFT project, runs ScopeAggregator with user
 * overrides, and writes the scope slot (including backend-only
 * detail keys) directly to ``wizard_state["scope"]``.
 */
export const projectsApiWizardWizardAnalyzeV2Mutation = (options?: Partial<Options<ProjectsApiWizardWizardAnalyzeV2Data>>): UseMutationOptions<ProjectsApiWizardWizardAnalyzeV2Response, ProjectsApiWizardWizardAnalyzeV2Error, Options<ProjectsApiWizardWizardAnalyzeV2Data>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardAnalyzeV2Response, ProjectsApiWizardWizardAnalyzeV2Error, Options<ProjectsApiWizardWizardAnalyzeV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardAnalyzeV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Wizard Analyze
 */
export const projectsApiWizardWizardAnalyzeMutation = (options?: Partial<Options<ProjectsApiWizardWizardAnalyzeData>>): UseMutationOptions<ProjectsApiWizardWizardAnalyzeResponse, ProjectsApiWizardWizardAnalyzeError, Options<ProjectsApiWizardWizardAnalyzeData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardAnalyzeResponse, ProjectsApiWizardWizardAnalyzeError, Options<ProjectsApiWizardWizardAnalyzeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardAnalyze({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate multi-cycle schedule
 *
 * Generate day-level schedule for all project cycles.
 *
 * Apply the selected mode's visit frequency to source work and allowed
 * cycle dates, then persist the result in ``wizard_state['schedule']``.
 */
export const projectsApiWizardWizardScheduleV2Mutation = (options?: Partial<Options<ProjectsApiWizardWizardScheduleV2Data>>): UseMutationOptions<ProjectsApiWizardWizardScheduleV2Response, ProjectsApiWizardWizardScheduleV2Error, Options<ProjectsApiWizardWizardScheduleV2Data>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardScheduleV2Response, ProjectsApiWizardWizardScheduleV2Error, Options<ProjectsApiWizardWizardScheduleV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardScheduleV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Apply schedule-level overrides and regenerate schedule
 *
 * Full-replacement write of schedule-level overrides +
 * atomic schedule regeneration.
 *
 * Preserves scope-level overrides (category_ids, store_ids,
 * notes, assignment_overrides, nici_rollover_exclusions) —
 * those are owned by PATCH /save-draft.
 *
 * Downstream slots (assignments, cost) become stale via
 * schedule_inputs_hash change; the client sees stale flags
 * through GET /resume.
 */
export const projectsApiWizardWizardScheduleApplyMutation = (options?: Partial<Options<ProjectsApiWizardWizardScheduleApplyData>>): UseMutationOptions<ProjectsApiWizardWizardScheduleApplyResponse, ProjectsApiWizardWizardScheduleApplyError, Options<ProjectsApiWizardWizardScheduleApplyData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardScheduleApplyResponse, ProjectsApiWizardWizardScheduleApplyError, Options<ProjectsApiWizardWizardScheduleApplyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardScheduleApply({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate multi-cycle team assignments
 *
 * Assign employees to stores across all project cycles.
 *
 * Reads the schedule from wizard_state, runs the 3-pass
 * assignment engine, and persists the result in
 * wizard_state['assignments'].
 */
export const projectsApiWizardWizardAssignTeamsV2Mutation = (options?: Partial<Options<ProjectsApiWizardWizardAssignTeamsV2Data>>): UseMutationOptions<ProjectsApiWizardWizardAssignTeamsV2Response, ProjectsApiWizardWizardAssignTeamsV2Error, Options<ProjectsApiWizardWizardAssignTeamsV2Data>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardAssignTeamsV2Response, ProjectsApiWizardWizardAssignTeamsV2Error, Options<ProjectsApiWizardWizardAssignTeamsV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardAssignTeamsV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Calculate cost estimate and persist
 *
 * Calculate labor + mileage costs, generate warnings,
 * and persist the result in wizard_state['cost'].
 *
 * Updates Project cost fields for quick reads.
 */
export const projectsApiWizardWizardCostEstimateMutation = (options?: Partial<Options<ProjectsApiWizardWizardCostEstimateData>>): UseMutationOptions<ProjectsApiWizardWizardCostEstimateResponse, ProjectsApiWizardWizardCostEstimateError, Options<ProjectsApiWizardWizardCostEstimateData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardCostEstimateResponse, ProjectsApiWizardWizardCostEstimateError, Options<ProjectsApiWizardWizardCostEstimateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardCostEstimate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rebuild a draft's results from current data
 *
 * Re-run every filled wizard step with current planning data.
 *
 * User overrides are kept. Returns the same body as ``/resume``.
 */
export const projectsApiWizardWizardRefreshMutation = (options?: Partial<Options<ProjectsApiWizardWizardRefreshData>>): UseMutationOptions<ProjectsApiWizardWizardRefreshResponse, ProjectsApiWizardWizardRefreshError, Options<ProjectsApiWizardWizardRefreshData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardRefreshResponse, ProjectsApiWizardWizardRefreshError, Options<ProjectsApiWizardWizardRefreshData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardRefresh({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Wizard Create
 */
export const projectsApiWizardWizardCreateMutation = (options?: Partial<Options<ProjectsApiWizardWizardCreateData>>): UseMutationOptions<ProjectsApiWizardWizardCreateResponse, ProjectsApiWizardWizardCreateError, Options<ProjectsApiWizardWizardCreateData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardCreateResponse, ProjectsApiWizardWizardCreateError, Options<ProjectsApiWizardWizardCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve and publish a draft project
 *
 * Finalise the wizard: build execution structure, then publish.
 *
 * Calls ``build_project_structure`` (T-016) to create ProjectCycles,
 * WorkOrders and typed WorkItems. Then records approval
 * metadata and transitions the project from DRAFT to PUBLISHED.
 *
 * All mutations happen inside a single atomic block so a failure
 * at any point rolls back everything.
 */
export const projectsApiWizardWizardApproveMutation = (options?: Partial<Options<ProjectsApiWizardWizardApproveData>>): UseMutationOptions<ProjectsApiWizardWizardApproveResponse, ProjectsApiWizardWizardApproveError, Options<ProjectsApiWizardWizardApproveData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiWizardWizardApproveResponse, ProjectsApiWizardWizardApproveError, Options<ProjectsApiWizardWizardApproveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiWizardWizardApprove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Begin a project-level edit session
 *
 * Create or reset an edit session for a PUBLISHED project.
 *
 * Snapshots the current params into ``edit_state.base`` / ``new_params``
 * and computes the future-window anchor. Idempotent-guarded: returns
 * 409 if a session is already active, unless ``force=true``.
 */
export const projectsApiEditEditInitMutation = (options?: Partial<Options<ProjectsApiEditEditInitData>>): UseMutationOptions<ProjectsApiEditEditInitResponse, ProjectsApiEditEditInitError, Options<ProjectsApiEditEditInitData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiEditEditInitResponse, ProjectsApiEditEditInitError, Options<ProjectsApiEditEditInitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiEditEditInit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save proposed edit parameters
 *
 * Full-replacement write of proposed edit parameters.
 *
 * Replaces ``new_params`` in the active edit session and
 * invalidates any previously-computed downstream slots
 * (scope / schedule / assignments / cost).
 */
export const projectsApiEditEditSaveDraftMutation = (options?: Partial<Options<ProjectsApiEditEditSaveDraftData>>): UseMutationOptions<ProjectsApiEditEditSaveDraftResponse, ProjectsApiEditEditSaveDraftError, Options<ProjectsApiEditEditSaveDraftData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiEditEditSaveDraftResponse, ProjectsApiEditEditSaveDraftError, Options<ProjectsApiEditEditSaveDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiEditEditSaveDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiEditEditResumeQueryKey = (options: Options<ProjectsApiEditEditResumeData>) => createQueryKey('projectsApiEditEditResume', options);

/**
 * Read the active edit session
 *
 * Return the current edit session state for the UI.
 *
 * Returns ``active: false`` when no session is in progress;
 * returns the full ``edit_state`` dict when one is active.
 */
export const projectsApiEditEditResumeOptions = (options: Options<ProjectsApiEditEditResumeData>) => queryOptions<ProjectsApiEditEditResumeResponse, ProjectsApiEditEditResumeError, ProjectsApiEditEditResumeResponse, ReturnType<typeof projectsApiEditEditResumeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiEditEditResume({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiEditEditResumeQueryKey(options)
});

/**
 * Discard the active edit session
 *
 * Clear ``edit_state`` for the project.
 *
 * Idempotent: safe to call even when no session is active.
 *
 * Unlike the mutating compute endpoints, cancel deliberately does
 * NOT require the project to be PUBLISHED — it is a cleanup action
 * that must be able to discard a stale session even if the project
 * has since moved to another status (e.g. LOCKED).
 */
export const projectsApiEditEditCancelMutation = (options?: Partial<Options<ProjectsApiEditEditCancelData>>): UseMutationOptions<ProjectsApiEditEditCancelResponse, ProjectsApiEditEditCancelError, Options<ProjectsApiEditEditCancelData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiEditEditCancelResponse, ProjectsApiEditEditCancelError, Options<ProjectsApiEditEditCancelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiEditEditCancel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Recompute future-window scope and preview the delta
 *
 * Recompute scope over the future window and persist the scope slot.
 *
 * Mirrors ``wizard_analyze_v2`` but operates on ``edit_state`` and the
 * future-only window (anchored so cycle numbers continue past preserved
 * cycles). Also runs the reconciler in dry-run mode to produce a delta
 * preview (cycles created/deleted/modified, WO/WI deltas, warnings).
 * Blockers (e.g. "no stores in scope") set ``can_commit=False``.
 */
export const projectsApiEditEditAnalyzeMutation = (options?: Partial<Options<ProjectsApiEditEditAnalyzeData>>): UseMutationOptions<ProjectsApiEditEditAnalyzeResponse, ProjectsApiEditEditAnalyzeError, Options<ProjectsApiEditEditAnalyzeData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiEditEditAnalyzeResponse, ProjectsApiEditEditAnalyzeError, Options<ProjectsApiEditEditAnalyzeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiEditEditAnalyze({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Recompute future-window schedule
 *
 * Generate a day-level schedule over the edit future window.
 *
 * Mirrors ``wizard_schedule_v2`` but reads/writes ``edit_state``
 * and gates on the edit scope slot being present.
 */
export const projectsApiEditEditScheduleMutation = (options?: Partial<Options<ProjectsApiEditEditScheduleData>>): UseMutationOptions<ProjectsApiEditEditScheduleResponse, ProjectsApiEditEditScheduleError, Options<ProjectsApiEditEditScheduleData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiEditEditScheduleResponse, ProjectsApiEditEditScheduleError, Options<ProjectsApiEditEditScheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiEditEditSchedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Recompute future-window team assignments
 *
 * Assign employees to stores across the edit future window.
 *
 * Mirrors ``wizard_assign_teams_v2`` but reads/writes ``edit_state``
 * and gates on the edit schedule slot being present.
 */
export const projectsApiEditEditAssignTeamsMutation = (options?: Partial<Options<ProjectsApiEditEditAssignTeamsData>>): UseMutationOptions<ProjectsApiEditEditAssignTeamsResponse, ProjectsApiEditEditAssignTeamsError, Options<ProjectsApiEditEditAssignTeamsData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiEditEditAssignTeamsResponse, ProjectsApiEditEditAssignTeamsError, Options<ProjectsApiEditEditAssignTeamsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiEditEditAssignTeams({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Recompute future-window cost estimate
 *
 * Calculate labor + mileage costs for the edit future window.
 *
 * Mirrors ``wizard_cost_estimate`` but reads/writes ``edit_state``
 * and gates on the edit assignments slot being present.
 */
export const projectsApiEditEditCostEstimateMutation = (options?: Partial<Options<ProjectsApiEditEditCostEstimateData>>): UseMutationOptions<ProjectsApiEditEditCostEstimateResponse, ProjectsApiEditEditCostEstimateError, Options<ProjectsApiEditEditCostEstimateData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiEditEditCostEstimateResponse, ProjectsApiEditEditCostEstimateError, Options<ProjectsApiEditEditCostEstimateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiEditEditCostEstimate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Apply the edit delta to the published project
 *
 * Apply the edit delta to the published project.
 *
 * Guards in order:
 * 1. Must have a scope slot (else 400).
 * 2. If-Match optimistic lock vs the live locked row's updated_at (else 412).
 * 3. Staleness guard: recompute scope hash from current master data;
 * mismatch means data drifted or a cycle activated (else 409).
 * 4. Age guard: the instant /edit/analyze pinned is replayed here, and
 * past ``EDIT_SCOPE_MAX_AGE`` it no longer describes the world
 * (else 409).
 * 5. Blocker guard: scope has blockers / can_proceed is False (else 400).
 *
 * On success: applies the reconciler delta, updates effective_range +
 * cost fields from the edit_state cost slot, clears edit_state, and
 * saves. The project STAYS PUBLISHED (no state-machine transition).
 * On any guard failure, edit_state is left intact.
 */
export const projectsApiEditEditCommitMutation = (options?: Partial<Options<ProjectsApiEditEditCommitData>>): UseMutationOptions<ProjectsApiEditEditCommitResponse, ProjectsApiEditEditCommitError, Options<ProjectsApiEditEditCommitData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiEditEditCommitResponse, ProjectsApiEditEditCommitError, Options<ProjectsApiEditEditCommitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiEditEditCommit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiNiciScansListNiciScansQueryKey = (options?: Options<ProjectsApiNiciScansListNiciScansData>) => createQueryKey('projectsApiNiciScansListNiciScans', options);

/**
 * List Nici Scans
 *
 * List scans, limiting non-privileged callers to their own records.
 */
export const projectsApiNiciScansListNiciScansOptions = (options?: Options<ProjectsApiNiciScansListNiciScansData>) => queryOptions<ProjectsApiNiciScansListNiciScansResponse, ProjectsApiNiciScansListNiciScansError, ProjectsApiNiciScansListNiciScansResponse, ReturnType<typeof projectsApiNiciScansListNiciScansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiNiciScansListNiciScans({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiNiciScansListNiciScansQueryKey(options)
});

export const projectsApiNiciScansListNiciScansInfiniteQueryKey = (options?: Options<ProjectsApiNiciScansListNiciScansData>): QueryKey<Options<ProjectsApiNiciScansListNiciScansData>> => createQueryKey('projectsApiNiciScansListNiciScans', options, true);

/**
 * List Nici Scans
 *
 * List scans, limiting non-privileged callers to their own records.
 */
export const projectsApiNiciScansListNiciScansInfiniteOptions = (options?: Options<ProjectsApiNiciScansListNiciScansData>) => infiniteQueryOptions<ProjectsApiNiciScansListNiciScansResponse, ProjectsApiNiciScansListNiciScansError, InfiniteData<ProjectsApiNiciScansListNiciScansResponse>, QueryKey<Options<ProjectsApiNiciScansListNiciScansData>>, number | Pick<QueryKey<Options<ProjectsApiNiciScansListNiciScansData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiNiciScansListNiciScansData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiNiciScansListNiciScans({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiNiciScansListNiciScansInfiniteQueryKey(options)
});

export const projectsApiTimeEntriesListTimeEntriesQueryKey = (options?: Options<ProjectsApiTimeEntriesListTimeEntriesData>) => createQueryKey('projectsApiTimeEntriesListTimeEntries', options);

/**
 * List Time Entries
 */
export const projectsApiTimeEntriesListTimeEntriesOptions = (options?: Options<ProjectsApiTimeEntriesListTimeEntriesData>) => queryOptions<ProjectsApiTimeEntriesListTimeEntriesResponse, ProjectsApiTimeEntriesListTimeEntriesError, ProjectsApiTimeEntriesListTimeEntriesResponse, ReturnType<typeof projectsApiTimeEntriesListTimeEntriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiTimeEntriesListTimeEntries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiTimeEntriesListTimeEntriesQueryKey(options)
});

export const projectsApiTimeEntriesListTimeEntriesInfiniteQueryKey = (options?: Options<ProjectsApiTimeEntriesListTimeEntriesData>): QueryKey<Options<ProjectsApiTimeEntriesListTimeEntriesData>> => createQueryKey('projectsApiTimeEntriesListTimeEntries', options, true);

/**
 * List Time Entries
 */
export const projectsApiTimeEntriesListTimeEntriesInfiniteOptions = (options?: Options<ProjectsApiTimeEntriesListTimeEntriesData>) => infiniteQueryOptions<ProjectsApiTimeEntriesListTimeEntriesResponse, ProjectsApiTimeEntriesListTimeEntriesError, InfiniteData<ProjectsApiTimeEntriesListTimeEntriesResponse>, QueryKey<Options<ProjectsApiTimeEntriesListTimeEntriesData>>, number | Pick<QueryKey<Options<ProjectsApiTimeEntriesListTimeEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiTimeEntriesListTimeEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiTimeEntriesListTimeEntries({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiTimeEntriesListTimeEntriesInfiniteQueryKey(options)
});

/**
 * Create Nici Resolution
 */
export const projectsApiNiciResolutionsCreateNiciResolutionMutation = (options?: Partial<Options<ProjectsApiNiciResolutionsCreateNiciResolutionData>>): UseMutationOptions<ProjectsApiNiciResolutionsCreateNiciResolutionResponse, ProjectsApiNiciResolutionsCreateNiciResolutionError, Options<ProjectsApiNiciResolutionsCreateNiciResolutionData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiNiciResolutionsCreateNiciResolutionResponse, ProjectsApiNiciResolutionsCreateNiciResolutionError, Options<ProjectsApiNiciResolutionsCreateNiciResolutionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiNiciResolutionsCreateNiciResolution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const categoriesApiCategoryStatsQueryKey = (options?: Options<CategoriesApiCategoryStatsData>) => createQueryKey('categoriesApiCategoryStats', options);

/**
 * Category Stats
 *
 * Return aggregate category statistics.
 *
 * Computes the total number of categories and a breakdown
 * by hierarchy level.
 *
 * Returns:
 * A dict with ``total`` count and ``by_level`` mapping
 * of ``{level: count}``.
 */
export const categoriesApiCategoryStatsOptions = (options?: Options<CategoriesApiCategoryStatsData>) => queryOptions<CategoriesApiCategoryStatsResponse, DefaultError, CategoriesApiCategoryStatsResponse, ReturnType<typeof categoriesApiCategoryStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await categoriesApiCategoryStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: categoriesApiCategoryStatsQueryKey(options)
});

export const categoriesApiListCategoriesQueryKey = (options?: Options<CategoriesApiListCategoriesData>) => createQueryKey('categoriesApiListCategories', options);

/**
 * List Categories
 *
 * Return a paginated list of categories.
 *
 * Supports optional filtering by text search (``code``,
 * ``name``), hierarchy ``level``, and ``parent_id``.
 *
 * Args:
 * request: The incoming HTTP request.
 * search: Free-text search across ``code`` and
 * ``name`` fields (case-insensitive contains).
 * level: Filter by exact hierarchy depth.
 * parent_id: Filter by parent category UUID.
 * page: Page number (1-indexed).
 * page_size: Number of results per page.
 *
 * Returns:
 * Paginated response envelope with ``count``, ``next``,
 * ``previous``, and ``results``.
 */
export const categoriesApiListCategoriesOptions = (options?: Options<CategoriesApiListCategoriesData>) => queryOptions<CategoriesApiListCategoriesResponse, DefaultError, CategoriesApiListCategoriesResponse, ReturnType<typeof categoriesApiListCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await categoriesApiListCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: categoriesApiListCategoriesQueryKey(options)
});

export const categoriesApiListCategoriesInfiniteQueryKey = (options?: Options<CategoriesApiListCategoriesData>): QueryKey<Options<CategoriesApiListCategoriesData>> => createQueryKey('categoriesApiListCategories', options, true);

/**
 * List Categories
 *
 * Return a paginated list of categories.
 *
 * Supports optional filtering by text search (``code``,
 * ``name``), hierarchy ``level``, and ``parent_id``.
 *
 * Args:
 * request: The incoming HTTP request.
 * search: Free-text search across ``code`` and
 * ``name`` fields (case-insensitive contains).
 * level: Filter by exact hierarchy depth.
 * parent_id: Filter by parent category UUID.
 * page: Page number (1-indexed).
 * page_size: Number of results per page.
 *
 * Returns:
 * Paginated response envelope with ``count``, ``next``,
 * ``previous``, and ``results``.
 */
export const categoriesApiListCategoriesInfiniteOptions = (options?: Options<CategoriesApiListCategoriesData>) => infiniteQueryOptions<CategoriesApiListCategoriesResponse, DefaultError, InfiniteData<CategoriesApiListCategoriesResponse>, QueryKey<Options<CategoriesApiListCategoriesData>>, number | Pick<QueryKey<Options<CategoriesApiListCategoriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<CategoriesApiListCategoriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await categoriesApiListCategories({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: categoriesApiListCategoriesInfiniteQueryKey(options)
});

/**
 * Create Category
 *
 * Create a new category node.
 *
 * Args:
 * request: The incoming HTTP request.
 * payload: Category data to create.
 *
 * Returns:
 * A tuple of ``(201, created_category)`` on success, or
 * ``(409, error_detail)`` if a uniqueness constraint is
 * violated.
 */
export const categoriesApiCreateCategoryMutation = (options?: Partial<Options<CategoriesApiCreateCategoryData>>): UseMutationOptions<CategoriesApiCreateCategoryResponse, CategoriesApiCreateCategoryError, Options<CategoriesApiCreateCategoryData>> => {
    const mutationOptions: UseMutationOptions<CategoriesApiCreateCategoryResponse, CategoriesApiCreateCategoryError, Options<CategoriesApiCreateCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await categoriesApiCreateCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Category
 *
 * Delete a category by its UUID.
 *
 * Cascading deletion will also remove child categories
 * linked via the ``parent`` FK.
 *
 * Args:
 * request: The incoming HTTP request.
 * category_id: UUID of the category to delete.
 *
 * Returns:
 * A tuple of ``(204, None)`` on successful deletion, or
 * ``(409, error_detail)`` if the category is referenced.
 *
 * Raises:
 * Http404: If no category with the given UUID exists.
 */
export const categoriesApiDeleteCategoryMutation = (options?: Partial<Options<CategoriesApiDeleteCategoryData>>): UseMutationOptions<CategoriesApiDeleteCategoryResponse, CategoriesApiDeleteCategoryError, Options<CategoriesApiDeleteCategoryData>> => {
    const mutationOptions: UseMutationOptions<CategoriesApiDeleteCategoryResponse, CategoriesApiDeleteCategoryError, Options<CategoriesApiDeleteCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await categoriesApiDeleteCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const categoriesApiGetCategoryQueryKey = (options: Options<CategoriesApiGetCategoryData>) => createQueryKey('categoriesApiGetCategory', options);

/**
 * Get Category
 *
 * Retrieve a single category by its UUID.
 *
 * Args:
 * request: The incoming HTTP request.
 * category_id: UUID of the category to retrieve.
 *
 * Returns:
 * The matching ``Category`` instance.
 *
 * Raises:
 * Http404: If no category with the given UUID exists.
 */
export const categoriesApiGetCategoryOptions = (options: Options<CategoriesApiGetCategoryData>) => queryOptions<CategoriesApiGetCategoryResponse, DefaultError, CategoriesApiGetCategoryResponse, ReturnType<typeof categoriesApiGetCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await categoriesApiGetCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: categoriesApiGetCategoryQueryKey(options)
});

/**
 * Update Category
 *
 * Partially update an existing category.
 *
 * Only fields present in the request body are updated
 * (PATCH semantics via ``exclude_unset``).
 *
 * Args:
 * request: The incoming HTTP request.
 * category_id: UUID of the category to update.
 * payload: Partial category data to apply.
 *
 * Returns:
 * A tuple of ``(200, updated_category)`` on success, or
 * ``(409, error_detail)`` if a uniqueness constraint is
 * violated.
 *
 * Raises:
 * Http404: If no category with the given UUID exists.
 */
export const categoriesApiUpdateCategoryMutation = (options?: Partial<Options<CategoriesApiUpdateCategoryData>>): UseMutationOptions<CategoriesApiUpdateCategoryResponse, CategoriesApiUpdateCategoryError, Options<CategoriesApiUpdateCategoryData>> => {
    const mutationOptions: UseMutationOptions<CategoriesApiUpdateCategoryResponse, CategoriesApiUpdateCategoryError, Options<CategoriesApiUpdateCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await categoriesApiUpdateCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const storesApiStoreStatsQueryKey = (options?: Options<StoresApiStoreStatsData>) => createQueryKey('storesApiStoreStats', options);

/**
 * Store Stats
 *
 * Return aggregate store statistics, optionally scoped by a filter.
 */
export const storesApiStoreStatsOptions = (options?: Options<StoresApiStoreStatsData>) => queryOptions<StoresApiStoreStatsResponse, DefaultError, StoresApiStoreStatsResponse, ReturnType<typeof storesApiStoreStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await storesApiStoreStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storesApiStoreStatsQueryKey(options)
});

export const storesApiListSegmentsQueryKey = (options?: Options<StoresApiListSegmentsData>) => createQueryKey('storesApiListSegments', options);

/**
 * List Segments
 *
 * List store segment lookup values.
 *
 * When ``in_use=true``, only segments assigned to at least one
 * store are returned.
 */
export const storesApiListSegmentsOptions = (options?: Options<StoresApiListSegmentsData>) => queryOptions<StoresApiListSegmentsResponse, DefaultError, StoresApiListSegmentsResponse, ReturnType<typeof storesApiListSegmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await storesApiListSegments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storesApiListSegmentsQueryKey(options)
});

export const storesApiListStoreTypesQueryKey = (options?: Options<StoresApiListStoreTypesData>) => createQueryKey('storesApiListStoreTypes', options);

/**
 * List Store Types
 *
 * List store type lookup values.
 */
export const storesApiListStoreTypesOptions = (options?: Options<StoresApiListStoreTypesData>) => queryOptions<StoresApiListStoreTypesResponse, DefaultError, StoresApiListStoreTypesResponse, ReturnType<typeof storesApiListStoreTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await storesApiListStoreTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storesApiListStoreTypesQueryKey(options)
});

export const storesApiListStoreFormatsQueryKey = (options?: Options<StoresApiListStoreFormatsData>) => createQueryKey('storesApiListStoreFormats', options);

/**
 * List Store Formats
 *
 * List store format lookup values.
 */
export const storesApiListStoreFormatsOptions = (options?: Options<StoresApiListStoreFormatsData>) => queryOptions<StoresApiListStoreFormatsResponse, DefaultError, StoresApiListStoreFormatsResponse, ReturnType<typeof storesApiListStoreFormatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await storesApiListStoreFormats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storesApiListStoreFormatsQueryKey(options)
});

export const storesApiListRegionsQueryKey = (options?: Options<StoresApiListRegionsData>) => createQueryKey('storesApiListRegions', options);

/**
 * List Regions
 *
 * List regions assigned to at least one store.
 *
 * The "Region" filter in the Store List UI mirrors the table's
 * ``Region`` column, which is sourced from a store's direct
 * ``parent_hierarchy_node``. We therefore return distinct hierarchy
 * nodes that are referenced by at least one ``Store.parent_hierarchy_node``
 * — regardless of which level they live at in the hierarchy tree.
 */
export const storesApiListRegionsOptions = (options?: Options<StoresApiListRegionsData>) => queryOptions<StoresApiListRegionsResponse, DefaultError, StoresApiListRegionsResponse, ReturnType<typeof storesApiListRegionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await storesApiListRegions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storesApiListRegionsQueryKey(options)
});

export const storesApiListBannersQueryKey = (options?: Options<StoresApiListBannersData>) => createQueryKey('storesApiListBanners', options);

/**
 * List Banners
 *
 * List banners assigned to at least one store.
 */
export const storesApiListBannersOptions = (options?: Options<StoresApiListBannersData>) => queryOptions<StoresApiListBannersResponse, DefaultError, StoresApiListBannersResponse, ReturnType<typeof storesApiListBannersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await storesApiListBanners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storesApiListBannersQueryKey(options)
});

export const storesApiListStoreGroupsQueryKey = (options?: Options<StoresApiListStoreGroupsData>) => createQueryKey('storesApiListStoreGroups', options);

/**
 * List Store Groups
 *
 * List store groups for the scope picker.
 */
export const storesApiListStoreGroupsOptions = (options?: Options<StoresApiListStoreGroupsData>) => queryOptions<StoresApiListStoreGroupsResponse, DefaultError, StoresApiListStoreGroupsResponse, ReturnType<typeof storesApiListStoreGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await storesApiListStoreGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storesApiListStoreGroupsQueryKey(options)
});

export const storesApiListStatesQueryKey = (options?: Options<StoresApiListStatesData>) => createQueryKey('storesApiListStates', options);

/**
 * List States
 *
 * List distinct state values across all stores.
 */
export const storesApiListStatesOptions = (options?: Options<StoresApiListStatesData>) => queryOptions<StoresApiListStatesResponse, DefaultError, StoresApiListStatesResponse, ReturnType<typeof storesApiListStatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await storesApiListStates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storesApiListStatesQueryKey(options)
});

export const storesApiListStoresQueryKey = (options?: Options<StoresApiListStoresData>) => createQueryKey('storesApiListStores', options);

/**
 * List Stores
 *
 * List stores with search, filtering, and pagination.
 */
export const storesApiListStoresOptions = (options?: Options<StoresApiListStoresData>) => queryOptions<StoresApiListStoresResponse, DefaultError, StoresApiListStoresResponse, ReturnType<typeof storesApiListStoresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await storesApiListStores({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storesApiListStoresQueryKey(options)
});

export const storesApiListStoresInfiniteQueryKey = (options?: Options<StoresApiListStoresData>): QueryKey<Options<StoresApiListStoresData>> => createQueryKey('storesApiListStores', options, true);

/**
 * List Stores
 *
 * List stores with search, filtering, and pagination.
 */
export const storesApiListStoresInfiniteOptions = (options?: Options<StoresApiListStoresData>) => infiniteQueryOptions<StoresApiListStoresResponse, DefaultError, InfiniteData<StoresApiListStoresResponse>, QueryKey<Options<StoresApiListStoresData>>, number | Pick<QueryKey<Options<StoresApiListStoresData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<StoresApiListStoresData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await storesApiListStores({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storesApiListStoresInfiniteQueryKey(options)
});

/**
 * Create Store
 *
 * Create a new store.
 */
export const storesApiCreateStoreMutation = (options?: Partial<Options<StoresApiCreateStoreData>>): UseMutationOptions<StoresApiCreateStoreResponse, StoresApiCreateStoreError, Options<StoresApiCreateStoreData>> => {
    const mutationOptions: UseMutationOptions<StoresApiCreateStoreResponse, StoresApiCreateStoreError, Options<StoresApiCreateStoreData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await storesApiCreateStore({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Store
 *
 * Delete a store.
 */
export const storesApiDeleteStoreMutation = (options?: Partial<Options<StoresApiDeleteStoreData>>): UseMutationOptions<StoresApiDeleteStoreResponse, DefaultError, Options<StoresApiDeleteStoreData>> => {
    const mutationOptions: UseMutationOptions<StoresApiDeleteStoreResponse, DefaultError, Options<StoresApiDeleteStoreData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await storesApiDeleteStore({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const storesApiGetStoreQueryKey = (options: Options<StoresApiGetStoreData>) => createQueryKey('storesApiGetStore', options);

/**
 * Get Store
 *
 * Retrieve a single store by ID.
 */
export const storesApiGetStoreOptions = (options: Options<StoresApiGetStoreData>) => queryOptions<StoresApiGetStoreResponse, DefaultError, StoresApiGetStoreResponse, ReturnType<typeof storesApiGetStoreQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await storesApiGetStore({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storesApiGetStoreQueryKey(options)
});

/**
 * Update Store
 *
 * Partially update a store.
 */
export const storesApiUpdateStoreMutation = (options?: Partial<Options<StoresApiUpdateStoreData>>): UseMutationOptions<StoresApiUpdateStoreResponse, StoresApiUpdateStoreError, Options<StoresApiUpdateStoreData>> => {
    const mutationOptions: UseMutationOptions<StoresApiUpdateStoreResponse, StoresApiUpdateStoreError, Options<StoresApiUpdateStoreData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await storesApiUpdateStore({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const employeesApiEmployeeStatsQueryKey = (options?: Options<EmployeesApiEmployeeStatsData>) => createQueryKey('employeesApiEmployeeStats', options);

/**
 * Employee Stats
 */
export const employeesApiEmployeeStatsOptions = (options?: Options<EmployeesApiEmployeeStatsData>) => queryOptions<EmployeesApiEmployeeStatsResponse, DefaultError, EmployeesApiEmployeeStatsResponse, ReturnType<typeof employeesApiEmployeeStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await employeesApiEmployeeStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: employeesApiEmployeeStatsQueryKey(options)
});

export const employeesApiListEmploymentTypesQueryKey = (options?: Options<EmployeesApiListEmploymentTypesData>) => createQueryKey('employeesApiListEmploymentTypes', options);

/**
 * List Employment Types
 *
 * List selectable employment types for the employee create/edit form.
 */
export const employeesApiListEmploymentTypesOptions = (options?: Options<EmployeesApiListEmploymentTypesData>) => queryOptions<EmployeesApiListEmploymentTypesResponse, DefaultError, EmployeesApiListEmploymentTypesResponse, ReturnType<typeof employeesApiListEmploymentTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await employeesApiListEmploymentTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: employeesApiListEmploymentTypesQueryKey(options)
});

export const employeesApiListEmployeeRolesQueryKey = (options?: Options<EmployeesApiListEmployeeRolesData>) => createQueryKey('employeesApiListEmployeeRoles', options);

/**
 * List Employee Roles
 *
 * List selectable employee roles for the employee create/edit form.
 */
export const employeesApiListEmployeeRolesOptions = (options?: Options<EmployeesApiListEmployeeRolesData>) => queryOptions<EmployeesApiListEmployeeRolesResponse, DefaultError, EmployeesApiListEmployeeRolesResponse, ReturnType<typeof employeesApiListEmployeeRolesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await employeesApiListEmployeeRoles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: employeesApiListEmployeeRolesQueryKey(options)
});

export const employeesApiListEmployeesQueryKey = (options?: Options<EmployeesApiListEmployeesData>) => createQueryKey('employeesApiListEmployees', options);

/**
 * List Employees
 */
export const employeesApiListEmployeesOptions = (options?: Options<EmployeesApiListEmployeesData>) => queryOptions<EmployeesApiListEmployeesResponse, DefaultError, EmployeesApiListEmployeesResponse, ReturnType<typeof employeesApiListEmployeesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await employeesApiListEmployees({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: employeesApiListEmployeesQueryKey(options)
});

export const employeesApiListEmployeesInfiniteQueryKey = (options?: Options<EmployeesApiListEmployeesData>): QueryKey<Options<EmployeesApiListEmployeesData>> => createQueryKey('employeesApiListEmployees', options, true);

/**
 * List Employees
 */
export const employeesApiListEmployeesInfiniteOptions = (options?: Options<EmployeesApiListEmployeesData>) => infiniteQueryOptions<EmployeesApiListEmployeesResponse, DefaultError, InfiniteData<EmployeesApiListEmployeesResponse>, QueryKey<Options<EmployeesApiListEmployeesData>>, number | Pick<QueryKey<Options<EmployeesApiListEmployeesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<EmployeesApiListEmployeesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await employeesApiListEmployees({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: employeesApiListEmployeesInfiniteQueryKey(options)
});

/**
 * Create Employee
 */
export const employeesApiCreateEmployeeMutation = (options?: Partial<Options<EmployeesApiCreateEmployeeData>>): UseMutationOptions<EmployeesApiCreateEmployeeResponse, EmployeesApiCreateEmployeeError, Options<EmployeesApiCreateEmployeeData>> => {
    const mutationOptions: UseMutationOptions<EmployeesApiCreateEmployeeResponse, EmployeesApiCreateEmployeeError, Options<EmployeesApiCreateEmployeeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await employeesApiCreateEmployee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Employee
 */
export const employeesApiDeleteEmployeeMutation = (options?: Partial<Options<EmployeesApiDeleteEmployeeData>>): UseMutationOptions<EmployeesApiDeleteEmployeeResponse, EmployeesApiDeleteEmployeeError, Options<EmployeesApiDeleteEmployeeData>> => {
    const mutationOptions: UseMutationOptions<EmployeesApiDeleteEmployeeResponse, EmployeesApiDeleteEmployeeError, Options<EmployeesApiDeleteEmployeeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await employeesApiDeleteEmployee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const employeesApiGetEmployeeQueryKey = (options: Options<EmployeesApiGetEmployeeData>) => createQueryKey('employeesApiGetEmployee', options);

/**
 * Get Employee
 */
export const employeesApiGetEmployeeOptions = (options: Options<EmployeesApiGetEmployeeData>) => queryOptions<EmployeesApiGetEmployeeResponse, DefaultError, EmployeesApiGetEmployeeResponse, ReturnType<typeof employeesApiGetEmployeeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await employeesApiGetEmployee({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: employeesApiGetEmployeeQueryKey(options)
});

/**
 * Update Employee
 */
export const employeesApiUpdateEmployeeMutation = (options?: Partial<Options<EmployeesApiUpdateEmployeeData>>): UseMutationOptions<EmployeesApiUpdateEmployeeResponse, EmployeesApiUpdateEmployeeError, Options<EmployeesApiUpdateEmployeeData>> => {
    const mutationOptions: UseMutationOptions<EmployeesApiUpdateEmployeeResponse, EmployeesApiUpdateEmployeeError, Options<EmployeesApiUpdateEmployeeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await employeesApiUpdateEmployee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mobileApiListWorkItemBaysQueryKey = (options: Options<MobileApiListWorkItemBaysData>) => createQueryKey('mobileApiListWorkItemBays', options);

/**
 * List Work Item Bays
 */
export const mobileApiListWorkItemBaysOptions = (options: Options<MobileApiListWorkItemBaysData>) => queryOptions<MobileApiListWorkItemBaysResponse, MobileApiListWorkItemBaysError, MobileApiListWorkItemBaysResponse, ReturnType<typeof mobileApiListWorkItemBaysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mobileApiListWorkItemBays({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mobileApiListWorkItemBaysQueryKey(options)
});

/**
 * Validate Work Order Location
 */
export const mobileApiValidateWorkOrderLocationMutation = (options?: Partial<Options<MobileApiValidateWorkOrderLocationData>>): UseMutationOptions<MobileApiValidateWorkOrderLocationResponse, MobileApiValidateWorkOrderLocationError, Options<MobileApiValidateWorkOrderLocationData>> => {
    const mutationOptions: UseMutationOptions<MobileApiValidateWorkOrderLocationResponse, MobileApiValidateWorkOrderLocationError, Options<MobileApiValidateWorkOrderLocationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mobileApiValidateWorkOrderLocation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Work Order Visit
 */
export const mobileApiStartWorkOrderVisitMutation = (options?: Partial<Options<MobileApiStartWorkOrderVisitData>>): UseMutationOptions<MobileApiStartWorkOrderVisitResponse, MobileApiStartWorkOrderVisitError, Options<MobileApiStartWorkOrderVisitData>> => {
    const mutationOptions: UseMutationOptions<MobileApiStartWorkOrderVisitResponse, MobileApiStartWorkOrderVisitError, Options<MobileApiStartWorkOrderVisitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mobileApiStartWorkOrderVisit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Work Order Nici Task
 */
export const mobileApiStartWorkOrderNiciTaskMutation = (options?: Partial<Options<MobileApiStartWorkOrderNiciTaskData>>): UseMutationOptions<MobileApiStartWorkOrderNiciTaskResponse, MobileApiStartWorkOrderNiciTaskError, Options<MobileApiStartWorkOrderNiciTaskData>> => {
    const mutationOptions: UseMutationOptions<MobileApiStartWorkOrderNiciTaskResponse, MobileApiStartWorkOrderNiciTaskError, Options<MobileApiStartWorkOrderNiciTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mobileApiStartWorkOrderNiciTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit Work Order Nici Scan
 */
export const mobileApiSubmitWorkOrderNiciScanMutation = (options?: Partial<Options<MobileApiSubmitWorkOrderNiciScanData>>): UseMutationOptions<MobileApiSubmitWorkOrderNiciScanResponse, MobileApiSubmitWorkOrderNiciScanError, Options<MobileApiSubmitWorkOrderNiciScanData>> => {
    const mutationOptions: UseMutationOptions<MobileApiSubmitWorkOrderNiciScanResponse, MobileApiSubmitWorkOrderNiciScanError, Options<MobileApiSubmitWorkOrderNiciScanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mobileApiSubmitWorkOrderNiciScan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stop Work Order Nici Task
 */
export const mobileApiStopWorkOrderNiciTaskMutation = (options?: Partial<Options<MobileApiStopWorkOrderNiciTaskData>>): UseMutationOptions<MobileApiStopWorkOrderNiciTaskResponse, MobileApiStopWorkOrderNiciTaskError, Options<MobileApiStopWorkOrderNiciTaskData>> => {
    const mutationOptions: UseMutationOptions<MobileApiStopWorkOrderNiciTaskResponse, MobileApiStopWorkOrderNiciTaskError, Options<MobileApiStopWorkOrderNiciTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mobileApiStopWorkOrderNiciTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Work Item Task
 */
export const mobileApiStartWorkItemTaskMutation = (options?: Partial<Options<MobileApiStartWorkItemTaskData>>): UseMutationOptions<MobileApiStartWorkItemTaskResponse, DefaultError, Options<MobileApiStartWorkItemTaskData>> => {
    const mutationOptions: UseMutationOptions<MobileApiStartWorkItemTaskResponse, DefaultError, Options<MobileApiStartWorkItemTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mobileApiStartWorkItemTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mobileApiGetCompletionSummaryQueryKey = (options: Options<MobileApiGetCompletionSummaryData>) => createQueryKey('mobileApiGetCompletionSummary', options);

/**
 * Get Completion Summary
 */
export const mobileApiGetCompletionSummaryOptions = (options: Options<MobileApiGetCompletionSummaryData>) => queryOptions<MobileApiGetCompletionSummaryResponse, MobileApiGetCompletionSummaryError, MobileApiGetCompletionSummaryResponse, ReturnType<typeof mobileApiGetCompletionSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mobileApiGetCompletionSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mobileApiGetCompletionSummaryQueryKey(options)
});

/**
 * Complete Work Item Task
 */
export const mobileApiCompleteWorkItemTaskMutation = (options?: Partial<Options<MobileApiCompleteWorkItemTaskData>>): UseMutationOptions<MobileApiCompleteWorkItemTaskResponse, DefaultError, Options<MobileApiCompleteWorkItemTaskData>> => {
    const mutationOptions: UseMutationOptions<MobileApiCompleteWorkItemTaskResponse, DefaultError, Options<MobileApiCompleteWorkItemTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mobileApiCompleteWorkItemTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const productsProductsApiProductStatsQueryKey = (options?: Options<ProductsProductsApiProductStatsData>) => createQueryKey('productsProductsApiProductStats', options);

/**
 * Product Stats
 *
 * Return aggregated product statistics.
 *
 * Accepts the same filter params as the list endpoint so the
 * summary cards reflect the current filter state.
 *
 * Returns:
 * Dictionary with total SKU count, new-item count,
 * and distinct category count.
 */
export const productsProductsApiProductStatsOptions = (options?: Options<ProductsProductsApiProductStatsData>) => queryOptions<ProductsProductsApiProductStatsResponse, DefaultError, ProductsProductsApiProductStatsResponse, ReturnType<typeof productsProductsApiProductStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsProductsApiProductStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsProductsApiProductStatsQueryKey(options)
});

export const productsProductsApiListBrandsQueryKey = (options?: Options<ProductsProductsApiListBrandsData>) => createQueryKey('productsProductsApiListBrands', options);

/**
 * List Brands
 *
 * Return brands that have at least one product.
 */
export const productsProductsApiListBrandsOptions = (options?: Options<ProductsProductsApiListBrandsData>) => queryOptions<ProductsProductsApiListBrandsResponse, DefaultError, ProductsProductsApiListBrandsResponse, ReturnType<typeof productsProductsApiListBrandsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsProductsApiListBrands({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsProductsApiListBrandsQueryKey(options)
});

export const productsProductsApiListProductsQueryKey = (options?: Options<ProductsProductsApiListProductsData>) => createQueryKey('productsProductsApiListProducts', options);

/**
 * List Products
 *
 * Return a paginated list of products.
 *
 * Args:
 * request: The incoming HTTP request.
 * search: Optional search term applied against barcode,
 * name, and brand.
 * category_id: Optional filter by category UUID.
 * brand_id: Optional filter by brand UUID.
 * page: Page number (1-indexed).
 * page_size: Number of items per page.
 *
 * Returns:
 * Paginated response with ``count``, ``next``, ``previous``,
 * and ``results`` keys.
 */
export const productsProductsApiListProductsOptions = (options?: Options<ProductsProductsApiListProductsData>) => queryOptions<ProductsProductsApiListProductsResponse, DefaultError, ProductsProductsApiListProductsResponse, ReturnType<typeof productsProductsApiListProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsProductsApiListProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsProductsApiListProductsQueryKey(options)
});

export const productsProductsApiListProductsInfiniteQueryKey = (options?: Options<ProductsProductsApiListProductsData>): QueryKey<Options<ProductsProductsApiListProductsData>> => createQueryKey('productsProductsApiListProducts', options, true);

/**
 * List Products
 *
 * Return a paginated list of products.
 *
 * Args:
 * request: The incoming HTTP request.
 * search: Optional search term applied against barcode,
 * name, and brand.
 * category_id: Optional filter by category UUID.
 * brand_id: Optional filter by brand UUID.
 * page: Page number (1-indexed).
 * page_size: Number of items per page.
 *
 * Returns:
 * Paginated response with ``count``, ``next``, ``previous``,
 * and ``results`` keys.
 */
export const productsProductsApiListProductsInfiniteOptions = (options?: Options<ProductsProductsApiListProductsData>) => infiniteQueryOptions<ProductsProductsApiListProductsResponse, DefaultError, InfiniteData<ProductsProductsApiListProductsResponse>, QueryKey<Options<ProductsProductsApiListProductsData>>, number | Pick<QueryKey<Options<ProductsProductsApiListProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProductsProductsApiListProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await productsProductsApiListProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsProductsApiListProductsInfiniteQueryKey(options)
});

/**
 * Create Product
 *
 * Create a new product.
 *
 * Args:
 * request: The incoming HTTP request.
 * payload: Product data to create.
 *
 * Returns:
 * Tuple of ``(201, product)`` on success or
 * ``(409, error_dict)`` on integrity violation.
 */
export const productsProductsApiCreateProductMutation = (options?: Partial<Options<ProductsProductsApiCreateProductData>>): UseMutationOptions<ProductsProductsApiCreateProductResponse, ProductsProductsApiCreateProductError, Options<ProductsProductsApiCreateProductData>> => {
    const mutationOptions: UseMutationOptions<ProductsProductsApiCreateProductResponse, ProductsProductsApiCreateProductError, Options<ProductsProductsApiCreateProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsProductsApiCreateProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Product
 *
 * Delete a product by ID.
 *
 * Args:
 * request: The incoming HTTP request.
 * product_id: UUID of the product to delete.
 *
 * Returns:
 * Tuple of ``(204, None)`` on successful deletion.
 */
export const productsProductsApiDeleteProductMutation = (options?: Partial<Options<ProductsProductsApiDeleteProductData>>): UseMutationOptions<ProductsProductsApiDeleteProductResponse, DefaultError, Options<ProductsProductsApiDeleteProductData>> => {
    const mutationOptions: UseMutationOptions<ProductsProductsApiDeleteProductResponse, DefaultError, Options<ProductsProductsApiDeleteProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsProductsApiDeleteProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const productsProductsApiGetProductQueryKey = (options: Options<ProductsProductsApiGetProductData>) => createQueryKey('productsProductsApiGetProduct', options);

/**
 * Get Product
 *
 * Retrieve a single product by ID.
 *
 * Args:
 * request: The incoming HTTP request.
 * product_id: UUID of the product to retrieve.
 *
 * Returns:
 * The matching product instance.
 */
export const productsProductsApiGetProductOptions = (options: Options<ProductsProductsApiGetProductData>) => queryOptions<ProductsProductsApiGetProductResponse, DefaultError, ProductsProductsApiGetProductResponse, ReturnType<typeof productsProductsApiGetProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await productsProductsApiGetProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: productsProductsApiGetProductQueryKey(options)
});

/**
 * Update Product
 *
 * Partially update a product.
 *
 * Only fields present in the request body are applied.
 *
 * Args:
 * request: The incoming HTTP request.
 * product_id: UUID of the product to update.
 * payload: Partial product data to apply.
 *
 * Returns:
 * Tuple of ``(200, product)`` on success or
 * ``(409, error_dict)`` on integrity violation.
 */
export const productsProductsApiUpdateProductMutation = (options?: Partial<Options<ProductsProductsApiUpdateProductData>>): UseMutationOptions<ProductsProductsApiUpdateProductResponse, ProductsProductsApiUpdateProductError, Options<ProductsProductsApiUpdateProductData>> => {
    const mutationOptions: UseMutationOptions<ProductsProductsApiUpdateProductResponse, ProductsProductsApiUpdateProductError, Options<ProductsProductsApiUpdateProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsProductsApiUpdateProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Product Image
 *
 * Upload an image for a product.
 *
 * Validates file type (JPG/PNG), size (max 10 MB), and gallery
 * capacity (max 5 per product). The first uploaded image is set
 * as primary automatically.
 *
 * Args:
 * request: The incoming HTTP request.
 * product_id: UUID of the product to attach the image to.
 * file: Multipart file upload.
 *
 * Returns:
 * Tuple of ``(201, ProductImageOut)`` on success or
 * ``(400, error_dict)`` on validation failure.
 */
export const productsProductsApiUploadProductImageMutation = (options?: Partial<Options<ProductsProductsApiUploadProductImageData>>): UseMutationOptions<ProductsProductsApiUploadProductImageResponse, ProductsProductsApiUploadProductImageError, Options<ProductsProductsApiUploadProductImageData>> => {
    const mutationOptions: UseMutationOptions<ProductsProductsApiUploadProductImageResponse, ProductsProductsApiUploadProductImageError, Options<ProductsProductsApiUploadProductImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsProductsApiUploadProductImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Product Image
 *
 * Delete a single product image.
 *
 * Reorders remaining images so positions stay contiguous. If the
 * deleted image was primary, promotes the new position-0 image
 * to primary.
 *
 * Args:
 * request: The incoming HTTP request.
 * image_id: UUID of the image to delete.
 *
 * Returns:
 * Tuple of ``(204, None)`` on successful deletion.
 */
export const productsProductsApiDeleteProductImageMutation = (options?: Partial<Options<ProductsProductsApiDeleteProductImageData>>): UseMutationOptions<ProductsProductsApiDeleteProductImageResponse, DefaultError, Options<ProductsProductsApiDeleteProductImageData>> => {
    const mutationOptions: UseMutationOptions<ProductsProductsApiDeleteProductImageResponse, DefaultError, Options<ProductsProductsApiDeleteProductImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsProductsApiDeleteProductImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Primary Product Image
 *
 * Promote an image to be the primary for its product.
 *
 * Clears the ``is_primary`` flag on any other image of the same
 * product, then sets it on the target image. Positions are
 * unchanged.
 *
 * Args:
 * request: The incoming HTTP request.
 * image_id: UUID of the image to promote.
 *
 * Returns:
 * Tuple of ``(200, ProductImageOut)`` for the promoted image.
 */
export const productsProductsApiSetPrimaryProductImageMutation = (options?: Partial<Options<ProductsProductsApiSetPrimaryProductImageData>>): UseMutationOptions<ProductsProductsApiSetPrimaryProductImageResponse, ProductsProductsApiSetPrimaryProductImageError, Options<ProductsProductsApiSetPrimaryProductImageData>> => {
    const mutationOptions: UseMutationOptions<ProductsProductsApiSetPrimaryProductImageResponse, ProductsProductsApiSetPrimaryProductImageError, Options<ProductsProductsApiSetPrimaryProductImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await productsProductsApiSetPrimaryProductImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const planogramsApiPlanogramsPlanogramStatsQueryKey = (options?: Options<PlanogramsApiPlanogramsPlanogramStatsData>) => createQueryKey('planogramsApiPlanogramsPlanogramStats', options);

/**
 * Planogram Stats
 */
export const planogramsApiPlanogramsPlanogramStatsOptions = (options?: Options<PlanogramsApiPlanogramsPlanogramStatsData>) => queryOptions<PlanogramsApiPlanogramsPlanogramStatsResponse, DefaultError, PlanogramsApiPlanogramsPlanogramStatsResponse, ReturnType<typeof planogramsApiPlanogramsPlanogramStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planogramsApiPlanogramsPlanogramStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planogramsApiPlanogramsPlanogramStatsQueryKey(options)
});

export const planogramsApiPlanogramsListPlanogramsQueryKey = (options?: Options<PlanogramsApiPlanogramsListPlanogramsData>) => createQueryKey('planogramsApiPlanogramsListPlanograms', options);

/**
 * List Planograms
 */
export const planogramsApiPlanogramsListPlanogramsOptions = (options?: Options<PlanogramsApiPlanogramsListPlanogramsData>) => queryOptions<PlanogramsApiPlanogramsListPlanogramsResponse, DefaultError, PlanogramsApiPlanogramsListPlanogramsResponse, ReturnType<typeof planogramsApiPlanogramsListPlanogramsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planogramsApiPlanogramsListPlanograms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planogramsApiPlanogramsListPlanogramsQueryKey(options)
});

export const planogramsApiPlanogramsListPlanogramsInfiniteQueryKey = (options?: Options<PlanogramsApiPlanogramsListPlanogramsData>): QueryKey<Options<PlanogramsApiPlanogramsListPlanogramsData>> => createQueryKey('planogramsApiPlanogramsListPlanograms', options, true);

/**
 * List Planograms
 */
export const planogramsApiPlanogramsListPlanogramsInfiniteOptions = (options?: Options<PlanogramsApiPlanogramsListPlanogramsData>) => infiniteQueryOptions<PlanogramsApiPlanogramsListPlanogramsResponse, DefaultError, InfiniteData<PlanogramsApiPlanogramsListPlanogramsResponse>, QueryKey<Options<PlanogramsApiPlanogramsListPlanogramsData>>, number | Pick<QueryKey<Options<PlanogramsApiPlanogramsListPlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<PlanogramsApiPlanogramsListPlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await planogramsApiPlanogramsListPlanograms({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planogramsApiPlanogramsListPlanogramsInfiniteQueryKey(options)
});

/**
 * Create Planogram
 */
export const planogramsApiPlanogramsCreatePlanogramMutation = (options?: Partial<Options<PlanogramsApiPlanogramsCreatePlanogramData>>): UseMutationOptions<PlanogramsApiPlanogramsCreatePlanogramResponse, PlanogramsApiPlanogramsCreatePlanogramError, Options<PlanogramsApiPlanogramsCreatePlanogramData>> => {
    const mutationOptions: UseMutationOptions<PlanogramsApiPlanogramsCreatePlanogramResponse, PlanogramsApiPlanogramsCreatePlanogramError, Options<PlanogramsApiPlanogramsCreatePlanogramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await planogramsApiPlanogramsCreatePlanogram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Planogram
 */
export const planogramsApiPlanogramsDeletePlanogramMutation = (options?: Partial<Options<PlanogramsApiPlanogramsDeletePlanogramData>>): UseMutationOptions<PlanogramsApiPlanogramsDeletePlanogramResponse, PlanogramsApiPlanogramsDeletePlanogramError, Options<PlanogramsApiPlanogramsDeletePlanogramData>> => {
    const mutationOptions: UseMutationOptions<PlanogramsApiPlanogramsDeletePlanogramResponse, PlanogramsApiPlanogramsDeletePlanogramError, Options<PlanogramsApiPlanogramsDeletePlanogramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await planogramsApiPlanogramsDeletePlanogram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const planogramsApiPlanogramsGetPlanogramQueryKey = (options: Options<PlanogramsApiPlanogramsGetPlanogramData>) => createQueryKey('planogramsApiPlanogramsGetPlanogram', options);

/**
 * Get Planogram
 */
export const planogramsApiPlanogramsGetPlanogramOptions = (options: Options<PlanogramsApiPlanogramsGetPlanogramData>) => queryOptions<PlanogramsApiPlanogramsGetPlanogramResponse, DefaultError, PlanogramsApiPlanogramsGetPlanogramResponse, ReturnType<typeof planogramsApiPlanogramsGetPlanogramQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planogramsApiPlanogramsGetPlanogram({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planogramsApiPlanogramsGetPlanogramQueryKey(options)
});

/**
 * Update Planogram
 */
export const planogramsApiPlanogramsUpdatePlanogramMutation = (options?: Partial<Options<PlanogramsApiPlanogramsUpdatePlanogramData>>): UseMutationOptions<PlanogramsApiPlanogramsUpdatePlanogramResponse, PlanogramsApiPlanogramsUpdatePlanogramError, Options<PlanogramsApiPlanogramsUpdatePlanogramData>> => {
    const mutationOptions: UseMutationOptions<PlanogramsApiPlanogramsUpdatePlanogramResponse, PlanogramsApiPlanogramsUpdatePlanogramError, Options<PlanogramsApiPlanogramsUpdatePlanogramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await planogramsApiPlanogramsUpdatePlanogram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const planogramsApiPlanogramsGetPlanogramDetailsQueryKey = (options: Options<PlanogramsApiPlanogramsGetPlanogramDetailsData>) => createQueryKey('planogramsApiPlanogramsGetPlanogramDetails', options);

/**
 * Get Planogram Details
 */
export const planogramsApiPlanogramsGetPlanogramDetailsOptions = (options: Options<PlanogramsApiPlanogramsGetPlanogramDetailsData>) => queryOptions<PlanogramsApiPlanogramsGetPlanogramDetailsResponse, DefaultError, PlanogramsApiPlanogramsGetPlanogramDetailsResponse, ReturnType<typeof planogramsApiPlanogramsGetPlanogramDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planogramsApiPlanogramsGetPlanogramDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planogramsApiPlanogramsGetPlanogramDetailsQueryKey(options)
});

export const planogramsApiPositionsListPlanogramPositionsQueryKey = (options: Options<PlanogramsApiPositionsListPlanogramPositionsData>) => createQueryKey('planogramsApiPositionsListPlanogramPositions', options);

/**
 * List Planogram Positions
 */
export const planogramsApiPositionsListPlanogramPositionsOptions = (options: Options<PlanogramsApiPositionsListPlanogramPositionsData>) => queryOptions<PlanogramsApiPositionsListPlanogramPositionsResponse, DefaultError, PlanogramsApiPositionsListPlanogramPositionsResponse, ReturnType<typeof planogramsApiPositionsListPlanogramPositionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planogramsApiPositionsListPlanogramPositions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planogramsApiPositionsListPlanogramPositionsQueryKey(options)
});

export const planogramsApiVersionsListVersionsQueryKey = (options: Options<PlanogramsApiVersionsListVersionsData>) => createQueryKey('planogramsApiVersionsListVersions', options);

/**
 * List Versions
 */
export const planogramsApiVersionsListVersionsOptions = (options: Options<PlanogramsApiVersionsListVersionsData>) => queryOptions<PlanogramsApiVersionsListVersionsResponse, DefaultError, PlanogramsApiVersionsListVersionsResponse, ReturnType<typeof planogramsApiVersionsListVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planogramsApiVersionsListVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planogramsApiVersionsListVersionsQueryKey(options)
});

export const planogramsApiVersionsListVersionsInfiniteQueryKey = (options: Options<PlanogramsApiVersionsListVersionsData>): QueryKey<Options<PlanogramsApiVersionsListVersionsData>> => createQueryKey('planogramsApiVersionsListVersions', options, true);

/**
 * List Versions
 */
export const planogramsApiVersionsListVersionsInfiniteOptions = (options: Options<PlanogramsApiVersionsListVersionsData>) => infiniteQueryOptions<PlanogramsApiVersionsListVersionsResponse, DefaultError, InfiniteData<PlanogramsApiVersionsListVersionsResponse>, QueryKey<Options<PlanogramsApiVersionsListVersionsData>>, number | Pick<QueryKey<Options<PlanogramsApiVersionsListVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<PlanogramsApiVersionsListVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await planogramsApiVersionsListVersions({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planogramsApiVersionsListVersionsInfiniteQueryKey(options)
});

/**
 * Publish
 *
 * Publish a ready draft as an immutable Published Future version.
 *
 * Every failure carries its reason, because §11 asks the user to be
 * told why a publication was refused and given the chance to retry.
 */
export const planogramsApiVersionsPublishMutation = (options?: Partial<Options<PlanogramsApiVersionsPublishData>>): UseMutationOptions<PlanogramsApiVersionsPublishResponse, PlanogramsApiVersionsPublishError, Options<PlanogramsApiVersionsPublishData>> => {
    const mutationOptions: UseMutationOptions<PlanogramsApiVersionsPublishResponse, PlanogramsApiVersionsPublishError, Options<PlanogramsApiVersionsPublishData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await planogramsApiVersionsPublish({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const planogramsApiVersionsStoreReachQueryKey = (options: Options<PlanogramsApiVersionsStoreReachData>) => createQueryKey('planogramsApiVersionsStoreReach', options);

/**
 * Store Reach
 *
 * The stores a publish would affect, for the Publish Review step.
 *
 * Declared before ``/{version_id}`` so the literal path wins over the
 * UUID parameter.
 */
export const planogramsApiVersionsStoreReachOptions = (options: Options<PlanogramsApiVersionsStoreReachData>) => queryOptions<PlanogramsApiVersionsStoreReachResponse, DefaultError, PlanogramsApiVersionsStoreReachResponse, ReturnType<typeof planogramsApiVersionsStoreReachQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planogramsApiVersionsStoreReach({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planogramsApiVersionsStoreReachQueryKey(options)
});

export const planogramsApiVersionsGetVersionQueryKey = (options: Options<PlanogramsApiVersionsGetVersionData>) => createQueryKey('planogramsApiVersionsGetVersion', options);

/**
 * Get Version
 */
export const planogramsApiVersionsGetVersionOptions = (options: Options<PlanogramsApiVersionsGetVersionData>) => queryOptions<PlanogramsApiVersionsGetVersionResponse, DefaultError, PlanogramsApiVersionsGetVersionResponse, ReturnType<typeof planogramsApiVersionsGetVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planogramsApiVersionsGetVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planogramsApiVersionsGetVersionQueryKey(options)
});

export const planogramsApiVisualizationGetVisualizationQueryKey = (options?: Options<PlanogramsApiVisualizationGetVisualizationData>) => createQueryKey('planogramsApiVisualizationGetVisualization', options);

/**
 * Get Visualization
 */
export const planogramsApiVisualizationGetVisualizationOptions = (options?: Options<PlanogramsApiVisualizationGetVisualizationData>) => queryOptions<PlanogramsApiVisualizationGetVisualizationResponse, PlanogramsApiVisualizationGetVisualizationError, PlanogramsApiVisualizationGetVisualizationResponse, ReturnType<typeof planogramsApiVisualizationGetVisualizationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planogramsApiVisualizationGetVisualization({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planogramsApiVisualizationGetVisualizationQueryKey(options)
});

export const rulesApiRuleStatsQueryKey = (options?: Options<RulesApiRuleStatsData>) => createQueryKey('rulesApiRuleStats', options);

/**
 * Rule Stats
 *
 * Return aggregate policy rule statistics.
 */
export const rulesApiRuleStatsOptions = (options?: Options<RulesApiRuleStatsData>) => queryOptions<RulesApiRuleStatsResponse, DefaultError, RulesApiRuleStatsResponse, ReturnType<typeof rulesApiRuleStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rulesApiRuleStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rulesApiRuleStatsQueryKey(options)
});

export const rulesApiListRulesQueryKey = (options?: Options<RulesApiListRulesData>) => createQueryKey('rulesApiListRules', options);

/**
 * List Rules
 *
 * List policy rules with search, filtering, and pagination.
 */
export const rulesApiListRulesOptions = (options?: Options<RulesApiListRulesData>) => queryOptions<RulesApiListRulesResponse, DefaultError, RulesApiListRulesResponse, ReturnType<typeof rulesApiListRulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rulesApiListRules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rulesApiListRulesQueryKey(options)
});

export const rulesApiListRulesInfiniteQueryKey = (options?: Options<RulesApiListRulesData>): QueryKey<Options<RulesApiListRulesData>> => createQueryKey('rulesApiListRules', options, true);

/**
 * List Rules
 *
 * List policy rules with search, filtering, and pagination.
 */
export const rulesApiListRulesInfiniteOptions = (options?: Options<RulesApiListRulesData>) => infiniteQueryOptions<RulesApiListRulesResponse, DefaultError, InfiniteData<RulesApiListRulesResponse>, QueryKey<Options<RulesApiListRulesData>>, number | Pick<QueryKey<Options<RulesApiListRulesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<RulesApiListRulesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await rulesApiListRules({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rulesApiListRulesInfiniteQueryKey(options)
});

/**
 * Create Rule
 *
 * Create a new policy rule.
 */
export const rulesApiCreateRuleMutation = (options?: Partial<Options<RulesApiCreateRuleData>>): UseMutationOptions<RulesApiCreateRuleResponse, RulesApiCreateRuleError, Options<RulesApiCreateRuleData>> => {
    const mutationOptions: UseMutationOptions<RulesApiCreateRuleResponse, RulesApiCreateRuleError, Options<RulesApiCreateRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rulesApiCreateRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Rule
 *
 * Delete a policy rule.
 */
export const rulesApiDeleteRuleMutation = (options?: Partial<Options<RulesApiDeleteRuleData>>): UseMutationOptions<RulesApiDeleteRuleResponse, DefaultError, Options<RulesApiDeleteRuleData>> => {
    const mutationOptions: UseMutationOptions<RulesApiDeleteRuleResponse, DefaultError, Options<RulesApiDeleteRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rulesApiDeleteRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rulesApiGetRuleQueryKey = (options: Options<RulesApiGetRuleData>) => createQueryKey('rulesApiGetRule', options);

/**
 * Get Rule
 *
 * Retrieve a single policy rule by ID.
 */
export const rulesApiGetRuleOptions = (options: Options<RulesApiGetRuleData>) => queryOptions<RulesApiGetRuleResponse, DefaultError, RulesApiGetRuleResponse, ReturnType<typeof rulesApiGetRuleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rulesApiGetRule({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rulesApiGetRuleQueryKey(options)
});

/**
 * Update Rule
 *
 * Partially update a policy rule.
 */
export const rulesApiUpdateRuleMutation = (options?: Partial<Options<RulesApiUpdateRuleData>>): UseMutationOptions<RulesApiUpdateRuleResponse, RulesApiUpdateRuleError, Options<RulesApiUpdateRuleData>> => {
    const mutationOptions: UseMutationOptions<RulesApiUpdateRuleResponse, RulesApiUpdateRuleError, Options<RulesApiUpdateRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rulesApiUpdateRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const suppliersApiListSuppliersQueryKey = (options?: Options<SuppliersApiListSuppliersData>) => createQueryKey('suppliersApiListSuppliers', options);

/**
 * List Suppliers
 *
 * Return all suppliers ordered by name.
 */
export const suppliersApiListSuppliersOptions = (options?: Options<SuppliersApiListSuppliersData>) => queryOptions<SuppliersApiListSuppliersResponse, DefaultError, SuppliersApiListSuppliersResponse, ReturnType<typeof suppliersApiListSuppliersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suppliersApiListSuppliers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suppliersApiListSuppliersQueryKey(options)
});

export const mappingsApiStoreCategoriesStoreCategoryStatsQueryKey = (options?: Options<MappingsApiStoreCategoriesStoreCategoryStatsData>) => createQueryKey('mappingsApiStoreCategoriesStoreCategoryStats', options);

/**
 * Store Category Stats
 */
export const mappingsApiStoreCategoriesStoreCategoryStatsOptions = (options?: Options<MappingsApiStoreCategoriesStoreCategoryStatsData>) => queryOptions<MappingsApiStoreCategoriesStoreCategoryStatsResponse, DefaultError, MappingsApiStoreCategoriesStoreCategoryStatsResponse, ReturnType<typeof mappingsApiStoreCategoriesStoreCategoryStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiStoreCategoriesStoreCategoryStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStoreCategoriesStoreCategoryStatsQueryKey(options)
});

export const mappingsApiStoreCategoriesListStoreCategoriesQueryKey = (options?: Options<MappingsApiStoreCategoriesListStoreCategoriesData>) => createQueryKey('mappingsApiStoreCategoriesListStoreCategories', options);

/**
 * List Store Categories
 */
export const mappingsApiStoreCategoriesListStoreCategoriesOptions = (options?: Options<MappingsApiStoreCategoriesListStoreCategoriesData>) => queryOptions<MappingsApiStoreCategoriesListStoreCategoriesResponse, DefaultError, MappingsApiStoreCategoriesListStoreCategoriesResponse, ReturnType<typeof mappingsApiStoreCategoriesListStoreCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiStoreCategoriesListStoreCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStoreCategoriesListStoreCategoriesQueryKey(options)
});

export const mappingsApiStoreCategoriesListStoreCategoriesInfiniteQueryKey = (options?: Options<MappingsApiStoreCategoriesListStoreCategoriesData>): QueryKey<Options<MappingsApiStoreCategoriesListStoreCategoriesData>> => createQueryKey('mappingsApiStoreCategoriesListStoreCategories', options, true);

/**
 * List Store Categories
 */
export const mappingsApiStoreCategoriesListStoreCategoriesInfiniteOptions = (options?: Options<MappingsApiStoreCategoriesListStoreCategoriesData>) => infiniteQueryOptions<MappingsApiStoreCategoriesListStoreCategoriesResponse, DefaultError, InfiniteData<MappingsApiStoreCategoriesListStoreCategoriesResponse>, QueryKey<Options<MappingsApiStoreCategoriesListStoreCategoriesData>>, number | Pick<QueryKey<Options<MappingsApiStoreCategoriesListStoreCategoriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MappingsApiStoreCategoriesListStoreCategoriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mappingsApiStoreCategoriesListStoreCategories({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStoreCategoriesListStoreCategoriesInfiniteQueryKey(options)
});

/**
 * Create Store Category
 */
export const mappingsApiStoreCategoriesCreateStoreCategoryMutation = (options?: Partial<Options<MappingsApiStoreCategoriesCreateStoreCategoryData>>): UseMutationOptions<MappingsApiStoreCategoriesCreateStoreCategoryResponse, MappingsApiStoreCategoriesCreateStoreCategoryError, Options<MappingsApiStoreCategoriesCreateStoreCategoryData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiStoreCategoriesCreateStoreCategoryResponse, MappingsApiStoreCategoriesCreateStoreCategoryError, Options<MappingsApiStoreCategoriesCreateStoreCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiStoreCategoriesCreateStoreCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Store Category
 */
export const mappingsApiStoreCategoriesDeleteStoreCategoryMutation = (options?: Partial<Options<MappingsApiStoreCategoriesDeleteStoreCategoryData>>): UseMutationOptions<MappingsApiStoreCategoriesDeleteStoreCategoryResponse, DefaultError, Options<MappingsApiStoreCategoriesDeleteStoreCategoryData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiStoreCategoriesDeleteStoreCategoryResponse, DefaultError, Options<MappingsApiStoreCategoriesDeleteStoreCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiStoreCategoriesDeleteStoreCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mappingsApiStoreCategoriesGetStoreCategoryQueryKey = (options: Options<MappingsApiStoreCategoriesGetStoreCategoryData>) => createQueryKey('mappingsApiStoreCategoriesGetStoreCategory', options);

/**
 * Get Store Category
 */
export const mappingsApiStoreCategoriesGetStoreCategoryOptions = (options: Options<MappingsApiStoreCategoriesGetStoreCategoryData>) => queryOptions<MappingsApiStoreCategoriesGetStoreCategoryResponse, DefaultError, MappingsApiStoreCategoriesGetStoreCategoryResponse, ReturnType<typeof mappingsApiStoreCategoriesGetStoreCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiStoreCategoriesGetStoreCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStoreCategoriesGetStoreCategoryQueryKey(options)
});

/**
 * Update Store Category
 */
export const mappingsApiStoreCategoriesUpdateStoreCategoryMutation = (options?: Partial<Options<MappingsApiStoreCategoriesUpdateStoreCategoryData>>): UseMutationOptions<MappingsApiStoreCategoriesUpdateStoreCategoryResponse, MappingsApiStoreCategoriesUpdateStoreCategoryError, Options<MappingsApiStoreCategoriesUpdateStoreCategoryData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiStoreCategoriesUpdateStoreCategoryResponse, MappingsApiStoreCategoriesUpdateStoreCategoryError, Options<MappingsApiStoreCategoriesUpdateStoreCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiStoreCategoriesUpdateStoreCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mappingsApiStorePlanogramsStorePlanogramStatsQueryKey = (options?: Options<MappingsApiStorePlanogramsStorePlanogramStatsData>) => createQueryKey('mappingsApiStorePlanogramsStorePlanogramStats', options);

/**
 * Store Planogram Stats
 */
export const mappingsApiStorePlanogramsStorePlanogramStatsOptions = (options?: Options<MappingsApiStorePlanogramsStorePlanogramStatsData>) => queryOptions<MappingsApiStorePlanogramsStorePlanogramStatsResponse, DefaultError, MappingsApiStorePlanogramsStorePlanogramStatsResponse, ReturnType<typeof mappingsApiStorePlanogramsStorePlanogramStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiStorePlanogramsStorePlanogramStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStorePlanogramsStorePlanogramStatsQueryKey(options)
});

export const mappingsApiStorePlanogramsStorePlanogramGroupStatsQueryKey = (options?: Options<MappingsApiStorePlanogramsStorePlanogramGroupStatsData>) => createQueryKey('mappingsApiStorePlanogramsStorePlanogramGroupStats', options);

/**
 * Store Planogram Group Stats
 */
export const mappingsApiStorePlanogramsStorePlanogramGroupStatsOptions = (options?: Options<MappingsApiStorePlanogramsStorePlanogramGroupStatsData>) => queryOptions<MappingsApiStorePlanogramsStorePlanogramGroupStatsResponse, DefaultError, MappingsApiStorePlanogramsStorePlanogramGroupStatsResponse, ReturnType<typeof mappingsApiStorePlanogramsStorePlanogramGroupStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiStorePlanogramsStorePlanogramGroupStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStorePlanogramsStorePlanogramGroupStatsQueryKey(options)
});

export const mappingsApiStorePlanogramsListStorePlanogramGroupsQueryKey = (options?: Options<MappingsApiStorePlanogramsListStorePlanogramGroupsData>) => createQueryKey('mappingsApiStorePlanogramsListStorePlanogramGroups', options);

/**
 * List Store Planogram Groups
 */
export const mappingsApiStorePlanogramsListStorePlanogramGroupsOptions = (options?: Options<MappingsApiStorePlanogramsListStorePlanogramGroupsData>) => queryOptions<MappingsApiStorePlanogramsListStorePlanogramGroupsResponse, DefaultError, MappingsApiStorePlanogramsListStorePlanogramGroupsResponse, ReturnType<typeof mappingsApiStorePlanogramsListStorePlanogramGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiStorePlanogramsListStorePlanogramGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStorePlanogramsListStorePlanogramGroupsQueryKey(options)
});

export const mappingsApiStorePlanogramsListStorePlanogramGroupsInfiniteQueryKey = (options?: Options<MappingsApiStorePlanogramsListStorePlanogramGroupsData>): QueryKey<Options<MappingsApiStorePlanogramsListStorePlanogramGroupsData>> => createQueryKey('mappingsApiStorePlanogramsListStorePlanogramGroups', options, true);

/**
 * List Store Planogram Groups
 */
export const mappingsApiStorePlanogramsListStorePlanogramGroupsInfiniteOptions = (options?: Options<MappingsApiStorePlanogramsListStorePlanogramGroupsData>) => infiniteQueryOptions<MappingsApiStorePlanogramsListStorePlanogramGroupsResponse, DefaultError, InfiniteData<MappingsApiStorePlanogramsListStorePlanogramGroupsResponse>, QueryKey<Options<MappingsApiStorePlanogramsListStorePlanogramGroupsData>>, number | Pick<QueryKey<Options<MappingsApiStorePlanogramsListStorePlanogramGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MappingsApiStorePlanogramsListStorePlanogramGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mappingsApiStorePlanogramsListStorePlanogramGroups({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStorePlanogramsListStorePlanogramGroupsInfiniteQueryKey(options)
});

export const mappingsApiStorePlanogramsListStorePlanogramsQueryKey = (options?: Options<MappingsApiStorePlanogramsListStorePlanogramsData>) => createQueryKey('mappingsApiStorePlanogramsListStorePlanograms', options);

/**
 * List Store Planograms
 */
export const mappingsApiStorePlanogramsListStorePlanogramsOptions = (options?: Options<MappingsApiStorePlanogramsListStorePlanogramsData>) => queryOptions<MappingsApiStorePlanogramsListStorePlanogramsResponse, DefaultError, MappingsApiStorePlanogramsListStorePlanogramsResponse, ReturnType<typeof mappingsApiStorePlanogramsListStorePlanogramsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiStorePlanogramsListStorePlanograms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStorePlanogramsListStorePlanogramsQueryKey(options)
});

export const mappingsApiStorePlanogramsListStorePlanogramsInfiniteQueryKey = (options?: Options<MappingsApiStorePlanogramsListStorePlanogramsData>): QueryKey<Options<MappingsApiStorePlanogramsListStorePlanogramsData>> => createQueryKey('mappingsApiStorePlanogramsListStorePlanograms', options, true);

/**
 * List Store Planograms
 */
export const mappingsApiStorePlanogramsListStorePlanogramsInfiniteOptions = (options?: Options<MappingsApiStorePlanogramsListStorePlanogramsData>) => infiniteQueryOptions<MappingsApiStorePlanogramsListStorePlanogramsResponse, DefaultError, InfiniteData<MappingsApiStorePlanogramsListStorePlanogramsResponse>, QueryKey<Options<MappingsApiStorePlanogramsListStorePlanogramsData>>, number | Pick<QueryKey<Options<MappingsApiStorePlanogramsListStorePlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MappingsApiStorePlanogramsListStorePlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mappingsApiStorePlanogramsListStorePlanograms({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStorePlanogramsListStorePlanogramsInfiniteQueryKey(options)
});

/**
 * Create Store Planogram
 */
export const mappingsApiStorePlanogramsCreateStorePlanogramMutation = (options?: Partial<Options<MappingsApiStorePlanogramsCreateStorePlanogramData>>): UseMutationOptions<MappingsApiStorePlanogramsCreateStorePlanogramResponse, MappingsApiStorePlanogramsCreateStorePlanogramError, Options<MappingsApiStorePlanogramsCreateStorePlanogramData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiStorePlanogramsCreateStorePlanogramResponse, MappingsApiStorePlanogramsCreateStorePlanogramError, Options<MappingsApiStorePlanogramsCreateStorePlanogramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiStorePlanogramsCreateStorePlanogram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Store Planogram
 */
export const mappingsApiStorePlanogramsDeleteStorePlanogramMutation = (options?: Partial<Options<MappingsApiStorePlanogramsDeleteStorePlanogramData>>): UseMutationOptions<MappingsApiStorePlanogramsDeleteStorePlanogramResponse, MappingsApiStorePlanogramsDeleteStorePlanogramError, Options<MappingsApiStorePlanogramsDeleteStorePlanogramData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiStorePlanogramsDeleteStorePlanogramResponse, MappingsApiStorePlanogramsDeleteStorePlanogramError, Options<MappingsApiStorePlanogramsDeleteStorePlanogramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiStorePlanogramsDeleteStorePlanogram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mappingsApiStorePlanogramsGetStorePlanogramQueryKey = (options: Options<MappingsApiStorePlanogramsGetStorePlanogramData>) => createQueryKey('mappingsApiStorePlanogramsGetStorePlanogram', options);

/**
 * Get Store Planogram
 */
export const mappingsApiStorePlanogramsGetStorePlanogramOptions = (options: Options<MappingsApiStorePlanogramsGetStorePlanogramData>) => queryOptions<MappingsApiStorePlanogramsGetStorePlanogramResponse, DefaultError, MappingsApiStorePlanogramsGetStorePlanogramResponse, ReturnType<typeof mappingsApiStorePlanogramsGetStorePlanogramQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiStorePlanogramsGetStorePlanogram({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStorePlanogramsGetStorePlanogramQueryKey(options)
});

/**
 * Update Store Planogram
 */
export const mappingsApiStorePlanogramsUpdateStorePlanogramMutation = (options?: Partial<Options<MappingsApiStorePlanogramsUpdateStorePlanogramData>>): UseMutationOptions<MappingsApiStorePlanogramsUpdateStorePlanogramResponse, MappingsApiStorePlanogramsUpdateStorePlanogramError, Options<MappingsApiStorePlanogramsUpdateStorePlanogramData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiStorePlanogramsUpdateStorePlanogramResponse, MappingsApiStorePlanogramsUpdateStorePlanogramError, Options<MappingsApiStorePlanogramsUpdateStorePlanogramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiStorePlanogramsUpdateStorePlanogram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mappingsApiStoreProductsStoreProductStatsQueryKey = (options?: Options<MappingsApiStoreProductsStoreProductStatsData>) => createQueryKey('mappingsApiStoreProductsStoreProductStats', options);

/**
 * Store Product Stats
 */
export const mappingsApiStoreProductsStoreProductStatsOptions = (options?: Options<MappingsApiStoreProductsStoreProductStatsData>) => queryOptions<MappingsApiStoreProductsStoreProductStatsResponse, DefaultError, MappingsApiStoreProductsStoreProductStatsResponse, ReturnType<typeof mappingsApiStoreProductsStoreProductStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiStoreProductsStoreProductStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStoreProductsStoreProductStatsQueryKey(options)
});

export const mappingsApiStoreProductsListStoreProductsQueryKey = (options?: Options<MappingsApiStoreProductsListStoreProductsData>) => createQueryKey('mappingsApiStoreProductsListStoreProducts', options);

/**
 * List Store Products
 */
export const mappingsApiStoreProductsListStoreProductsOptions = (options?: Options<MappingsApiStoreProductsListStoreProductsData>) => queryOptions<MappingsApiStoreProductsListStoreProductsResponse, DefaultError, MappingsApiStoreProductsListStoreProductsResponse, ReturnType<typeof mappingsApiStoreProductsListStoreProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiStoreProductsListStoreProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStoreProductsListStoreProductsQueryKey(options)
});

export const mappingsApiStoreProductsListStoreProductsInfiniteQueryKey = (options?: Options<MappingsApiStoreProductsListStoreProductsData>): QueryKey<Options<MappingsApiStoreProductsListStoreProductsData>> => createQueryKey('mappingsApiStoreProductsListStoreProducts', options, true);

/**
 * List Store Products
 */
export const mappingsApiStoreProductsListStoreProductsInfiniteOptions = (options?: Options<MappingsApiStoreProductsListStoreProductsData>) => infiniteQueryOptions<MappingsApiStoreProductsListStoreProductsResponse, DefaultError, InfiniteData<MappingsApiStoreProductsListStoreProductsResponse>, QueryKey<Options<MappingsApiStoreProductsListStoreProductsData>>, number | Pick<QueryKey<Options<MappingsApiStoreProductsListStoreProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MappingsApiStoreProductsListStoreProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mappingsApiStoreProductsListStoreProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStoreProductsListStoreProductsInfiniteQueryKey(options)
});

/**
 * Create Store Product
 */
export const mappingsApiStoreProductsCreateStoreProductMutation = (options?: Partial<Options<MappingsApiStoreProductsCreateStoreProductData>>): UseMutationOptions<MappingsApiStoreProductsCreateStoreProductResponse, MappingsApiStoreProductsCreateStoreProductError, Options<MappingsApiStoreProductsCreateStoreProductData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiStoreProductsCreateStoreProductResponse, MappingsApiStoreProductsCreateStoreProductError, Options<MappingsApiStoreProductsCreateStoreProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiStoreProductsCreateStoreProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Store Product
 *
 * Deauthorize a listing.
 *
 * A soft delete since the assortment went soft-deletable, and for a
 * NEW listing it closes the NICI obligation as WITHDRAWN and
 * cancels the unfinished work against it. The endpoint itself does
 * nothing for that beyond calling ``delete()`` — the model's policy
 * and the receivers behind it carry the meaning.
 */
export const mappingsApiStoreProductsDeleteStoreProductMutation = (options?: Partial<Options<MappingsApiStoreProductsDeleteStoreProductData>>): UseMutationOptions<MappingsApiStoreProductsDeleteStoreProductResponse, DefaultError, Options<MappingsApiStoreProductsDeleteStoreProductData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiStoreProductsDeleteStoreProductResponse, DefaultError, Options<MappingsApiStoreProductsDeleteStoreProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiStoreProductsDeleteStoreProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mappingsApiStoreProductsGetStoreProductQueryKey = (options: Options<MappingsApiStoreProductsGetStoreProductData>) => createQueryKey('mappingsApiStoreProductsGetStoreProduct', options);

/**
 * Get Store Product
 */
export const mappingsApiStoreProductsGetStoreProductOptions = (options: Options<MappingsApiStoreProductsGetStoreProductData>) => queryOptions<MappingsApiStoreProductsGetStoreProductResponse, DefaultError, MappingsApiStoreProductsGetStoreProductResponse, ReturnType<typeof mappingsApiStoreProductsGetStoreProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiStoreProductsGetStoreProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiStoreProductsGetStoreProductQueryKey(options)
});

/**
 * Update Store Product
 */
export const mappingsApiStoreProductsUpdateStoreProductMutation = (options?: Partial<Options<MappingsApiStoreProductsUpdateStoreProductData>>): UseMutationOptions<MappingsApiStoreProductsUpdateStoreProductResponse, MappingsApiStoreProductsUpdateStoreProductError, Options<MappingsApiStoreProductsUpdateStoreProductData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiStoreProductsUpdateStoreProductResponse, MappingsApiStoreProductsUpdateStoreProductError, Options<MappingsApiStoreProductsUpdateStoreProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiStoreProductsUpdateStoreProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsQueryKey = (options?: Options<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData>) => createQueryKey('mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignments', options);

/**
 * List Employee Store Assignments
 */
export const mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsOptions = (options?: Options<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData>) => queryOptions<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsResponse, DefaultError, MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsResponse, ReturnType<typeof mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsQueryKey(options)
});

export const mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsInfiniteQueryKey = (options?: Options<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData>): QueryKey<Options<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData>> => createQueryKey('mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignments', options, true);

/**
 * List Employee Store Assignments
 */
export const mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsInfiniteOptions = (options?: Options<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData>) => infiniteQueryOptions<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsResponse, DefaultError, InfiniteData<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsResponse>, QueryKey<Options<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData>>, number | Pick<QueryKey<Options<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignments({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsInfiniteQueryKey(options)
});

/**
 * Create Employee Store Assignment
 */
export const mappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentMutation = (options?: Partial<Options<MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentData>>): UseMutationOptions<MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentResponse, MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentError, Options<MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentResponse, MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentError, Options<MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsQueryKey = (options?: Options<MappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsData>) => createQueryKey('mappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStats', options);

/**
 * Employee Store Assignment Stats
 */
export const mappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsOptions = (options?: Options<MappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsData>) => queryOptions<MappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsResponse, DefaultError, MappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsResponse, ReturnType<typeof mappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsQueryKey(options)
});

export const mappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentQueryKey = (options: Options<MappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentData>) => createQueryKey('mappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignment', options);

/**
 * Get Employee Store Assignment
 */
export const mappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentOptions = (options: Options<MappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentData>) => queryOptions<MappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentResponse, DefaultError, MappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentResponse, ReturnType<typeof mappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentQueryKey(options)
});

/**
 * Update Employee Store Assignment
 */
export const mappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentMutation = (options?: Partial<Options<MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentData>>): UseMutationOptions<MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentResponse, MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentError, Options<MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentResponse, MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentError, Options<MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mappingsApiWorkingGroupsListWorkingGroupsQueryKey = (options?: Options<MappingsApiWorkingGroupsListWorkingGroupsData>) => createQueryKey('mappingsApiWorkingGroupsListWorkingGroups', options);

/**
 * List Working Groups
 */
export const mappingsApiWorkingGroupsListWorkingGroupsOptions = (options?: Options<MappingsApiWorkingGroupsListWorkingGroupsData>) => queryOptions<MappingsApiWorkingGroupsListWorkingGroupsResponse, DefaultError, MappingsApiWorkingGroupsListWorkingGroupsResponse, ReturnType<typeof mappingsApiWorkingGroupsListWorkingGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiWorkingGroupsListWorkingGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiWorkingGroupsListWorkingGroupsQueryKey(options)
});

export const mappingsApiWorkingGroupsListWorkingGroupsInfiniteQueryKey = (options?: Options<MappingsApiWorkingGroupsListWorkingGroupsData>): QueryKey<Options<MappingsApiWorkingGroupsListWorkingGroupsData>> => createQueryKey('mappingsApiWorkingGroupsListWorkingGroups', options, true);

/**
 * List Working Groups
 */
export const mappingsApiWorkingGroupsListWorkingGroupsInfiniteOptions = (options?: Options<MappingsApiWorkingGroupsListWorkingGroupsData>) => infiniteQueryOptions<MappingsApiWorkingGroupsListWorkingGroupsResponse, DefaultError, InfiniteData<MappingsApiWorkingGroupsListWorkingGroupsResponse>, QueryKey<Options<MappingsApiWorkingGroupsListWorkingGroupsData>>, number | Pick<QueryKey<Options<MappingsApiWorkingGroupsListWorkingGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MappingsApiWorkingGroupsListWorkingGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mappingsApiWorkingGroupsListWorkingGroups({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiWorkingGroupsListWorkingGroupsInfiniteQueryKey(options)
});

/**
 * Create Working Group
 */
export const mappingsApiWorkingGroupsCreateWorkingGroupMutation = (options?: Partial<Options<MappingsApiWorkingGroupsCreateWorkingGroupData>>): UseMutationOptions<MappingsApiWorkingGroupsCreateWorkingGroupResponse, MappingsApiWorkingGroupsCreateWorkingGroupError, Options<MappingsApiWorkingGroupsCreateWorkingGroupData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiWorkingGroupsCreateWorkingGroupResponse, MappingsApiWorkingGroupsCreateWorkingGroupError, Options<MappingsApiWorkingGroupsCreateWorkingGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiWorkingGroupsCreateWorkingGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mappingsApiWorkingGroupsWorkingGroupStatsQueryKey = (options?: Options<MappingsApiWorkingGroupsWorkingGroupStatsData>) => createQueryKey('mappingsApiWorkingGroupsWorkingGroupStats', options);

/**
 * Working Group Stats
 */
export const mappingsApiWorkingGroupsWorkingGroupStatsOptions = (options?: Options<MappingsApiWorkingGroupsWorkingGroupStatsData>) => queryOptions<MappingsApiWorkingGroupsWorkingGroupStatsResponse, DefaultError, MappingsApiWorkingGroupsWorkingGroupStatsResponse, ReturnType<typeof mappingsApiWorkingGroupsWorkingGroupStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiWorkingGroupsWorkingGroupStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiWorkingGroupsWorkingGroupStatsQueryKey(options)
});

export const mappingsApiWorkingGroupsGetWorkingGroupQueryKey = (options: Options<MappingsApiWorkingGroupsGetWorkingGroupData>) => createQueryKey('mappingsApiWorkingGroupsGetWorkingGroup', options);

/**
 * Get Working Group
 */
export const mappingsApiWorkingGroupsGetWorkingGroupOptions = (options: Options<MappingsApiWorkingGroupsGetWorkingGroupData>) => queryOptions<MappingsApiWorkingGroupsGetWorkingGroupResponse, DefaultError, MappingsApiWorkingGroupsGetWorkingGroupResponse, ReturnType<typeof mappingsApiWorkingGroupsGetWorkingGroupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mappingsApiWorkingGroupsGetWorkingGroup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mappingsApiWorkingGroupsGetWorkingGroupQueryKey(options)
});

/**
 * Update Working Group
 */
export const mappingsApiWorkingGroupsUpdateWorkingGroupMutation = (options?: Partial<Options<MappingsApiWorkingGroupsUpdateWorkingGroupData>>): UseMutationOptions<MappingsApiWorkingGroupsUpdateWorkingGroupResponse, MappingsApiWorkingGroupsUpdateWorkingGroupError, Options<MappingsApiWorkingGroupsUpdateWorkingGroupData>> => {
    const mutationOptions: UseMutationOptions<MappingsApiWorkingGroupsUpdateWorkingGroupResponse, MappingsApiWorkingGroupsUpdateWorkingGroupError, Options<MappingsApiWorkingGroupsUpdateWorkingGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mappingsApiWorkingGroupsUpdateWorkingGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const planningApiResetCalendarResetCycleStatsQueryKey = (options?: Options<PlanningApiResetCalendarResetCycleStatsData>) => createQueryKey('planningApiResetCalendarResetCycleStats', options);

/**
 * Reset Cycle Stats
 */
export const planningApiResetCalendarResetCycleStatsOptions = (options?: Options<PlanningApiResetCalendarResetCycleStatsData>) => queryOptions<PlanningApiResetCalendarResetCycleStatsResponse, DefaultError, PlanningApiResetCalendarResetCycleStatsResponse, ReturnType<typeof planningApiResetCalendarResetCycleStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planningApiResetCalendarResetCycleStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planningApiResetCalendarResetCycleStatsQueryKey(options)
});

export const planningApiResetCalendarListResetCyclesQueryKey = (options?: Options<PlanningApiResetCalendarListResetCyclesData>) => createQueryKey('planningApiResetCalendarListResetCycles', options);

/**
 * List Reset Cycles
 */
export const planningApiResetCalendarListResetCyclesOptions = (options?: Options<PlanningApiResetCalendarListResetCyclesData>) => queryOptions<PlanningApiResetCalendarListResetCyclesResponse, DefaultError, PlanningApiResetCalendarListResetCyclesResponse, ReturnType<typeof planningApiResetCalendarListResetCyclesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planningApiResetCalendarListResetCycles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planningApiResetCalendarListResetCyclesQueryKey(options)
});

export const planningApiResetCalendarListResetCyclesInfiniteQueryKey = (options?: Options<PlanningApiResetCalendarListResetCyclesData>): QueryKey<Options<PlanningApiResetCalendarListResetCyclesData>> => createQueryKey('planningApiResetCalendarListResetCycles', options, true);

/**
 * List Reset Cycles
 */
export const planningApiResetCalendarListResetCyclesInfiniteOptions = (options?: Options<PlanningApiResetCalendarListResetCyclesData>) => infiniteQueryOptions<PlanningApiResetCalendarListResetCyclesResponse, DefaultError, InfiniteData<PlanningApiResetCalendarListResetCyclesResponse>, QueryKey<Options<PlanningApiResetCalendarListResetCyclesData>>, number | Pick<QueryKey<Options<PlanningApiResetCalendarListResetCyclesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<PlanningApiResetCalendarListResetCyclesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await planningApiResetCalendarListResetCycles({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planningApiResetCalendarListResetCyclesInfiniteQueryKey(options)
});

/**
 * Create Reset Cycle
 */
export const planningApiResetCalendarCreateResetCycleMutation = (options?: Partial<Options<PlanningApiResetCalendarCreateResetCycleData>>): UseMutationOptions<PlanningApiResetCalendarCreateResetCycleResponse, PlanningApiResetCalendarCreateResetCycleError, Options<PlanningApiResetCalendarCreateResetCycleData>> => {
    const mutationOptions: UseMutationOptions<PlanningApiResetCalendarCreateResetCycleResponse, PlanningApiResetCalendarCreateResetCycleError, Options<PlanningApiResetCalendarCreateResetCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await planningApiResetCalendarCreateResetCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Reset Cycle
 */
export const planningApiResetCalendarDeleteResetCycleMutation = (options?: Partial<Options<PlanningApiResetCalendarDeleteResetCycleData>>): UseMutationOptions<PlanningApiResetCalendarDeleteResetCycleResponse, DefaultError, Options<PlanningApiResetCalendarDeleteResetCycleData>> => {
    const mutationOptions: UseMutationOptions<PlanningApiResetCalendarDeleteResetCycleResponse, DefaultError, Options<PlanningApiResetCalendarDeleteResetCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await planningApiResetCalendarDeleteResetCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const planningApiResetCalendarGetResetCycleQueryKey = (options: Options<PlanningApiResetCalendarGetResetCycleData>) => createQueryKey('planningApiResetCalendarGetResetCycle', options);

/**
 * Get Reset Cycle
 */
export const planningApiResetCalendarGetResetCycleOptions = (options: Options<PlanningApiResetCalendarGetResetCycleData>) => queryOptions<PlanningApiResetCalendarGetResetCycleResponse, DefaultError, PlanningApiResetCalendarGetResetCycleResponse, ReturnType<typeof planningApiResetCalendarGetResetCycleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planningApiResetCalendarGetResetCycle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planningApiResetCalendarGetResetCycleQueryKey(options)
});

/**
 * Update Reset Cycle
 */
export const planningApiResetCalendarUpdateResetCycleMutation = (options?: Partial<Options<PlanningApiResetCalendarUpdateResetCycleData>>): UseMutationOptions<PlanningApiResetCalendarUpdateResetCycleResponse, PlanningApiResetCalendarUpdateResetCycleError, Options<PlanningApiResetCalendarUpdateResetCycleData>> => {
    const mutationOptions: UseMutationOptions<PlanningApiResetCalendarUpdateResetCycleResponse, PlanningApiResetCalendarUpdateResetCycleError, Options<PlanningApiResetCalendarUpdateResetCycleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await planningApiResetCalendarUpdateResetCycle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const planningApiNiciNiciStatsQueryKey = (options?: Options<PlanningApiNiciNiciStatsData>) => createQueryKey('planningApiNiciNiciStats', options);

/**
 * Nici Stats
 */
export const planningApiNiciNiciStatsOptions = (options?: Options<PlanningApiNiciNiciStatsData>) => queryOptions<PlanningApiNiciNiciStatsResponse, DefaultError, PlanningApiNiciNiciStatsResponse, ReturnType<typeof planningApiNiciNiciStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planningApiNiciNiciStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planningApiNiciNiciStatsQueryKey(options)
});

export const planningApiNiciListNiciQueryKey = (options?: Options<PlanningApiNiciListNiciData>) => createQueryKey('planningApiNiciListNici', options);

/**
 * List Nici
 */
export const planningApiNiciListNiciOptions = (options?: Options<PlanningApiNiciListNiciData>) => queryOptions<PlanningApiNiciListNiciResponse, PlanningApiNiciListNiciError, PlanningApiNiciListNiciResponse, ReturnType<typeof planningApiNiciListNiciQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planningApiNiciListNici({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planningApiNiciListNiciQueryKey(options)
});

export const planningApiNiciListNiciInfiniteQueryKey = (options?: Options<PlanningApiNiciListNiciData>): QueryKey<Options<PlanningApiNiciListNiciData>> => createQueryKey('planningApiNiciListNici', options, true);

/**
 * List Nici
 */
export const planningApiNiciListNiciInfiniteOptions = (options?: Options<PlanningApiNiciListNiciData>) => infiniteQueryOptions<PlanningApiNiciListNiciResponse, PlanningApiNiciListNiciError, InfiniteData<PlanningApiNiciListNiciResponse>, QueryKey<Options<PlanningApiNiciListNiciData>>, number | Pick<QueryKey<Options<PlanningApiNiciListNiciData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<PlanningApiNiciListNiciData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await planningApiNiciListNici({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planningApiNiciListNiciInfiniteQueryKey(options)
});

/**
 * Create Nici
 *
 * Bulk-create one listing per store in ``store_ids``.
 *
 * Overlap with an existing listing is reported per-store in ``conflicts``
 * rather than aborting the batch.
 */
export const planningApiNiciCreateNiciMutation = (options?: Partial<Options<PlanningApiNiciCreateNiciData>>): UseMutationOptions<PlanningApiNiciCreateNiciResponse, PlanningApiNiciCreateNiciError, Options<PlanningApiNiciCreateNiciData>> => {
    const mutationOptions: UseMutationOptions<PlanningApiNiciCreateNiciResponse, PlanningApiNiciCreateNiciError, Options<PlanningApiNiciCreateNiciData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await planningApiNiciCreateNici({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Nici
 *
 * Deauthorize a listing.
 *
 * A soft delete since the assortment went soft-deletable, and it
 * closes the listing's NICI obligation as WITHDRAWN and cancels
 * the unfinished work against it — which is what "the product is no
 * longer stocked here" has to mean operationally. The old 409 for a
 * listing with work items is gone: refusing was never the right
 * answer to "stop sending the crew", and ``PROTECT`` could not fire
 * any more anyway, the delete being an UPDATE now.
 */
export const planningApiNiciDeleteNiciMutation = (options?: Partial<Options<PlanningApiNiciDeleteNiciData>>): UseMutationOptions<PlanningApiNiciDeleteNiciResponse, DefaultError, Options<PlanningApiNiciDeleteNiciData>> => {
    const mutationOptions: UseMutationOptions<PlanningApiNiciDeleteNiciResponse, DefaultError, Options<PlanningApiNiciDeleteNiciData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await planningApiNiciDeleteNici({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const planningApiNiciGetNiciQueryKey = (options: Options<PlanningApiNiciGetNiciData>) => createQueryKey('planningApiNiciGetNici', options);

/**
 * Get Nici
 */
export const planningApiNiciGetNiciOptions = (options: Options<PlanningApiNiciGetNiciData>) => queryOptions<PlanningApiNiciGetNiciResponse, DefaultError, PlanningApiNiciGetNiciResponse, ReturnType<typeof planningApiNiciGetNiciQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await planningApiNiciGetNici({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: planningApiNiciGetNiciQueryKey(options)
});

/**
 * Update Nici
 */
export const planningApiNiciUpdateNiciMutation = (options?: Partial<Options<PlanningApiNiciUpdateNiciData>>): UseMutationOptions<PlanningApiNiciUpdateNiciResponse, PlanningApiNiciUpdateNiciError, Options<PlanningApiNiciUpdateNiciData>> => {
    const mutationOptions: UseMutationOptions<PlanningApiNiciUpdateNiciResponse, PlanningApiNiciUpdateNiciError, Options<PlanningApiNiciUpdateNiciData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await planningApiNiciUpdateNici({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request Upload
 *
 * Request a presigned upload form for direct file upload.
 */
export const storageApiRequestUploadMutation = (options?: Partial<Options<StorageApiRequestUploadData>>): UseMutationOptions<StorageApiRequestUploadResponse, DefaultError, Options<StorageApiRequestUploadData>> => {
    const mutationOptions: UseMutationOptions<StorageApiRequestUploadResponse, DefaultError, Options<StorageApiRequestUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await storageApiRequestUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Local Fs Upload
 *
 * Receives files posted by ``LocalMediaStorage.presign_upload_form()``
 * when no S3 bucket is configured (local development).
 *
 * Validates size and SHA-256 checksum against the values baked into
 * the presigned form, then saves the file to ``default_storage`` at
 * the provided ``path``. Returns 204 on success, 400 on mismatch,
 * 404 when ``default_storage`` is not ``LocalMediaStorage`` (e.g. in
 * production where uploads go directly to S3).
 */
export const storageApiLocalFsUploadMutation = (options?: Partial<Options<StorageApiLocalFsUploadData>>): UseMutationOptions<StorageApiLocalFsUploadResponse, StorageApiLocalFsUploadError, Options<StorageApiLocalFsUploadData>> => {
    const mutationOptions: UseMutationOptions<StorageApiLocalFsUploadResponse, StorageApiLocalFsUploadError, Options<StorageApiLocalFsUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await storageApiLocalFsUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const complianceApiGetActionItemsQueryKey = (options?: Options<ComplianceApiGetActionItemsData>) => createQueryKey('complianceApiGetActionItems', options);

/**
 * Get Action Items
 */
export const complianceApiGetActionItemsOptions = (options?: Options<ComplianceApiGetActionItemsData>) => queryOptions<ComplianceApiGetActionItemsResponse, DefaultError, ComplianceApiGetActionItemsResponse, ReturnType<typeof complianceApiGetActionItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await complianceApiGetActionItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: complianceApiGetActionItemsQueryKey(options)
});

export const complianceApiListProductActionsQueryKey = (options?: Options<ComplianceApiListProductActionsData>) => createQueryKey('complianceApiListProductActions', options);

/**
 * List Product Actions
 *
 * Return generated product actions for exactly one execution scope.
 *
 * A work-item scope keeps the RESET planogram behavior. A work-order
 * scope supports the informational discontinued-product list used by
 * NICI without changing product-action mutation behavior.
 *
 * Sorted by bay sequence, then display shelf number, then display
 * sequence — i.e. the natural reading order on the planogram.
 */
export const complianceApiListProductActionsOptions = (options?: Options<ComplianceApiListProductActionsData>) => queryOptions<ComplianceApiListProductActionsResponse, ComplianceApiListProductActionsError, ComplianceApiListProductActionsResponse, ReturnType<typeof complianceApiListProductActionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await complianceApiListProductActions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: complianceApiListProductActionsQueryKey(options)
});

export const complianceApiListProductActionsInfiniteQueryKey = (options?: Options<ComplianceApiListProductActionsData>): QueryKey<Options<ComplianceApiListProductActionsData>> => createQueryKey('complianceApiListProductActions', options, true);

/**
 * List Product Actions
 *
 * Return generated product actions for exactly one execution scope.
 *
 * A work-item scope keeps the RESET planogram behavior. A work-order
 * scope supports the informational discontinued-product list used by
 * NICI without changing product-action mutation behavior.
 *
 * Sorted by bay sequence, then display shelf number, then display
 * sequence — i.e. the natural reading order on the planogram.
 */
export const complianceApiListProductActionsInfiniteOptions = (options?: Options<ComplianceApiListProductActionsData>) => infiniteQueryOptions<ComplianceApiListProductActionsResponse, ComplianceApiListProductActionsError, InfiniteData<ComplianceApiListProductActionsResponse>, QueryKey<Options<ComplianceApiListProductActionsData>>, number | Pick<QueryKey<Options<ComplianceApiListProductActionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ComplianceApiListProductActionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await complianceApiListProductActions({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: complianceApiListProductActionsInfiniteQueryKey(options)
});

export const complianceApiGetProductActionsPostResetPhotoStateQueryKey = (options: Options<ComplianceApiGetProductActionsPostResetPhotoStateData>) => createQueryKey('complianceApiGetProductActionsPostResetPhotoState', options);

/**
 * Get Product Actions Post Reset Photo State
 */
export const complianceApiGetProductActionsPostResetPhotoStateOptions = (options: Options<ComplianceApiGetProductActionsPostResetPhotoStateData>) => queryOptions<ComplianceApiGetProductActionsPostResetPhotoStateResponse, ComplianceApiGetProductActionsPostResetPhotoStateError, ComplianceApiGetProductActionsPostResetPhotoStateResponse, ReturnType<typeof complianceApiGetProductActionsPostResetPhotoStateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await complianceApiGetProductActionsPostResetPhotoState({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: complianceApiGetProductActionsPostResetPhotoStateQueryKey(options)
});

/**
 * Update Product Action
 *
 * Set action_state to IDLE to undo a completion in the current active RESET task. The completion must be no more than five minutes old; submitted tasks cannot be changed.
 */
export const complianceApiUpdateProductActionMutation = (options?: Partial<Options<ComplianceApiUpdateProductActionData>>): UseMutationOptions<ComplianceApiUpdateProductActionResponse, ComplianceApiUpdateProductActionError, Options<ComplianceApiUpdateProductActionData>> => {
    const mutationOptions: UseMutationOptions<ComplianceApiUpdateProductActionResponse, ComplianceApiUpdateProductActionError, Options<ComplianceApiUpdateProductActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await complianceApiUpdateProductAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete Product Action
 *
 * Complete one product action. Use PERFORMED for the normal button and OOS_PRICE_TAG_PLACED only after the RESTOCK price-tag sheet is confirmed. Opening or cancelling that sheet sends no request. A 409 means the stored answer conflicts: reload the action and do not retry with a different outcome. Network retries must retain the original outcome. UI completion is action_state; its result label is completion_outcome. OOS remains status=MISSING and must not be returned as an unfinished task. After action reset, the backend cannot distinguish an old offline submission from a new command.
 */
export const complianceApiCompleteProductActionMutation = (options?: Partial<Options<ComplianceApiCompleteProductActionData>>): UseMutationOptions<ComplianceApiCompleteProductActionResponse, ComplianceApiCompleteProductActionError, Options<ComplianceApiCompleteProductActionData>> => {
    const mutationOptions: UseMutationOptions<ComplianceApiCompleteProductActionResponse, ComplianceApiCompleteProductActionError, Options<ComplianceApiCompleteProductActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await complianceApiCompleteProductAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Complete Product Actions
 */
export const complianceApiBulkCompleteProductActionsMutation = (options?: Partial<Options<ComplianceApiBulkCompleteProductActionsData>>): UseMutationOptions<ComplianceApiBulkCompleteProductActionsResponse, ComplianceApiBulkCompleteProductActionsError, Options<ComplianceApiBulkCompleteProductActionsData>> => {
    const mutationOptions: UseMutationOptions<ComplianceApiBulkCompleteProductActionsResponse, ComplianceApiBulkCompleteProductActionsError, Options<ComplianceApiBulkCompleteProductActionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await complianceApiBulkCompleteProductActions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const complianceApiListPogCategoryRatesQueryKey = (options?: Options<ComplianceApiListPogCategoryRatesData>) => createQueryKey('complianceApiListPogCategoryRates', options);

/**
 * List Pog Category Rates
 *
 * POG compliance per category. Unmeasured categories are omitted.
 */
export const complianceApiListPogCategoryRatesOptions = (options?: Options<ComplianceApiListPogCategoryRatesData>) => queryOptions<ComplianceApiListPogCategoryRatesResponse, DefaultError, ComplianceApiListPogCategoryRatesResponse, ReturnType<typeof complianceApiListPogCategoryRatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await complianceApiListPogCategoryRates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: complianceApiListPogCategoryRatesQueryKey(options)
});

export const complianceApiGetPogCategoryRateQueryKey = (options: Options<ComplianceApiGetPogCategoryRateData>) => createQueryKey('complianceApiGetPogCategoryRate', options);

/**
 * Get Pog Category Rate
 */
export const complianceApiGetPogCategoryRateOptions = (options: Options<ComplianceApiGetPogCategoryRateData>) => queryOptions<ComplianceApiGetPogCategoryRateResponse, DefaultError, ComplianceApiGetPogCategoryRateResponse, ReturnType<typeof complianceApiGetPogCategoryRateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await complianceApiGetPogCategoryRate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: complianceApiGetPogCategoryRateQueryKey(options)
});

export const complianceApiListPogStoreRatesQueryKey = (options: Options<ComplianceApiListPogStoreRatesData>) => createQueryKey('complianceApiListPogStoreRates', options);

/**
 * List Pog Store Rates
 *
 * Every store's latest compliance for one planogram.
 */
export const complianceApiListPogStoreRatesOptions = (options: Options<ComplianceApiListPogStoreRatesData>) => queryOptions<ComplianceApiListPogStoreRatesResponse, DefaultError, ComplianceApiListPogStoreRatesResponse, ReturnType<typeof complianceApiListPogStoreRatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await complianceApiListPogStoreRates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: complianceApiListPogStoreRatesQueryKey(options)
});

export const ingestionApiImportsListImportsQueryKey = (options?: Options<IngestionApiImportsListImportsData>) => createQueryKey('ingestionApiImportsListImports', options);

/**
 * List Imports
 */
export const ingestionApiImportsListImportsOptions = (options?: Options<IngestionApiImportsListImportsData>) => queryOptions<IngestionApiImportsListImportsResponse, DefaultError, IngestionApiImportsListImportsResponse, ReturnType<typeof ingestionApiImportsListImportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ingestionApiImportsListImports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ingestionApiImportsListImportsQueryKey(options)
});

export const ingestionApiImportsListImportsInfiniteQueryKey = (options?: Options<IngestionApiImportsListImportsData>): QueryKey<Options<IngestionApiImportsListImportsData>> => createQueryKey('ingestionApiImportsListImports', options, true);

/**
 * List Imports
 */
export const ingestionApiImportsListImportsInfiniteOptions = (options?: Options<IngestionApiImportsListImportsData>) => infiniteQueryOptions<IngestionApiImportsListImportsResponse, DefaultError, InfiniteData<IngestionApiImportsListImportsResponse>, QueryKey<Options<IngestionApiImportsListImportsData>>, number | Pick<QueryKey<Options<IngestionApiImportsListImportsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<IngestionApiImportsListImportsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await ingestionApiImportsListImports({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ingestionApiImportsListImportsInfiniteQueryKey(options)
});

/**
 * Create Import
 */
export const ingestionApiImportsCreateImportMutation = (options?: Partial<Options<IngestionApiImportsCreateImportData>>): UseMutationOptions<IngestionApiImportsCreateImportResponse, DefaultError, Options<IngestionApiImportsCreateImportData>> => {
    const mutationOptions: UseMutationOptions<IngestionApiImportsCreateImportResponse, DefaultError, Options<IngestionApiImportsCreateImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ingestionApiImportsCreateImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Import
 */
export const ingestionApiImportsApproveImportMutation = (options?: Partial<Options<IngestionApiImportsApproveImportData>>): UseMutationOptions<IngestionApiImportsApproveImportResponse, IngestionApiImportsApproveImportError, Options<IngestionApiImportsApproveImportData>> => {
    const mutationOptions: UseMutationOptions<IngestionApiImportsApproveImportResponse, IngestionApiImportsApproveImportError, Options<IngestionApiImportsApproveImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ingestionApiImportsApproveImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ingestionApiImportsGetImportQueryKey = (options: Options<IngestionApiImportsGetImportData>) => createQueryKey('ingestionApiImportsGetImport', options);

/**
 * Get Import
 */
export const ingestionApiImportsGetImportOptions = (options: Options<IngestionApiImportsGetImportData>) => queryOptions<IngestionApiImportsGetImportResponse, DefaultError, IngestionApiImportsGetImportResponse, ReturnType<typeof ingestionApiImportsGetImportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ingestionApiImportsGetImport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ingestionApiImportsGetImportQueryKey(options)
});

export const ingestionApiImportsListImportErrorsQueryKey = (options: Options<IngestionApiImportsListImportErrorsData>) => createQueryKey('ingestionApiImportsListImportErrors', options);

/**
 * List Import Errors
 */
export const ingestionApiImportsListImportErrorsOptions = (options: Options<IngestionApiImportsListImportErrorsData>) => queryOptions<IngestionApiImportsListImportErrorsResponse, DefaultError, IngestionApiImportsListImportErrorsResponse, ReturnType<typeof ingestionApiImportsListImportErrorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ingestionApiImportsListImportErrors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ingestionApiImportsListImportErrorsQueryKey(options)
});

export const ingestionApiImportsListImportErrorsInfiniteQueryKey = (options: Options<IngestionApiImportsListImportErrorsData>): QueryKey<Options<IngestionApiImportsListImportErrorsData>> => createQueryKey('ingestionApiImportsListImportErrors', options, true);

/**
 * List Import Errors
 */
export const ingestionApiImportsListImportErrorsInfiniteOptions = (options: Options<IngestionApiImportsListImportErrorsData>) => infiniteQueryOptions<IngestionApiImportsListImportErrorsResponse, DefaultError, InfiniteData<IngestionApiImportsListImportErrorsResponse>, QueryKey<Options<IngestionApiImportsListImportErrorsData>>, number | Pick<QueryKey<Options<IngestionApiImportsListImportErrorsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<IngestionApiImportsListImportErrorsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await ingestionApiImportsListImportErrors({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ingestionApiImportsListImportErrorsInfiniteQueryKey(options)
});

export const ingestionApiImportsDownloadImportErrorsCsvQueryKey = (options: Options<IngestionApiImportsDownloadImportErrorsCsvData>) => createQueryKey('ingestionApiImportsDownloadImportErrorsCsv', options);

/**
 * Download Import Errors Csv
 *
 * Stream a CSV report of the run's per-row errors, or of its
 * run-level failure when it has none.
 */
export const ingestionApiImportsDownloadImportErrorsCsvOptions = (options: Options<IngestionApiImportsDownloadImportErrorsCsvData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof ingestionApiImportsDownloadImportErrorsCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ingestionApiImportsDownloadImportErrorsCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ingestionApiImportsDownloadImportErrorsCsvQueryKey(options)
});

export const ingestionApiConnectionsConnectionStatsQueryKey = (options?: Options<IngestionApiConnectionsConnectionStatsData>) => createQueryKey('ingestionApiConnectionsConnectionStats', options);

/**
 * Connection Stats
 *
 * Return aggregate connection statistics.
 */
export const ingestionApiConnectionsConnectionStatsOptions = (options?: Options<IngestionApiConnectionsConnectionStatsData>) => queryOptions<IngestionApiConnectionsConnectionStatsResponse, DefaultError, IngestionApiConnectionsConnectionStatsResponse, ReturnType<typeof ingestionApiConnectionsConnectionStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ingestionApiConnectionsConnectionStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ingestionApiConnectionsConnectionStatsQueryKey(options)
});

export const ingestionApiConnectionsListConnectionsQueryKey = (options?: Options<IngestionApiConnectionsListConnectionsData>) => createQueryKey('ingestionApiConnectionsListConnections', options);

/**
 * List Connections
 *
 * List connections with search, filtering, and pagination.
 */
export const ingestionApiConnectionsListConnectionsOptions = (options?: Options<IngestionApiConnectionsListConnectionsData>) => queryOptions<IngestionApiConnectionsListConnectionsResponse, DefaultError, IngestionApiConnectionsListConnectionsResponse, ReturnType<typeof ingestionApiConnectionsListConnectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ingestionApiConnectionsListConnections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ingestionApiConnectionsListConnectionsQueryKey(options)
});

export const ingestionApiConnectionsListConnectionsInfiniteQueryKey = (options?: Options<IngestionApiConnectionsListConnectionsData>): QueryKey<Options<IngestionApiConnectionsListConnectionsData>> => createQueryKey('ingestionApiConnectionsListConnections', options, true);

/**
 * List Connections
 *
 * List connections with search, filtering, and pagination.
 */
export const ingestionApiConnectionsListConnectionsInfiniteOptions = (options?: Options<IngestionApiConnectionsListConnectionsData>) => infiniteQueryOptions<IngestionApiConnectionsListConnectionsResponse, DefaultError, InfiniteData<IngestionApiConnectionsListConnectionsResponse>, QueryKey<Options<IngestionApiConnectionsListConnectionsData>>, number | Pick<QueryKey<Options<IngestionApiConnectionsListConnectionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<IngestionApiConnectionsListConnectionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await ingestionApiConnectionsListConnections({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ingestionApiConnectionsListConnectionsInfiniteQueryKey(options)
});

/**
 * Create Connection
 *
 * Create a new connection.
 */
export const ingestionApiConnectionsCreateConnectionMutation = (options?: Partial<Options<IngestionApiConnectionsCreateConnectionData>>): UseMutationOptions<IngestionApiConnectionsCreateConnectionResponse, IngestionApiConnectionsCreateConnectionError, Options<IngestionApiConnectionsCreateConnectionData>> => {
    const mutationOptions: UseMutationOptions<IngestionApiConnectionsCreateConnectionResponse, IngestionApiConnectionsCreateConnectionError, Options<IngestionApiConnectionsCreateConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ingestionApiConnectionsCreateConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Connection
 *
 * Delete a connection.
 */
export const ingestionApiConnectionsDeleteConnectionMutation = (options?: Partial<Options<IngestionApiConnectionsDeleteConnectionData>>): UseMutationOptions<IngestionApiConnectionsDeleteConnectionResponse, DefaultError, Options<IngestionApiConnectionsDeleteConnectionData>> => {
    const mutationOptions: UseMutationOptions<IngestionApiConnectionsDeleteConnectionResponse, DefaultError, Options<IngestionApiConnectionsDeleteConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ingestionApiConnectionsDeleteConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const ingestionApiConnectionsGetConnectionQueryKey = (options: Options<IngestionApiConnectionsGetConnectionData>) => createQueryKey('ingestionApiConnectionsGetConnection', options);

/**
 * Get Connection
 *
 * Retrieve a single connection by ID.
 */
export const ingestionApiConnectionsGetConnectionOptions = (options: Options<IngestionApiConnectionsGetConnectionData>) => queryOptions<IngestionApiConnectionsGetConnectionResponse, DefaultError, IngestionApiConnectionsGetConnectionResponse, ReturnType<typeof ingestionApiConnectionsGetConnectionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ingestionApiConnectionsGetConnection({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: ingestionApiConnectionsGetConnectionQueryKey(options)
});

/**
 * Update Connection
 *
 * Partially update a connection.
 */
export const ingestionApiConnectionsUpdateConnectionMutation = (options?: Partial<Options<IngestionApiConnectionsUpdateConnectionData>>): UseMutationOptions<IngestionApiConnectionsUpdateConnectionResponse, IngestionApiConnectionsUpdateConnectionError, Options<IngestionApiConnectionsUpdateConnectionData>> => {
    const mutationOptions: UseMutationOptions<IngestionApiConnectionsUpdateConnectionResponse, IngestionApiConnectionsUpdateConnectionError, Options<IngestionApiConnectionsUpdateConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ingestionApiConnectionsUpdateConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Test Connection
 *
 * Test a connection (placeholder).
 */
export const ingestionApiConnectionsTestConnectionMutation = (options?: Partial<Options<IngestionApiConnectionsTestConnectionData>>): UseMutationOptions<IngestionApiConnectionsTestConnectionResponse, IngestionApiConnectionsTestConnectionError, Options<IngestionApiConnectionsTestConnectionData>> => {
    const mutationOptions: UseMutationOptions<IngestionApiConnectionsTestConnectionResponse, IngestionApiConnectionsTestConnectionError, Options<IngestionApiConnectionsTestConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ingestionApiConnectionsTestConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync Connection
 *
 * Trigger a sync for a connection (placeholder).
 */
export const ingestionApiConnectionsSyncConnectionMutation = (options?: Partial<Options<IngestionApiConnectionsSyncConnectionData>>): UseMutationOptions<IngestionApiConnectionsSyncConnectionResponse, IngestionApiConnectionsSyncConnectionError, Options<IngestionApiConnectionsSyncConnectionData>> => {
    const mutationOptions: UseMutationOptions<IngestionApiConnectionsSyncConnectionResponse, IngestionApiConnectionsSyncConnectionError, Options<IngestionApiConnectionsSyncConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ingestionApiConnectionsSyncConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiMissionControlDashboardSummaryQueryKey = (options?: Options<ProjectsApiMissionControlDashboardSummaryData>) => createQueryKey('projectsApiMissionControlDashboardSummary', options);

/**
 * Dashboard Summary
 */
export const projectsApiMissionControlDashboardSummaryOptions = (options?: Options<ProjectsApiMissionControlDashboardSummaryData>) => queryOptions<ProjectsApiMissionControlDashboardSummaryResponse, DefaultError, ProjectsApiMissionControlDashboardSummaryResponse, ReturnType<typeof projectsApiMissionControlDashboardSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiMissionControlDashboardSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiMissionControlDashboardSummaryQueryKey(options)
});

export const projectsApiMissionControlListWorkOrdersQueryKey = (options?: Options<ProjectsApiMissionControlListWorkOrdersData>) => createQueryKey('projectsApiMissionControlListWorkOrders', options);

/**
 * List Work Orders
 */
export const projectsApiMissionControlListWorkOrdersOptions = (options?: Options<ProjectsApiMissionControlListWorkOrdersData>) => queryOptions<ProjectsApiMissionControlListWorkOrdersResponse, ProjectsApiMissionControlListWorkOrdersError, ProjectsApiMissionControlListWorkOrdersResponse, ReturnType<typeof projectsApiMissionControlListWorkOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiMissionControlListWorkOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiMissionControlListWorkOrdersQueryKey(options)
});

export const projectsApiMissionControlListWorkOrdersInfiniteQueryKey = (options?: Options<ProjectsApiMissionControlListWorkOrdersData>): QueryKey<Options<ProjectsApiMissionControlListWorkOrdersData>> => createQueryKey('projectsApiMissionControlListWorkOrders', options, true);

/**
 * List Work Orders
 */
export const projectsApiMissionControlListWorkOrdersInfiniteOptions = (options?: Options<ProjectsApiMissionControlListWorkOrdersData>) => infiniteQueryOptions<ProjectsApiMissionControlListWorkOrdersResponse, ProjectsApiMissionControlListWorkOrdersError, InfiniteData<ProjectsApiMissionControlListWorkOrdersResponse>, QueryKey<Options<ProjectsApiMissionControlListWorkOrdersData>>, number | Pick<QueryKey<Options<ProjectsApiMissionControlListWorkOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiMissionControlListWorkOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiMissionControlListWorkOrders({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiMissionControlListWorkOrdersInfiniteQueryKey(options)
});

export const projectsApiMissionControlListAlertsQueryKey = (options?: Options<ProjectsApiMissionControlListAlertsData>) => createQueryKey('projectsApiMissionControlListAlerts', options);

/**
 * List Alerts
 */
export const projectsApiMissionControlListAlertsOptions = (options?: Options<ProjectsApiMissionControlListAlertsData>) => queryOptions<ProjectsApiMissionControlListAlertsResponse, DefaultError, ProjectsApiMissionControlListAlertsResponse, ReturnType<typeof projectsApiMissionControlListAlertsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiMissionControlListAlerts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiMissionControlListAlertsQueryKey(options)
});

export const projectsApiMissionControlListEscalationsQueryKey = (options?: Options<ProjectsApiMissionControlListEscalationsData>) => createQueryKey('projectsApiMissionControlListEscalations', options);

/**
 * List Escalations
 */
export const projectsApiMissionControlListEscalationsOptions = (options?: Options<ProjectsApiMissionControlListEscalationsData>) => queryOptions<ProjectsApiMissionControlListEscalationsResponse, DefaultError, ProjectsApiMissionControlListEscalationsResponse, ReturnType<typeof projectsApiMissionControlListEscalationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiMissionControlListEscalations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiMissionControlListEscalationsQueryKey(options)
});

export const projectsApiMissionControlListEscalationsInfiniteQueryKey = (options?: Options<ProjectsApiMissionControlListEscalationsData>): QueryKey<Options<ProjectsApiMissionControlListEscalationsData>> => createQueryKey('projectsApiMissionControlListEscalations', options, true);

/**
 * List Escalations
 */
export const projectsApiMissionControlListEscalationsInfiniteOptions = (options?: Options<ProjectsApiMissionControlListEscalationsData>) => infiniteQueryOptions<ProjectsApiMissionControlListEscalationsResponse, DefaultError, InfiniteData<ProjectsApiMissionControlListEscalationsResponse>, QueryKey<Options<ProjectsApiMissionControlListEscalationsData>>, number | Pick<QueryKey<Options<ProjectsApiMissionControlListEscalationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiMissionControlListEscalationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiMissionControlListEscalations({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiMissionControlListEscalationsInfiniteQueryKey(options)
});

/**
 * Resolve Escalation
 */
export const projectsApiMissionControlResolveEscalationMutation = (options?: Partial<Options<ProjectsApiMissionControlResolveEscalationData>>): UseMutationOptions<ProjectsApiMissionControlResolveEscalationResponse, ProjectsApiMissionControlResolveEscalationError, Options<ProjectsApiMissionControlResolveEscalationData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiMissionControlResolveEscalationResponse, ProjectsApiMissionControlResolveEscalationError, Options<ProjectsApiMissionControlResolveEscalationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiMissionControlResolveEscalation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiNiciTrackingNiciProjectSummaryQueryKey = (options: Options<ProjectsApiNiciTrackingNiciProjectSummaryData>) => createQueryKey('projectsApiNiciTrackingNiciProjectSummary', options);

/**
 * Nici Project Summary
 */
export const projectsApiNiciTrackingNiciProjectSummaryOptions = (options: Options<ProjectsApiNiciTrackingNiciProjectSummaryData>) => queryOptions<ProjectsApiNiciTrackingNiciProjectSummaryResponse, DefaultError, ProjectsApiNiciTrackingNiciProjectSummaryResponse, ReturnType<typeof projectsApiNiciTrackingNiciProjectSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiNiciTrackingNiciProjectSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiNiciTrackingNiciProjectSummaryQueryKey(options)
});

export const projectsApiNiciTrackingListNiciStoresQueryKey = (options: Options<ProjectsApiNiciTrackingListNiciStoresData>) => createQueryKey('projectsApiNiciTrackingListNiciStores', options);

/**
 * List Nici Stores
 */
export const projectsApiNiciTrackingListNiciStoresOptions = (options: Options<ProjectsApiNiciTrackingListNiciStoresData>) => queryOptions<ProjectsApiNiciTrackingListNiciStoresResponse, ProjectsApiNiciTrackingListNiciStoresError, ProjectsApiNiciTrackingListNiciStoresResponse, ReturnType<typeof projectsApiNiciTrackingListNiciStoresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiNiciTrackingListNiciStores({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiNiciTrackingListNiciStoresQueryKey(options)
});

export const projectsApiNiciTrackingListNiciStoresInfiniteQueryKey = (options: Options<ProjectsApiNiciTrackingListNiciStoresData>): QueryKey<Options<ProjectsApiNiciTrackingListNiciStoresData>> => createQueryKey('projectsApiNiciTrackingListNiciStores', options, true);

/**
 * List Nici Stores
 */
export const projectsApiNiciTrackingListNiciStoresInfiniteOptions = (options: Options<ProjectsApiNiciTrackingListNiciStoresData>) => infiniteQueryOptions<ProjectsApiNiciTrackingListNiciStoresResponse, ProjectsApiNiciTrackingListNiciStoresError, InfiniteData<ProjectsApiNiciTrackingListNiciStoresResponse>, QueryKey<Options<ProjectsApiNiciTrackingListNiciStoresData>>, number | Pick<QueryKey<Options<ProjectsApiNiciTrackingListNiciStoresData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiNiciTrackingListNiciStoresData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiNiciTrackingListNiciStores({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiNiciTrackingListNiciStoresInfiniteQueryKey(options)
});

export const projectsApiNiciTrackingListNiciItemsQueryKey = (options: Options<ProjectsApiNiciTrackingListNiciItemsData>) => createQueryKey('projectsApiNiciTrackingListNiciItems', options);

/**
 * List Nici Items
 */
export const projectsApiNiciTrackingListNiciItemsOptions = (options: Options<ProjectsApiNiciTrackingListNiciItemsData>) => queryOptions<ProjectsApiNiciTrackingListNiciItemsResponse, ProjectsApiNiciTrackingListNiciItemsError, ProjectsApiNiciTrackingListNiciItemsResponse, ReturnType<typeof projectsApiNiciTrackingListNiciItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiNiciTrackingListNiciItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiNiciTrackingListNiciItemsQueryKey(options)
});

export const projectsApiNiciTrackingListNiciItemsInfiniteQueryKey = (options: Options<ProjectsApiNiciTrackingListNiciItemsData>): QueryKey<Options<ProjectsApiNiciTrackingListNiciItemsData>> => createQueryKey('projectsApiNiciTrackingListNiciItems', options, true);

/**
 * List Nici Items
 */
export const projectsApiNiciTrackingListNiciItemsInfiniteOptions = (options: Options<ProjectsApiNiciTrackingListNiciItemsData>) => infiniteQueryOptions<ProjectsApiNiciTrackingListNiciItemsResponse, ProjectsApiNiciTrackingListNiciItemsError, InfiniteData<ProjectsApiNiciTrackingListNiciItemsResponse>, QueryKey<Options<ProjectsApiNiciTrackingListNiciItemsData>>, number | Pick<QueryKey<Options<ProjectsApiNiciTrackingListNiciItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiNiciTrackingListNiciItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiNiciTrackingListNiciItems({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiNiciTrackingListNiciItemsInfiniteQueryKey(options)
});

export const projectsApiNiciTrackingNiciItemRolloutQueryKey = (options: Options<ProjectsApiNiciTrackingNiciItemRolloutData>) => createQueryKey('projectsApiNiciTrackingNiciItemRollout', options);

/**
 * Nici Item Rollout
 */
export const projectsApiNiciTrackingNiciItemRolloutOptions = (options: Options<ProjectsApiNiciTrackingNiciItemRolloutData>) => queryOptions<ProjectsApiNiciTrackingNiciItemRolloutResponse, ProjectsApiNiciTrackingNiciItemRolloutError, ProjectsApiNiciTrackingNiciItemRolloutResponse, ReturnType<typeof projectsApiNiciTrackingNiciItemRolloutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiNiciTrackingNiciItemRollout({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiNiciTrackingNiciItemRolloutQueryKey(options)
});

export const projectsApiNiciTrackingNiciItemRolloutInfiniteQueryKey = (options: Options<ProjectsApiNiciTrackingNiciItemRolloutData>): QueryKey<Options<ProjectsApiNiciTrackingNiciItemRolloutData>> => createQueryKey('projectsApiNiciTrackingNiciItemRollout', options, true);

/**
 * Nici Item Rollout
 */
export const projectsApiNiciTrackingNiciItemRolloutInfiniteOptions = (options: Options<ProjectsApiNiciTrackingNiciItemRolloutData>) => infiniteQueryOptions<ProjectsApiNiciTrackingNiciItemRolloutResponse, ProjectsApiNiciTrackingNiciItemRolloutError, InfiniteData<ProjectsApiNiciTrackingNiciItemRolloutResponse>, QueryKey<Options<ProjectsApiNiciTrackingNiciItemRolloutData>>, number | Pick<QueryKey<Options<ProjectsApiNiciTrackingNiciItemRolloutData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiNiciTrackingNiciItemRolloutData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiNiciTrackingNiciItemRollout({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiNiciTrackingNiciItemRolloutInfiniteQueryKey(options)
});

export const projectsApiFieldworkListAssignedStoresQueryKey = (options?: Options<ProjectsApiFieldworkListAssignedStoresData>) => createQueryKey('projectsApiFieldworkListAssignedStores', options);

/**
 * List Assigned Stores
 */
export const projectsApiFieldworkListAssignedStoresOptions = (options?: Options<ProjectsApiFieldworkListAssignedStoresData>) => queryOptions<ProjectsApiFieldworkListAssignedStoresResponse, ProjectsApiFieldworkListAssignedStoresError, ProjectsApiFieldworkListAssignedStoresResponse, ReturnType<typeof projectsApiFieldworkListAssignedStoresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiFieldworkListAssignedStores({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiFieldworkListAssignedStoresQueryKey(options)
});

export const projectsApiFieldworkListAssignedStoresInfiniteQueryKey = (options?: Options<ProjectsApiFieldworkListAssignedStoresData>): QueryKey<Options<ProjectsApiFieldworkListAssignedStoresData>> => createQueryKey('projectsApiFieldworkListAssignedStores', options, true);

/**
 * List Assigned Stores
 */
export const projectsApiFieldworkListAssignedStoresInfiniteOptions = (options?: Options<ProjectsApiFieldworkListAssignedStoresData>) => infiniteQueryOptions<ProjectsApiFieldworkListAssignedStoresResponse, ProjectsApiFieldworkListAssignedStoresError, InfiniteData<ProjectsApiFieldworkListAssignedStoresResponse>, QueryKey<Options<ProjectsApiFieldworkListAssignedStoresData>>, number | Pick<QueryKey<Options<ProjectsApiFieldworkListAssignedStoresData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiFieldworkListAssignedStoresData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiFieldworkListAssignedStores({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiFieldworkListAssignedStoresInfiniteQueryKey(options)
});

/**
 * Update Visit
 */
export const projectsApiFieldworkUpdateVisitMutation = (options?: Partial<Options<ProjectsApiFieldworkUpdateVisitData>>): UseMutationOptions<ProjectsApiFieldworkUpdateVisitResponse, ProjectsApiFieldworkUpdateVisitError, Options<ProjectsApiFieldworkUpdateVisitData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiFieldworkUpdateVisitResponse, ProjectsApiFieldworkUpdateVisitError, Options<ProjectsApiFieldworkUpdateVisitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiFieldworkUpdateVisit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiFieldworkListVisitAssignmentsQueryKey = (options?: Options<ProjectsApiFieldworkListVisitAssignmentsData>) => createQueryKey('projectsApiFieldworkListVisitAssignments', options);

/**
 * List Visit Assignments
 */
export const projectsApiFieldworkListVisitAssignmentsOptions = (options?: Options<ProjectsApiFieldworkListVisitAssignmentsData>) => queryOptions<ProjectsApiFieldworkListVisitAssignmentsResponse, ProjectsApiFieldworkListVisitAssignmentsError, ProjectsApiFieldworkListVisitAssignmentsResponse, ReturnType<typeof projectsApiFieldworkListVisitAssignmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiFieldworkListVisitAssignments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiFieldworkListVisitAssignmentsQueryKey(options)
});

export const projectsApiFieldworkListVisitAssignmentsInfiniteQueryKey = (options?: Options<ProjectsApiFieldworkListVisitAssignmentsData>): QueryKey<Options<ProjectsApiFieldworkListVisitAssignmentsData>> => createQueryKey('projectsApiFieldworkListVisitAssignments', options, true);

/**
 * List Visit Assignments
 */
export const projectsApiFieldworkListVisitAssignmentsInfiniteOptions = (options?: Options<ProjectsApiFieldworkListVisitAssignmentsData>) => infiniteQueryOptions<ProjectsApiFieldworkListVisitAssignmentsResponse, ProjectsApiFieldworkListVisitAssignmentsError, InfiniteData<ProjectsApiFieldworkListVisitAssignmentsResponse>, QueryKey<Options<ProjectsApiFieldworkListVisitAssignmentsData>>, number | Pick<QueryKey<Options<ProjectsApiFieldworkListVisitAssignmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiFieldworkListVisitAssignmentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiFieldworkListVisitAssignments({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiFieldworkListVisitAssignmentsInfiniteQueryKey(options)
});

export const projectsApiFieldworkGetVisitAssignmentQueryKey = (options: Options<ProjectsApiFieldworkGetVisitAssignmentData>) => createQueryKey('projectsApiFieldworkGetVisitAssignment', options);

/**
 * Get Visit Assignment
 */
export const projectsApiFieldworkGetVisitAssignmentOptions = (options: Options<ProjectsApiFieldworkGetVisitAssignmentData>) => queryOptions<ProjectsApiFieldworkGetVisitAssignmentResponse, ProjectsApiFieldworkGetVisitAssignmentError, ProjectsApiFieldworkGetVisitAssignmentResponse, ReturnType<typeof projectsApiFieldworkGetVisitAssignmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiFieldworkGetVisitAssignment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiFieldworkGetVisitAssignmentQueryKey(options)
});

/**
 * Update Visit Assignment
 */
export const projectsApiFieldworkUpdateVisitAssignmentMutation = (options?: Partial<Options<ProjectsApiFieldworkUpdateVisitAssignmentData>>): UseMutationOptions<ProjectsApiFieldworkUpdateVisitAssignmentResponse, ProjectsApiFieldworkUpdateVisitAssignmentError, Options<ProjectsApiFieldworkUpdateVisitAssignmentData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiFieldworkUpdateVisitAssignmentResponse, ProjectsApiFieldworkUpdateVisitAssignmentError, Options<ProjectsApiFieldworkUpdateVisitAssignmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiFieldworkUpdateVisitAssignment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiFieldworkListWorkItemsQueryKey = (options?: Options<ProjectsApiFieldworkListWorkItemsData>) => createQueryKey('projectsApiFieldworkListWorkItems', options);

/**
 * List Work Items
 */
export const projectsApiFieldworkListWorkItemsOptions = (options?: Options<ProjectsApiFieldworkListWorkItemsData>) => queryOptions<ProjectsApiFieldworkListWorkItemsResponse, ProjectsApiFieldworkListWorkItemsError, ProjectsApiFieldworkListWorkItemsResponse, ReturnType<typeof projectsApiFieldworkListWorkItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiFieldworkListWorkItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiFieldworkListWorkItemsQueryKey(options)
});

export const projectsApiFieldworkListWorkItemsInfiniteQueryKey = (options?: Options<ProjectsApiFieldworkListWorkItemsData>): QueryKey<Options<ProjectsApiFieldworkListWorkItemsData>> => createQueryKey('projectsApiFieldworkListWorkItems', options, true);

/**
 * List Work Items
 */
export const projectsApiFieldworkListWorkItemsInfiniteOptions = (options?: Options<ProjectsApiFieldworkListWorkItemsData>) => infiniteQueryOptions<ProjectsApiFieldworkListWorkItemsResponse, ProjectsApiFieldworkListWorkItemsError, InfiniteData<ProjectsApiFieldworkListWorkItemsResponse>, QueryKey<Options<ProjectsApiFieldworkListWorkItemsData>>, number | Pick<QueryKey<Options<ProjectsApiFieldworkListWorkItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiFieldworkListWorkItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiFieldworkListWorkItems({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiFieldworkListWorkItemsInfiniteQueryKey(options)
});

export const projectsApiTimesheetsListTimesheetsQueryKey = (options?: Options<ProjectsApiTimesheetsListTimesheetsData>) => createQueryKey('projectsApiTimesheetsListTimesheets', options);

/**
 * List Timesheets
 */
export const projectsApiTimesheetsListTimesheetsOptions = (options?: Options<ProjectsApiTimesheetsListTimesheetsData>) => queryOptions<ProjectsApiTimesheetsListTimesheetsResponse, ProjectsApiTimesheetsListTimesheetsError, ProjectsApiTimesheetsListTimesheetsResponse, ReturnType<typeof projectsApiTimesheetsListTimesheetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiTimesheetsListTimesheets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiTimesheetsListTimesheetsQueryKey(options)
});

export const projectsApiTimesheetsListTimesheetsInfiniteQueryKey = (options?: Options<ProjectsApiTimesheetsListTimesheetsData>): QueryKey<Options<ProjectsApiTimesheetsListTimesheetsData>> => createQueryKey('projectsApiTimesheetsListTimesheets', options, true);

/**
 * List Timesheets
 */
export const projectsApiTimesheetsListTimesheetsInfiniteOptions = (options?: Options<ProjectsApiTimesheetsListTimesheetsData>) => infiniteQueryOptions<ProjectsApiTimesheetsListTimesheetsResponse, ProjectsApiTimesheetsListTimesheetsError, InfiniteData<ProjectsApiTimesheetsListTimesheetsResponse>, QueryKey<Options<ProjectsApiTimesheetsListTimesheetsData>>, number | Pick<QueryKey<Options<ProjectsApiTimesheetsListTimesheetsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ProjectsApiTimesheetsListTimesheetsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectsApiTimesheetsListTimesheets({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiTimesheetsListTimesheetsInfiniteQueryKey(options)
});

export const projectsApiTimesheetsGetTimesheetQueryKey = (options: Options<ProjectsApiTimesheetsGetTimesheetData>) => createQueryKey('projectsApiTimesheetsGetTimesheet', options);

/**
 * Get Timesheet
 */
export const projectsApiTimesheetsGetTimesheetOptions = (options: Options<ProjectsApiTimesheetsGetTimesheetData>) => queryOptions<ProjectsApiTimesheetsGetTimesheetResponse, ProjectsApiTimesheetsGetTimesheetError, ProjectsApiTimesheetsGetTimesheetResponse, ReturnType<typeof projectsApiTimesheetsGetTimesheetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiTimesheetsGetTimesheet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiTimesheetsGetTimesheetQueryKey(options)
});

/**
 * Update Timesheet
 *
 * End-of-day submit: corrections, break answers, and the transition.
 *
 * Closing the day is a transition of this resource, not a separate
 * endpoint — the same way a check-in is a transition of an assignment.
 * With ``?dry_run=true`` the whole pipeline runs and is rolled back,
 * and violations come back as a 200 preview rather than a rejection:
 * the client cannot compute the deduction itself, so only the server
 * can answer "what happens if I submit this".
 *
 * ``dry_run`` therefore discriminates the 200 body between
 * ``WorkdayTimesheetOut`` and ``DaySubmitPreviewOut``. OpenAPI cannot
 * say that — a response schema may not depend on a query parameter —
 * so the union is documented as ``anyOf`` and this docstring carries
 * the rule.
 */
export const projectsApiTimesheetsUpdateTimesheetMutation = (options?: Partial<Options<ProjectsApiTimesheetsUpdateTimesheetData>>): UseMutationOptions<ProjectsApiTimesheetsUpdateTimesheetResponse, ProjectsApiTimesheetsUpdateTimesheetError, Options<ProjectsApiTimesheetsUpdateTimesheetData>> => {
    const mutationOptions: UseMutationOptions<ProjectsApiTimesheetsUpdateTimesheetResponse, ProjectsApiTimesheetsUpdateTimesheetError, Options<ProjectsApiTimesheetsUpdateTimesheetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsApiTimesheetsUpdateTimesheet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsApiTimesheetsGetBreakFormQueryKey = (options: Options<ProjectsApiTimesheetsGetBreakFormData>) => createQueryKey('projectsApiTimesheetsGetBreakForm', options);

/**
 * Get Break Form
 *
 * The break questions for this day, as the server defines them.
 *
 * The form is server-owned: which questions apply, and what counts as
 * a valid answer, is policy — the client renders, it does not decide.
 *
 * ``no-store`` rather than a client-side convention: the form is built
 * from *this* day's gross minutes and the policy in force on its date,
 * so a reused copy asks the wrong questions and answers them against
 * the wrong day. ``no-store`` and not ``no-cache``, which permits a
 * stored copy and only forces revalidation — there is nothing here
 * worth keeping on disk between two openings of the screen.
 */
export const projectsApiTimesheetsGetBreakFormOptions = (options: Options<ProjectsApiTimesheetsGetBreakFormData>) => queryOptions<ProjectsApiTimesheetsGetBreakFormResponse, ProjectsApiTimesheetsGetBreakFormError, ProjectsApiTimesheetsGetBreakFormResponse, ReturnType<typeof projectsApiTimesheetsGetBreakFormQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsApiTimesheetsGetBreakForm({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsApiTimesheetsGetBreakFormQueryKey(options)
});

export const supervisorApiListChatsQueryKey = (options?: Options<SupervisorApiListChatsData>) => createQueryKey('supervisorApiListChats', options);

/**
 * List Chats
 *
 * List chats: own for a user, all for an admin.
 */
export const supervisorApiListChatsOptions = (options?: Options<SupervisorApiListChatsData>) => queryOptions<SupervisorApiListChatsResponse, DefaultError, SupervisorApiListChatsResponse, ReturnType<typeof supervisorApiListChatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await supervisorApiListChats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: supervisorApiListChatsQueryKey(options)
});

export const supervisorApiListChatsInfiniteQueryKey = (options?: Options<SupervisorApiListChatsData>): QueryKey<Options<SupervisorApiListChatsData>> => createQueryKey('supervisorApiListChats', options, true);

/**
 * List Chats
 *
 * List chats: own for a user, all for an admin.
 */
export const supervisorApiListChatsInfiniteOptions = (options?: Options<SupervisorApiListChatsData>) => infiniteQueryOptions<SupervisorApiListChatsResponse, DefaultError, InfiniteData<SupervisorApiListChatsResponse>, QueryKey<Options<SupervisorApiListChatsData>>, number | Pick<QueryKey<Options<SupervisorApiListChatsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SupervisorApiListChatsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await supervisorApiListChats({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: supervisorApiListChatsInfiniteQueryKey(options)
});

/**
 * Create Chat
 *
 * Create a chat and snapshot the (owned) work context.
 */
export const supervisorApiCreateChatMutation = (options?: Partial<Options<SupervisorApiCreateChatData>>): UseMutationOptions<SupervisorApiCreateChatResponse, SupervisorApiCreateChatError, Options<SupervisorApiCreateChatData>> => {
    const mutationOptions: UseMutationOptions<SupervisorApiCreateChatResponse, SupervisorApiCreateChatError, Options<SupervisorApiCreateChatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await supervisorApiCreateChat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const supervisorApiListMessagesQueryKey = (options: Options<SupervisorApiListMessagesData>) => createQueryKey('supervisorApiListMessages', options);

/**
 * List Messages
 *
 * Full transcript. Access: author or admin (ADMIN/ANALYST_READONLY).
 */
export const supervisorApiListMessagesOptions = (options: Options<SupervisorApiListMessagesData>) => queryOptions<SupervisorApiListMessagesResponse, SupervisorApiListMessagesError, SupervisorApiListMessagesResponse, ReturnType<typeof supervisorApiListMessagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await supervisorApiListMessages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: supervisorApiListMessagesQueryKey(options)
});

export const supervisorApiListMessagesInfiniteQueryKey = (options: Options<SupervisorApiListMessagesData>): QueryKey<Options<SupervisorApiListMessagesData>> => createQueryKey('supervisorApiListMessages', options, true);

/**
 * List Messages
 *
 * Full transcript. Access: author or admin (ADMIN/ANALYST_READONLY).
 */
export const supervisorApiListMessagesInfiniteOptions = (options: Options<SupervisorApiListMessagesData>) => infiniteQueryOptions<SupervisorApiListMessagesResponse, SupervisorApiListMessagesError, InfiniteData<SupervisorApiListMessagesResponse>, QueryKey<Options<SupervisorApiListMessagesData>>, number | Pick<QueryKey<Options<SupervisorApiListMessagesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SupervisorApiListMessagesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await supervisorApiListMessages({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: supervisorApiListMessagesInfiniteQueryKey(options)
});

/**
 * Send Message
 *
 * Persist the question, then stream the answer (text/event-stream).
 *
 * Constance is read through ``aconfig`` — its async backend keeps the
 * cache-miss DB read off the event loop. The two-message create and the
 * concurrency slot stay on ``sync_to_async``: a sync ORM write would raise
 * ``SynchronousOnlyOperation`` from the loop.
 */
export const supervisorApiSendMessageMutation = (options?: Partial<Options<SupervisorApiSendMessageData>>): UseMutationOptions<unknown, SupervisorApiSendMessageError, Options<SupervisorApiSendMessageData>> => {
    const mutationOptions: UseMutationOptions<unknown, SupervisorApiSendMessageError, Options<SupervisorApiSendMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await supervisorApiSendMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
